<template>
  <div class="media-page page-ind-kpi min-h-screen w-full p-3 md:p-4">

    <!-- <section class="kpi-head-compact mb-3">
      <h2 class="text-lg font-bold">KPI Operaciones</h2>
      <p class="text-sm text-zinc-500 dark:text-zinc-400">Resumen mensual de rendimiento por canal.</p>
    </section> -->

    <!-- Toolbar -->
    <section class="ind-toolbar mb-4">
      <div class="ind-toolbar-left">
        <div class="ind-toolbar-field">
          <label class="field-label block mb-1">Mes</label>
          <input
            v-model="mes"
            type="month"
            class="ind-month-input"
            :max="mesMax"
            @input="onMesInput"
            @change="onMesChange"
            @keydown="onMesKeydown"
            @wheel.prevent
          />
        </div>

      </div>
      <div class="ind-toolbar-right">
        <div class="flex flex-col items-end gap-1.5">
          <div class="flex gap-2">
            <Button
              v-if="isAdmin"
              label="Invalidar caché"
              icon="pi pi-trash"
              :loading="invalidando"
              class="p-button-sm p-button-outlined p-button-danger"
              @click="invalidarCache"
            />
            <Button
              v-if="isAdmin && asesorSeleccionado"
              label="Invalidar caché operador"
              icon="pi pi-filter-slash"
              :loading="invalidandoOp"
              class="p-button-sm p-button-outlined p-button-warning"
              @click="invalidarCacheOperador"
            />
            <Button
              label="Actualizar"
              icon="pi pi-refresh"
              :loading="loading || refreshing"
              class="p-button-sm p-button-outlined"
              @click="actualizar"
            />
          </div>
          <div class="flex items-center h-4">
            <transition name="kpi-fade">
              <span v-if="refreshStatus === 'changed'" key="st-changed" class="kpi-refresh-badge kpi-refresh-badge-new">
                <i class="pi pi-arrow-up-right mr-1" style="font-size:0.7rem"></i>Actualizado
              </span>
              <span v-else-if="refreshStatus === 'same'" key="st-same" class="kpi-refresh-badge kpi-refresh-badge-same">
                <i class="pi pi-check mr-1" style="font-size:0.7rem"></i>Sin cambios
              </span>
              <span v-else-if="lastUpdated" key="st-time" class="kpi-last-updated">
                <i class="pi pi-clock mr-1" style="font-size:0.68rem"></i>{{ lastUpdatedLabel }}
              </span>
            </transition>
          </div>
        </div>
      </div>
    </section>

    <!-- Error -->
    <div v-if="error" class="kpi-error-box mb-5">
      <i class="pi pi-exclamation-triangle mr-2"></i>{{ error }}
    </div>

    <!-- Skeleton inicial (carga en frío) -->
    <template v-if="loading && !data">
      <div class="kpi-skel-page">
        <section class="kpi-section mb-5">
          <h3 class="kpi-section-title">
            <i class="pi pi-sync kpi-section-icon kpi-section-icon--live" style="font-size:0.92rem;color:#10b981"></i>
            Conectados
          </h3>
          <KpiSectionSkeleton variant="hero" />
          <div class="mt-3">
            <KpiSectionSkeleton variant="strip" :item-count="3" />
          </div>
        </section>
        <section class="kpi-section mb-5">
          <h3 class="kpi-section-title">
            <i class="pi pi-chart-bar" style="font-size:0.92rem;color:#3b82f6;opacity:0.85"></i>
            Global
          </h3>
          <KpiSectionSkeleton variant="hero" />
          <div class="mt-3">
            <KpiSectionSkeleton variant="strip" :item-count="3" />
          </div>
        </section>
        <section class="kpi-section mb-5">
          <h3 class="kpi-section-title" @click="toggleSeccion('global')">
            <i class="pi pi-microphone" style="font-size:0.92rem;color:#8b5cf6;opacity:0.85"></i>
            Producción · Locución + IA
          </h3>
          <KpiSectionSkeleton variant="dual-hero" />
          <div class="mt-3">
            <KpiSectionSkeleton variant="strip" :item-count="3" />
          </div>
          <div class="mt-4">
            <KpiSectionSkeleton variant="pills" :item-count="5" />
          </div>
        </section>
        <div class="text-center mt-2 mb-4">
          <span class="kpi-skel-loading-label">
            <i class="pi pi-spin pi-spinner mr-1.5" style="font-size:0.7rem"></i>
            Cargando indicadores…
          </span>
        </div>
      </div>
</template>

    <template v-else-if="data">

      <!-- Barra de progreso animada durante refresco -->
      <div class="kpi-refresh-bar mb-2" :class="{ 'kpi-refresh-bar-active': refreshing }"></div>

      <!-- Banner global mes en curso -->
      <div v-if="mes === mesMax" class="kpi-mes-en-curso-banner mb-4" style="width:fit-content;margin-left:auto;margin-right:auto">
        <i class="pi pi-clock mr-2" style="font-size:0.8rem"></i>
        Mes en curso 
      </div>

      <!-- ── Navegación rápida de secciones ── -->
      <nav class="kpi-quick-nav mb-5" aria-label="Navegación rápida">
        <button type="button" class="kpi-quick-nav-btn" data-section="conectados" @click="scrollToSection('section-conectados')">
          <i class="pi pi-sync" style="font-size:0.7rem;color:#10b981"></i>
          <span class="kpi-quick-nav-label">Conectados</span>
        </button>
        <button type="button" class="kpi-quick-nav-btn" data-section="global" @click="scrollToSection('section-global')">
          <i class="pi pi-chart-bar" style="font-size:0.7rem;color:#3b82f6"></i>
          <span class="kpi-quick-nav-label">Global</span>
        </button>
        <button type="button" class="kpi-quick-nav-btn" data-section="produccion" @click="scrollToSection('section-produccion')">
          <i class="pi pi-microphone" style="font-size:0.7rem;color:#8b5cf6"></i>
          <span class="kpi-quick-nav-label">Producción</span>
        </button>
        <button type="button" class="kpi-quick-nav-btn" data-section="musicalizacion" @click="scrollToSection('section-musicalizacion')">
          <i class="pi pi-volume-up" style="font-size:0.7rem;color:#14b8a6"></i>
          <span class="kpi-quick-nav-label">Musicalización</span>
        </button>
        <button type="button" class="kpi-quick-nav-btn" data-section="canales" @click="scrollToSection('section-indicadores')">
          <i class="pi pi-th-large" style="font-size:0.7rem;color:#f59e0b"></i>
          <span class="kpi-quick-nav-label">Canales</span>
        </button>
      </nav>

      <div class="kpi-page-content" :class="{ 'kpi-sections-refreshing': refreshing }">

      <!-- ──────── CONECTADOS ──────── -->
      <section id="section-conectados" class="kpi-section mb-5" :class="[{ 'kpi-section--filtered': asesorSeleccionado, 'kpi-section--loading': sectionLoading, 'kpi-section-collapsed': collapsed.conectados }]">
        <h3 class="kpi-section-title" @click="toggleSeccion('conectados')">
          <i class="pi pi-sync kpi-section-icon kpi-section-icon--live" style="font-size:0.92rem;color:#10b981"></i>
          Conectados
          <span v-if="sectionLoading" class="kpi-loading-dot" title="Cargando..."></span>
          <button v-if="asesorSeleccionado" type="button" class="kpi-filter-chip" @click="quitarFiltroAsesor" title="Quitar filtro de asesor">
            <i class="pi pi-filter"></i>
            <span class="kpi-filter-chip-name">{{ asesorPrimerNombre }}</span>
            <span class="kpi-filter-chip-close">&times;</span>
          </button>
          <button type="button" class="kpi-collapse-toggle" @click.stop="toggleSeccion('conectados')" :aria-label="collapsed.conectados ? 'Expandir sección' : 'Colapsar sección'">
            <i class="pi pi-chevron-up" :class="{ 'kpi-chevron-collapsed': collapsed.conectados }"></i>
          </button>
        </h3>
        <transition name="kpi-collapse">
          <div v-show="!collapsed.conectados" class="kpi-section-body">

        <!-- Hero: Conectados en tiempo real -->
        <div
          class="kpi-mus-hero kpi-stat-clickable mb-3"
          :class="conectadosAhora ? heroClass(conectadosAhora.eficiencia ?? 1, { currentMonthProgressive: true, fixed: { green: 1.0, yellow: 0.85 } }) : 'kpi-mus-hero-dimmed'"
          @click="abrirModalConectados"
        >
          <div class="kpi-mus-hero-row" style="justify-content:center">
            <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
              <span class="kpi-card-label">
                Conectados ahora
                <span v-if="conectadosAhora" class="kpi-live-dot"></span>
              </span>
              <div class="kpi-mus-hero-pct" style="font-size:2.6rem">
                {{ conectadosAhora ? conectadosAhora.total?.toLocaleString() : '—' }}
              </div>
              <span v-if="conectadosAhora" class="kpi-card-sub-muted" style="display:block;margin-top:2px" :data-tk="conectadosTicker">
                <i class="pi pi-sync mr-1" style="font-size:0.68rem"></i>{{ conectadosProximoRefresh() }}
              </span>
            </div>
          </div>
        </div>

        <!-- Strip: Promedio mensual | Total sucursales -->
        <div class="kpi-mus-strip">
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ conectados.promedio_diario.toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Promedio mensual</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ conectados.total_sucursales.toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Total sucursales</span>
          </div>
        </div>
        </div>
      </transition>
      </section>

      <!-- ───────── GLOBAL ───────── -->
      <section id="section-global" class="kpi-section mb-5" :class="[{ 'kpi-section--filtered': asesorSeleccionado, 'kpi-section--loading': sectionLoading, 'kpi-section-collapsed': collapsed.global }]">
        <div class="kpi-section-header">
          <h3 class="kpi-section-title" @click="toggleSeccion('global')" style="margin-bottom:0">
            <i class="pi pi-chart-bar" style="font-size:0.92rem;color:#3b82f6;opacity:0.85"></i>
            {{ tituloSeccionGlobal }}
            <span v-if="sectionLoading" class="kpi-loading-dot" title="Cargando..."></span>
            <button v-if="asesorSeleccionado" type="button" class="kpi-filter-chip" @click="quitarFiltroAsesor" title="Quitar filtro de asesor">
            <i class="pi pi-filter"></i>
            <span class="kpi-filter-chip-name">{{ asesorPrimerNombre }}</span>
            <span class="kpi-filter-chip-close">&times;</span>
          </button>
            <button type="button" class="kpi-collapse-toggle" @click.stop="toggleSeccion('global')" :aria-label="collapsed.global ? 'Expandir sección' : 'Colapsar sección'">
              <i class="pi pi-chevron-up" :class="{ 'kpi-chevron-collapsed': collapsed.global }"></i>
            </button>
          </h3>
        </div>
        <transition name="kpi-collapse">
          <div v-show="!collapsed.global" class="kpi-section-body">

        <!-- Hero: Eficiencia Spots -->
        <div
          class="kpi-mus-hero mb-3"
          :class="heroClass(data.global.eficiencia_spots, { currentMonthProgressive: true })"
        >
          <div class="kpi-mus-hero-row" style="justify-content:center">
            <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
              <span class="kpi-card-label">Eficiencia Spots</span>
              <div class="kpi-mus-hero-pct">{{ formatPct(data.global.eficiencia_spots) }}</div>
              <span class="kpi-card-sub">
                Meta: {{ (data.global.spots_capeados ?? 0).toLocaleString() }}/{{ data.global.meta_spots.toLocaleString() }}
                &nbsp;({{ produccionLocucion.meta.toLocaleString() }} loc. · {{ data.global.meta_ia.toLocaleString() }} IA)
              </span>
              <span class="kpi-card-sub">
                Real: {{ data.global.spots_logrados.toLocaleString() }}
              </span>

            </div>
          </div>
          <KpiProgressBar
              :value="data.global.eficiencia_spots"
              :show-target="isMesEnCurso"
              :target="avanceMes"
              :meta="data.global.meta_spots"
              :achieved="data.global.spots_capeados ?? data.global.spots_logrados"
              :bar-class="heroClass(data.global.eficiencia_spots, { currentMonthProgressive: true })"
            />
        </div>

        <!-- Capacidad Instalada (solo visible sin filtro de asesor) -->
        <div v-if="!asesorSeleccionado" class="kpi-mus-strip mb-3">
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val kpi-mus-val-neutral">
              {{ (data.global?.spots_logrados || 0).toLocaleString() }} / {{ (data.capacidad_instalada || 1000).toLocaleString() }}
            </span>
            <span class="kpi-mus-stat-label">
              Capacidad Instalada
              <span style="opacity:0.75;font-weight:600;">· {{ data.uso_capacidad || 0 }}%</span>
            </span>
            <div class="kpi-mus-stat-bar">
              <div class="kpi-mus-stat-bar-fill" :style="{ width: (data.uso_capacidad || 0) + '%' }" :class="capacidadBarClass"></div>
            </div>
            <button v-if="isAdmin" class="kpi-capacidad-edit-btn" @click="abrirEditorCapacidad">
              <i class="pi pi-pencil"></i> Editar
            </button>
          </div>
        </div>

        <!-- Producción Desglosada -->
        <div class="kpi-desglosada-toggle mb-2">
          <button
            class="text-sm text-blue-600 dark:text-blue-400 underline underline-offset-2 hover:text-blue-800"
            @click="toggleDesglosada"
          >
            <i class="pi pi-table mr-1"></i>
            {{ desglosadaVisible ? 'Ocultar' : 'Ver' }} producción desglosada
          </button>
        </div>
        <template v-if="desglosadaVisible && produccionDesglosada">
          <div class="kpi-desglosada-table mb-3">
            <DataTable
              :value="produccionDesglosadaAgrupaciones"
              responsiveLayout="scroll"
              stripedRows
              class="text-sm kpi-spots-table"
              selectionMode="single"
              @row-click="abrirDesgloseDetalle"
              dataKey="nombre"
            >
              <Column field="nombre" header="Agrupación" sortable style="min-width:100px">
                <template #body="{ data }">
                  <span class="kpi-desglose-link truncate block" :title="data.nombre">{{ data.nombre }}</span>
                </template>
              </Column>
              <Column field="canales" header="Canales" sortable style="width:72px">
                <template #body="{ data }">
                  <span class="font-medium text-zinc-600 dark:text-zinc-300">{{ data.canales }}</span>
                </template>
              </Column>
              <Column field="spots_locucion" header="Spots" sortable style="min-width:150px">
                <template #body="{ data }">
                  <DesgloseCell :prod="data.spots_locucion || 0" :meta="data.meta_spots || 0" type="spots" />
                </template>
              </Column>
              <Column field="spots_ia" header="Spots IA" sortable style="min-width:150px">
                <template #body="{ data }">
                  <DesgloseCell :prod="data.spots_ia || 0" :meta="data.meta_ia || 0" type="ia" />
                </template>
              </Column>
            </DataTable>
          </div>
        </template>

        <!-- Strip: Llamadas | Minutas | Genéricos Temporada -->
        <div class="kpi-mus-strip kpi-mus-strip--contacto">
          <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirContactosDetalle" title="Ver detalle de llamadas">
            <span
              class="kpi-mus-stat-val"
              :class="contactoLlamadasRatio >= 0.8 ? 'kpi-mus-val-green' : contactoLlamadasRatio >= 0.5 ? 'kpi-mus-val-yellow' : 'kpi-mus-val-red'"
            >{{ canalesConLlamadas }}/{{ data.global.canales_requieren_contacto || data.global.canales_en_global }}</span>
            <span class="kpi-mus-stat-label">Llamadas</span>
            <div class="kpi-mus-stat-bar">
              <div class="kpi-mus-stat-bar-fill" :style="{ width: (contactoLlamadasRatio * 100) + '%' }" :class="contactoLlamadasRatio >= 0.8 ? 'kpi-bar-green' : contactoLlamadasRatio >= 0.5 ? 'kpi-bar-yellow' : 'kpi-bar-red'"></div>
            </div>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirContactosDetalle" title="Ver detalle de minutas">
            <span
              class="kpi-mus-stat-val"
              :class="contactoMinutasRatio >= 0.8 ? 'kpi-mus-val-green' : contactoMinutasRatio >= 0.5 ? 'kpi-mus-val-yellow' : 'kpi-mus-val-red'"
            >{{ canalesConMinutas }}/{{ data.global.canales_requieren_contacto || data.global.canales_en_global }}</span>
            <span class="kpi-mus-stat-label">Minutas</span>
            <div class="kpi-mus-stat-bar">
              <div class="kpi-mus-stat-bar-fill" :style="{ width: (contactoMinutasRatio * 100) + '%' }" :class="contactoMinutasRatio >= 0.8 ? 'kpi-bar-green' : contactoMinutasRatio >= 0.5 ? 'kpi-bar-yellow' : 'kpi-bar-red'"></div>
            </div>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirTemporadaDetalle" title="Ver detalle de genéricos de temporada">
            <span
              class="kpi-mus-stat-val"
              :class="temporada.cumplida ? 'kpi-mus-val-green' : temporada.producidos >= temporada.meta * 0.7 ? 'kpi-mus-val-yellow' : 'kpi-mus-val-red'"
            >{{ temporada.producidos }}/{{ temporada.meta }}</span>
            <span class="kpi-mus-stat-label">Genéricos Temporada</span>
            <span class="kpi-mus-stat-sub">{{ temporada.cumplida ? 'Cumplida ✓' : 'Pendiente' }} · {{ formatPct(temporada.eficiencia) }}</span>
          </div>
        </div>

        <div v-if="spotsFueraMeta.total > 0" class="kpi-out-meta-row" aria-label="Spots fuera de meta">
          <span class="kpi-out-meta-label">
            <i class="pi pi-info-circle"></i>
            Adicionales
          </span>
          <div class="kpi-out-meta-items">
            <span class="kpi-out-meta-chip">
              <span class="kpi-out-meta-chip-name">Liner</span>
              <span class="kpi-out-meta-chip-value">{{ spotsFueraMeta.liner.toLocaleString() }}</span>
            </span>
            <span class="kpi-out-meta-chip">
              <span class="kpi-out-meta-chip-name">Sello</span>
              <span class="kpi-out-meta-chip-value">{{ spotsFueraMeta.sello.toLocaleString() }}</span>
            </span>
          </div>
          <span class="kpi-out-meta-total">Total: {{ spotsFueraMeta.total.toLocaleString() }}</span>
        </div>
        </div>
      </transition>
      </section>

      <section id="section-produccion" class="kpi-section mb-5" :class="[{ 'kpi-section--filtered': asesorSeleccionado, 'kpi-section--loading': sectionLoading, 'kpi-section-collapsed': collapsed.produccion }]">
        <h3 class="kpi-section-title" @click="toggleSeccion('produccion')">
          <i class="pi pi-microphone" style="font-size:0.92rem;color:#8b5cf6;opacity:0.85"></i>
          Producción · Locución + IA
          <span v-if="sectionLoading" class="kpi-loading-dot" title="Cargando..."></span>
          <button v-if="asesorSeleccionado" type="button" class="kpi-filter-chip" @click="quitarFiltroAsesor" title="Quitar filtro de asesor">
            <i class="pi pi-filter"></i>
            <span class="kpi-filter-chip-name">{{ asesorPrimerNombre }}</span>
            <span class="kpi-filter-chip-close">&times;</span>
          </button>
          <button type="button" class="kpi-collapse-toggle" @click.stop="toggleSeccion('produccion')" :aria-label="collapsed.produccion ? 'Expandir sección' : 'Colapsar sección'">
            <i class="pi pi-chevron-up" :class="{ 'kpi-chevron-collapsed': collapsed.produccion }"></i>
          </button>
        </h3>
        <transition name="kpi-collapse">
          <div v-show="!collapsed.produccion" class="kpi-section-body">

        <!-- Dual Hero: Locución + IA -->
        <div class="kpi-dual-hero mb-3">
          <div class="kpi-mus-hero" :class="heroClass(produccionLocucion.eficiencia, { currentMonthProgressive: true })">
            <div class="kpi-mus-hero-row" style="justify-content:center">
              <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
                <span class="kpi-card-label">Locución</span>
                <div class="kpi-mus-hero-pct">{{ formatPct(produccionLocucion.eficiencia) }}</div>
                <span class="kpi-card-sub">
                  Meta: {{ produccionLocucion.spots_topados.toLocaleString() }}/{{ produccionLocucion.meta.toLocaleString() }} 
                  &nbsp;·&nbsp;                  Real: {{ produccionLocucion.spots_logrados.toLocaleString() }}
                </span>

              </div>
            </div>
            <KpiProgressBar
              :value="produccionLocucion.eficiencia"
              :show-target="isMesEnCurso"
              :target="avanceMes"
              :meta="produccionLocucion.meta"
              :achieved="produccionLocucion.spots_topados"
              :bar-class="heroClass(produccionLocucion.eficiencia, { currentMonthProgressive: true })"
            />
          </div>
          <div class="kpi-mus-hero" :class="heroClass(data.global.eficiencia_ia, { currentMonthProgressive: true })">
            <div class="kpi-mus-hero-row" style="justify-content:center">
              <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
                <span class="kpi-card-label">IA</span>
                <div class="kpi-mus-hero-pct">{{ formatPct(data.global.eficiencia_ia) }}</div>
                <span class="kpi-card-sub">
                  Meta: {{ (data.global.spots_ia_capeados ?? 0).toLocaleString() }}/{{ data.global.meta_ia.toLocaleString() }} 
                  &nbsp;·&nbsp;                  Real: {{ data.global.spots_ia_logrados.toLocaleString() }}
                </span>

              </div>
            </div>
            <KpiProgressBar
              :value="data.global.eficiencia_ia"
              :show-target="isMesEnCurso"
              :target="avanceMes"
              :meta="data.global.meta_ia"
              :achieved="data.global.spots_ia_capeados ?? data.global.spots_ia_logrados"
              :bar-class="heroClass(data.global.eficiencia_ia, { currentMonthProgressive: true })"
            />
          </div>
        </div>

        <!-- Strip: Spots Locución | Spots IA | Productores (sin productores si hay filtro) -->
        <div class="kpi-mus-strip mb-4">
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ produccionLocucion.spots_logrados.toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Spots Locución</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ data.global.spots_ia_logrados.toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Spots IA</span>
          </div>
          <template>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat">
              <span class="kpi-mus-stat-val">{{ productorPersonas.length }}</span>
              <span class="kpi-mus-stat-label">Productores</span>
              <span class="kpi-mus-stat-sub">Con actividad</span>
            </div>
          </template>
        </div>

        <!-- Totales: productores vs real -->
        <div v-if="productorPersonas.length" class="mb-3 text-xs text-zinc-500 dark:text-zinc-400 text-center">
          Spots con productor asignado: <strong>{{ productorSpotsTotal.toLocaleString() }}</strong>
          &nbsp;·&nbsp;
          Sin asignar: <strong>{{ (data.global.spots_logrados - productorSpotsTotal).toLocaleString() }}</strong>
          <span class="text-zinc-400 dark:text-zinc-500"> (spots sin aprobación aún)</span>
        </div>

        <!-- Productores: pills compactos -->
          <div v-if="productorPersonas.length" class="mb-4">
            <p class="text-xs font-semibold uppercase tracking-wider text-zinc-400 dark:text-zinc-500 mb-2">Spots por productor (locución + IA)</p>
            <div class="kpi-persona-pills">
              <div v-for="p in productorPersonas" :key="p.user_id" class="kpi-persona-pill">
                <span class="kpi-persona-name">{{ p.user_name }}</span>
                <span class="kpi-persona-count">{{ p.spots_logrados.toLocaleString() }}</span>
                <span class="kpi-persona-pct">{{ formatPct(p.participacion) }}</span>
              </div>
            </div>
          </div>
          <p v-else-if="!loading" class="text-xs text-zinc-400 dark:text-zinc-500 italic mb-4">Sin datos de productores para este mes.</p>


        <!-- Tabla desglose completo -->
        <div v-if="desgloseCompleto.length">
          <div class="kpi-expand-actions">
            <div class="kpi-expand-actions-main">
              <button
                class="text-sm text-blue-600 dark:text-blue-400 underline underline-offset-2 hover:text-blue-800 dark:hover:text-blue-300"
                @click="desgloseExpandido = !desgloseExpandido"
              >
                {{ desgloseExpandido ? 'Ocultar tabla' : 'Ver tabla de locutores' }}
              </button>
              <span v-if="loadingPersonas" class="text-xs text-zinc-400 dark:text-zinc-500">Cargando locutores...</span>
            </div>
            <div v-if="desgloseExpandido" class="kpi-expand-actions-options">
              <button
                v-for="rol in ['Locutor', 'IA', 'Productor']"
                :key="rol"
                @click="rolesVisibles.includes(rol) ? rolesVisibles.splice(rolesVisibles.indexOf(rol), 1) : rolesVisibles.push(rol)"
                class="text-xs font-semibold px-2.5 py-0.5 rounded-full border transition-opacity"
                :class="{
                  'bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-900/40 dark:text-sky-300 dark:border-sky-800': rol === 'Locutor' && rolesVisibles.includes(rol),
                  'bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-900/40 dark:text-violet-300 dark:border-violet-800': rol === 'IA' && rolesVisibles.includes(rol),
                  'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-800': rol === 'Productor' && rolesVisibles.includes(rol),
                  'bg-zinc-100 text-zinc-400 border-zinc-200 dark:bg-zinc-800 dark:text-zinc-500 dark:border-zinc-700 opacity-50': !rolesVisibles.includes(rol),
                }"
              >{{ rol }}</button>
            </div>
          </div>
          <DataTable
            v-if="desgloseExpandido"
            :value="desgloseVisible"
            responsiveLayout="scroll"
            stripedRows
            class="text-sm mt-3"
          >
            <Column field="tipo" header="Rol" style="width:100px">
              <template #body="{ data: row }">
                <span
                  class="text-xs font-semibold px-2 py-0.5 rounded-full"
                  :class="{
                    'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300': row.tipo === 'IA',
                    'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300': row.tipo === 'Locutor',
                    'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300': row.tipo === 'Productor',
                  }"
                >{{ row.tipo }}</span>
              </template>
            </Column>
            <Column field="nombre" header="Nombre" style="min-width:200px" />
            <Column field="spots_logrados" header="Spots" sortable style="width:80px" />
            <Column field="participacion" header="Part. grupo" sortable style="width:110px">
              <template #body="{ data: row }">{{ formatPct(row.participacion) }}</template>
            </Column>
          </DataTable>
        </div>
        </div>
      </transition>
      </section>

      <section id="section-musicalizacion" class="kpi-section mb-5" :class="[{ 'kpi-section--filtered': asesorSeleccionado, 'kpi-section--loading': sectionLoading && !loadingMus, 'kpi-section-collapsed': collapsed.musicalizacion }]">
        <h3 class="kpi-section-title" @click="toggleSeccion('musicalizacion')">
          <i class="pi pi-volume-up" style="font-size:0.92rem;color:#14b8a6;opacity:0.85"></i>
          Musicalización
          <span v-if="sectionLoading && !loadingMus" class="kpi-loading-dot" title="Cargando..."></span>
          <button v-if="asesorSeleccionado" type="button" class="kpi-filter-chip" @click="quitarFiltroAsesor" title="Quitar filtro de asesor">
            <i class="pi pi-filter"></i>
            <span class="kpi-filter-chip-name">{{ asesorPrimerNombre }}</span>
            <span class="kpi-filter-chip-close">&times;</span>
          </button>
          <button type="button" class="kpi-collapse-toggle" @click.stop="toggleSeccion('musicalizacion')" :aria-label="collapsed.musicalizacion ? 'Expandir sección' : 'Colapsar sección'">
            <i class="pi pi-chevron-up" :class="{ 'kpi-chevron-collapsed': collapsed.musicalizacion }"></i>
          </button>
        </h3>
        <transition name="kpi-collapse">
          <div v-show="!collapsed.musicalizacion" class="kpi-section-body">

        <transition name="kpi-fade" mode="out-in">

          <!-- Cargando -->
          <div v-if="loadingMus" key="mus-loading" class="mus-skeleton-group">
            <KpiSectionSkeleton variant="hero" />
            <KpiSectionSkeleton variant="strip" :item-count="5" />
            <KpiSectionSkeleton variant="tops" :item-count="2" />
            <div class="text-center mt-3">
              <span class="kpi-skel-loading-label"><i class="pi pi-spin pi-spinner mr-1.5" style="font-size:0.7rem"></i>Cargando musicalización...</span>
            </div>
          </div>

          <!-- Error -->
          <p v-else-if="errorMus" key="mus-error" class="text-xs text-red-400 py-2">{{ errorMus }}</p>

          <!-- Contenido (mes cerrado o en curso) -->
          <div v-else-if="musKpi" :key="'mus-' + musKpi.source">

          <!-- ── MES CERRADO ── -->
          <div v-if="musKpi.source === 'month_stats'">

          <!-- Hero KPI: cumplimiento canales -->
          <div
            class="kpi-mus-hero kpi-stat-clickable mb-3"
            :class="musKpi.global.pct_canales >= 0.8 ? 'kpi-mus-hero-green' : musKpi.global.pct_canales >= 0.5 ? 'kpi-mus-hero-yellow' : 'kpi-mus-hero-red'"
            @click="abrirCanalesActualizadosDetalle" title="Ver detalle"
          >
            <div class="kpi-mus-hero-row" style="justify-content:center">
              <div class="kpi-mus-hero-left w-full flex flex-col items-center text-center">
                <span class="kpi-card-label">Cumplimiento canales</span>
                <div class="kpi-mus-hero-pct">
                  {{ musKpi.global.canales_con_cumplimiento != null ? musKpi.global.canales_con_cumplimiento : '—' }}/{{ musKpi.global.canales_total != null ? musKpi.global.canales_total : '—' }}
                </div>
                <span class="kpi-card-sub">≥1 playlist con ≥5 cambios</span>

              </div>
            </div>
            <KpiProgressBar
              :value="musKpi.global.pct_canales"
              :show-target="false"
              :meta="musKpi.global.canales_total"
              :achieved="musKpi.global.canales_con_cumplimiento"
              :bar-class="musKpi.global.pct_canales >= 0.8 ? 'kpi-mus-hero-green' : musKpi.global.pct_canales >= 0.5 ? 'kpi-mus-hero-yellow' : 'kpi-mus-hero-red'"
            />
          </div>

          <!-- Strip secundario: 5 métricas en fila -->
          <div class="kpi-mus-strip mb-3">
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirPlaylistsDetalle" title="Ver detalle de playlists">
              <span class="kpi-mus-stat-val">{{ musKpi.global.playlists_actualizadas ?? '—' }}<span class="kpi-mus-stat-sep">/</span>{{ musKpi.global.playlists_en_uso?.toLocaleString() || '—' }}</span>
              <span class="kpi-mus-stat-label">Playlists actualizadas</span>
              </div>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirPlaylistsNuevas" title="Ver detalle">
              <span class="kpi-mus-stat-val kpi-mus-val-green">+{{ musKpi.global.playlists_nuevas ?? 0 }}</span>
              <span class="kpi-mus-stat-label">Playlists nuevas</span>
              </div>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat">
              <span
                class="kpi-mus-stat-val"
                :class="musKpi.global.clocks_updated > 0 ? 'kpi-mus-val-yellow' : ''"
              >{{ musKpi.global.clocks_updated != null ? musKpi.global.clocks_updated : '—' }}/{{ musKpi.global.clocks_total != null ? musKpi.global.clocks_total : '—' }}</span>
            <span class="kpi-mus-stat-label">Fórmulas editadas</span>
            <span class="kpi-mus-stat-sub">Marcas musicales</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ musKpi.global.total_canciones?.toLocaleString() || '—' }}</span>
            <span class="kpi-mus-stat-label">Canciones en servidor</span>
          </div>
        </div>

          <!-- TOPs visibles (mes cerrado) -->
          <div v-if="musKpi && musKpi.global && musKpi.global.tops_total !== undefined" class="mb-3">
            <div class="kpi-tops-head">
              <div class="kpi-tops-head-left">
                <span class="kpi-tops-title">Actualizaciones Top 50</span>
              </div>
            </div>

            <span v-if="musKpi.global.tops_total <= 0" class="text-xs text-zinc-400 dark:text-zinc-500 italic">No hay TOP 50 configurados este mes.</span>
            <div v-else-if="musKpi.tops_list && musKpi.tops_list.length" class="kpi-tops-list mt-2">
              <template v-for="(t, i) in musKpi.tops_list" :key="i">
                <div class="kpi-top-row" :class="topRowClass(t)" @click="abrirTopDetalle(t)" :title="'Ver detalle de ' + t.name">
                  <i :class="topStatusIconClass(t)" style="font-size:0.9rem"></i>
                  <div class="kpi-top-content">
                    <span class="kpi-top-name" :title="t.name">{{ t.name }}</span>
                    <span class="kpi-top-meta">
                      {{ topUpdateLabel(t) }}
                      <span v-if="topChangeHint(t)" class="kpi-top-hint">{{ topChangeHint(t) }}</span>
                    </span>
                  </div>
                </div>
                <div v-if="!t.actualizada && i === musKpi.tops_list.findIndex(x => !x.actualizada) && i !== 0" class="kpi-top-divider"></div>
              </template>
            </div>
          </div>

          <!-- Detalle por canal -->
          <div v-if="musKpi.canales && musKpi.canales.length">
            <div class="kpi-expand-actions">
              <div class="kpi-expand-actions-main">
                <button
                  class="kpi-mus-detail-link"
                  @click="musExpandido = !musExpandido"
                >
                  {{ musExpandido ? 'Ocultar detalle por canal' : 'Ver detalle por canal' }}
                </button>
              </div>
              <div v-if="musExpandido" class="kpi-expand-actions-options kpi-inline-controls">
                <div class="kpi-inline-controls-search">
                  <i class="pi pi-search kpi-search-icon"></i>
                  <InputText
                    v-model="musFiltroTexto"
                    placeholder="Buscar canal..."
                    class="kpi-table-search kpi-table-search-with-icon"
                  />
                </div>
                <div class="kpi-inline-controls-filters">
                  <button
                    class="kpi-type-chip"
                    :class="{ 'is-active': mostrarTodosCanalesMus }"
                    @click="mostrarTodosCanalesMus = !mostrarTodosCanalesMus"
                  >
                    <span>{{ mostrarTodosCanalesMus ? 'Ocultar no actualizados' : 'Mostrar solo no actualizados' }}</span>
                  </button>
                </div>
              </div>
            </div>
            <DataTable
              v-if="musExpandido"
              :value="musCanalesDetalle"
              responsiveLayout="scroll"
              stripedRows
              class="text-sm mt-3 kpi-spots-table kpi-mus-canales-table"
            >
              <Column field="radio_name" header="Canal" style="min-width:200px">
                <template #body="{ data: row }">
                  <span class="font-semibold text-zinc-700 dark:text-zinc-200 kpi-canal-row-click" @click="abrirCanalDetalle(row)">{{ row.radio_name }}</span>
                </template>
              </Column>
              <Column field="cumplimiento" header="Cumple" style="width:80px">
                <template #body="{ data: row }">
                  <span :class="row.cumplimiento ? 'text-green-600 dark:text-green-400 font-semibold' : 'text-zinc-400 dark:text-zinc-500'">
                    {{ row.cumplimiento ? '✓' : '✗' }}
                  </span>
                </template>
              </Column>
              <Column header="Playlists" style="width:120px">
                <template #body="{ data: row }">
                  <span class="font-semibold kpi-canal-row-click" @click="abrirCanalDetalle(row)">{{ row.playlists_actualizadas }}</span>
                  <span class="text-zinc-400 text-xs">/{{ row.playlists_total }}</span>
                </template>
              </Column>
              <Column field="last_update_at" header="Actualización" style="min-width:130px">
                <template #body="{ data: row }">
                  <span class="text-xs text-zinc-600 dark:text-zinc-300">
                    {{ formatDateOnly(row.last_update_at) || 'Sin fecha' }}
                  </span>
                </template>
              </Column>
            </DataTable>

          </div>
          </div>

          <!-- ── MES EN CURSO ── -->
          <div v-else-if="musKpi.source === 'live' || musKpi.source === 'live_proxy'">

          <!-- Hero KPI: Canales actualizados (mes en curso) -->
          <div
            class="kpi-mus-hero kpi-stat-clickable mb-3"
            :class="heroClass(musKpi.global.pct_canales, { currentMonthProgressive: true, fixed: { green: 0.7, yellow: 0.4 } })"
            @click="abrirCanalesActualizadosDetalle" title="Ver detalle"
          >
            <div class="kpi-mus-hero-row" style="justify-content:center">
              <div class="kpi-mus-hero-left w-full flex flex-col items-center text-center">
                <span class="kpi-card-label">Canales actualizados</span>
                <div class="kpi-mus-hero-pct">
                  {{ musKpi.global.canales_con_cumplimiento != null ? musKpi.global.canales_con_cumplimiento : '—' }}/{{ musKpi.global.canales_total != null ? musKpi.global.canales_total : '—' }}
                </div>
                <span class="kpi-card-sub">≥1 playlist con ≥5 cambios</span>
              </div>
            </div>
            <KpiProgressBar
              :value="musKpi.global.pct_canales"
              :show-target="isMesEnCurso"
              :target="avanceMes"
              :meta="musKpi.global.canales_total"
              :achieved="musKpi.global.canales_con_cumplimiento"
              :bar-class="heroClass(musKpi.global.pct_canales, { currentMonthProgressive: true, fixed: { green: 0.7, yellow: 0.4 } })"
            />
          </div>

          <!-- Strip secundario -->
          <div class="kpi-mus-strip mb-3">
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirPlaylistsDetalle" title="Ver detalle de playlists">
              <span class="kpi-mus-stat-val">{{ musKpi.global.playlists_actualizadas ?? '—' }}<span class="kpi-mus-stat-sep">/</span>{{ musKpi.global.playlists_en_uso?.toLocaleString() || '—' }}</span>
              <span class="kpi-mus-stat-label">Playlists actualizadas</span>
              </div>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirPlaylistsNuevas" title="Ver detalle">
              <span class="kpi-mus-stat-val kpi-mus-val-green">+{{ musKpi.global.playlists_nuevas ?? 0 }}</span>
              <span class="kpi-mus-stat-label">Playlists nuevas</span>
              </div>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirCancionesMes" title="Ver detalle">
              <span class="kpi-mus-stat-val">
                <span class="text-green-600 dark:text-green-400">+{{ (musKpi.global.canciones_agregadas || 0).toLocaleString() }}</span>
                <span class="text-zinc-400 mx-1">/</span>
                <span class="text-red-500">-{{ (musKpi.global.canciones_eliminadas || 0).toLocaleString() }}</span>
              </span>
            <span class="kpi-mus-stat-label">Canciones del mes</span>
            <span class="kpi-mus-stat-sub">Agregadas / eliminadas</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val">{{ musKpi.global.total_canciones?.toLocaleString() || '—' }}</span>
            <span class="kpi-mus-stat-label">Canciones en servidor</span>
          </div>
        </div>

          <!-- TOPs visibles (mes en curso) -->
          <div v-if="musKpi.global && musKpi.global.tops_total !== undefined" class="mb-3">
            <div class="kpi-tops-head">
              <div class="kpi-tops-head-left">
                <span class="kpi-tops-title">Actualizaciones Top 50</span>
              </div>
            </div>

            <span v-if="!musKpi.tops_list || !musKpi.tops_list.length" class="text-xs text-zinc-400 dark:text-zinc-500 italic">No hay TOP 50 configurados este mes.</span>
            <div v-else class="kpi-tops-list mt-2">
              <div v-for="(t, i) in musKpi.tops_list" :key="i" class="kpi-top-row" :class="topRowClass(t)" @click="abrirTopDetalle(t)" :title="'Ver detalle de ' + t.name">
                <i :class="topStatusIconClass(t)" style="font-size:0.9rem"></i>
                <div class="kpi-top-content">
                  <span class="kpi-top-name" :title="t.name">{{ t.name }}</span>
                  <span class="kpi-top-meta">
                    {{ topUpdateLabel(t) }}
                    <span v-if="topChangeHint(t)" class="kpi-top-hint">{{ topChangeHint(t) }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla colapsable por canal -->
          <div v-if="musKpi.canales && musKpi.canales.length">
            <div class="kpi-expand-actions">
              <div class="kpi-expand-actions-main">
                <button
                  class="kpi-mus-detail-link"
                  @click="musExpandido = !musExpandido"
                >
                  {{ musExpandido ? 'Ocultar detalle por canal' : 'Ver detalle por canal' }}
                </button>
              </div>
              <div v-if="musExpandido" class="kpi-expand-actions-options kpi-inline-controls">
                <div class="kpi-inline-controls-search">
                  <i class="pi pi-search kpi-search-icon"></i>
                  <InputText
                    v-model="musFiltroTexto"
                    placeholder="Buscar canal..."
                    class="kpi-table-search kpi-table-search-with-icon"
                  />
                </div>
                <div class="kpi-inline-controls-filters">
                  <button
                    class="kpi-type-chip"
                    :class="{ 'is-active': mostrarTodosCanalesMus }"
                    @click="mostrarTodosCanalesMus = !mostrarTodosCanalesMus"
                  >
                    <span>{{ mostrarTodosCanalesMus ? 'Ocultar no actualizados' : 'Mostrar solo no actualizados' }}</span>
                  </button>
                </div>
              </div>
            </div>
            <DataTable
              v-if="musExpandido"
              :value="musCanalesDetalle"
              responsiveLayout="scroll"
              stripedRows
              class="text-sm mt-3 kpi-spots-table kpi-mus-canales-table"
            >
              <Column field="radio_name" header="Canal" style="min-width:200px">
                <template #body="{ data: row }">
                  <span class="font-semibold text-zinc-700 dark:text-zinc-200 kpi-canal-row-click" @click="abrirCanalDetalle(row)">{{ row.radio_name }}</span>
                </template>
              </Column>
              <Column field="cumplimiento" header="Cumple" style="width:80px">
                <template #body="{ data: row }">
                  <span :class="row.cumplimiento ? 'text-green-600 dark:text-green-400 font-semibold' : 'text-zinc-400 dark:text-zinc-500'">
                    {{ row.cumplimiento ? '✓' : '✗' }}
                  </span>
                </template>
              </Column>
              <Column header="Playlists" style="width:120px">
                <template #body="{ data: row }">
                  <span class="font-semibold kpi-canal-row-click" @click="abrirCanalDetalle(row)">{{ row.playlists_actualizadas }}</span>
                  <span class="text-zinc-400 text-xs">/{{ row.playlists_total }}</span>
                </template>
              </Column>
              <Column field="last_update_at" header="Actualización" style="min-width:130px">
                <template #body="{ data: row }">
                  <span class="text-xs text-zinc-600 dark:text-zinc-300">
                    {{ formatDateOnly(row.last_update_at) || 'Sin fecha' }}
                  </span>
                </template>
              </Column>
            </DataTable>

          </div>
          </div>

          <!-- ── Video (compartido ambos branches) ── -->
          <div class="kpi-video-subsection mt-4">
            <div class="kpi-video-subsection-head">
              <i class="pi pi-video" style="font-size:0.85rem"></i>
              <span class="kpi-video-subsection-title">Video</span>
            </div>
            <div class="kpi-mus-hero kpi-video-hero kpi-stat-clickable mb-3"
              :class="heroClass(videoCanalesPct, { currentMonthProgressive: true, fixed: { green: 0.7, yellow: 0.4 } })"
              @click="abrirVideoPlaylistsDetalle" title="Ver detalle de canales con video">
              <div class="kpi-mus-hero-row" style="justify-content:center">
                <div class="kpi-mus-hero-left" style="text-align:center;width:100%">
                  <span class="kpi-card-label">Canales video actualizados</span>
                  <div class="kpi-mus-hero-pct">{{ musKpi.global.canales_con_video_actualizadas ?? 0 }}/{{ musKpi.global.canales_con_video ?? '—' }}</div>
                </div>
              </div>
              <KpiProgressBar
                :value="videoCanalesPct"
                :show-target="isMesEnCurso"
                :target="avanceMes"
                :meta="musKpi.global.canales_con_video"
                :achieved="musKpi.global.canales_con_video_actualizadas"
                :bar-class="heroClass(videoCanalesPct, { currentMonthProgressive: true, fixed: { green: 0.7, yellow: 0.4 } })"
              />
            </div>
            <div class="kpi-mus-strip">

            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirPlaylistsVideoDetalle" title="Ver detalle de playlists video">
              <span class="kpi-mus-stat-val">{{ musKpi.global.playlists_video_actualizadas ?? '—' }}<span class="kpi-mus-stat-sep">/</span>{{ musKpi.global.playlists_video_total?.toLocaleString() || '—' }}</span>
              <span class="kpi-mus-stat-label">Playlists video actualizadas</span>
              </div>
              <div class="kpi-mus-stat-divider"></div>
              <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirVideoPlaylistsNuevas" title="Ver detalle">
                <span class="kpi-mus-stat-val kpi-mus-val-green">+{{ musKpi.global.playlists_video_nuevas ?? 0 }}</span>
                <span class="kpi-mus-stat-label">Playlists video nuevas</span>
                </div>
              <template v-if="musKpi.source === 'live' || musKpi.source === 'live_proxy'">
              <div class="kpi-mus-stat-divider"></div>
              <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirVideoCancionesMes" title="Ver detalle">
                <span class="kpi-mus-stat-val">
                  <span class="text-green-600 dark:text-green-400">+{{ (musKpi.global.videos_agregadas || 0).toLocaleString() }}</span>
                  <span class="kpi-mus-stat-sep">/</span>
                  <span class="text-red-500">-{{ (musKpi.global.videos_eliminadas || 0).toLocaleString() }}</span>
                </span>
                <span class="kpi-mus-stat-label">Videos del mes</span>
                <span class="kpi-mus-stat-sub">Agregados / eliminados</span>
              </div>
              </template>
              <div class="kpi-mus-stat-divider"></div>
              <div class="kpi-mus-stat">
                <span class="kpi-mus-stat-val">{{ musKpi.global.total_videos?.toLocaleString() || '—' }}</span>
                <span class="kpi-mus-stat-label">Videos en servidor</span>
              </div>
            </div>
          </div>
        </div>

          <!-- Sin datos -->
          <p v-else key="mus-empty" class="text-xs text-zinc-400 dark:text-zinc-500 italic">
            Sin datos de musicalización para este periodo.
          </p>

        </transition>

        <!-- ── Duplicados y Errores (global, estado actual) ── -->
        <div class="kpi-dup-errores-strip mt-4">
          <div class="kpi-dup-errores-header">
            <i class="pi pi-exclamation-triangle" style="font-size:0.82rem;color:#f59e0b"></i>
            <span class="kpi-integrity-subsection-title">Integridad de la biblioteca musical</span>
            <!-- <span class="kpi-dup-errores-subtitle">Biblioteca completa · estado actual</span> -->
            <span v-if="duplicadosErroresLoading" class="kpi-loading-dot"></span>
          </div>

          <div v-if="duplicadosErroresLoading && !duplicadosErrores" class="kpi-dup-errores-loading">
            <i class="pi pi-spin pi-spinner" style="font-size:0.75rem"></i>
            <span>Verificando biblioteca…</span>
          </div>
          <div v-else-if="duplicadosErroresError" class="kpi-dup-errores-error">{{ duplicadosErroresError }}</div>
          <div v-else-if="duplicadosErrores" class="kpi-mus-strip">
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirDuplicadosErrores('duplicadas')" title="Ver detalle de canciones repetidas">
              <span class="kpi-mus-stat-val kpi-mus-val-yellow">{{ duplicadosErrores.repetidas.toLocaleString() }}</span>
              <span class="kpi-mus-stat-label">Canciones repetidas</span>
            </div>
            <div class="kpi-mus-stat-divider"></div>
            <div class="kpi-mus-stat kpi-stat-clickable" @click="abrirDuplicadosErrores('sin_tag')" title="Ver detalle de canciones sin tag">
              <span class="kpi-mus-stat-val kpi-mus-val-red">{{ duplicadosErrores.notags.toLocaleString() }}</span>
              <span class="kpi-mus-stat-label">Canciones sin tag</span>
            </div>
          </div>
        </div>

        </div>
        </transition>
      </section>

      <!-- ── Duplicados y Errores Modal ── -->
      <Dialog
        v-model:visible="showDuplicadosErroresModal"
        modal
        :style="{ width: 'min(95vw, 720px)' }"
        :dismissableMask="true"
        :draggable="false"
        :closable="true"
        header="Reporte de duplicados y errores"
        class="duplicados-errores-modal"
      >
        <div v-if="duplicadosErroresLoading" class="pdm-loading">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Cargando…</span>
        </div>
        <div v-else-if="duplicadosErrores" class="canal-detalle-body">
          <div class="cdm-summary">
            <div class="cdm-summary-stat">
              <span class="cdm-summary-stat-val text-yellow-600 dark:text-yellow-400">{{ duplicadosErrores.repetidas.toLocaleString() }}</span>
              <span class="cdm-summary-stat-label">Repetidas</span>
            </div>
            <div class="cdm-summary-divider"></div>
            <div class="cdm-summary-stat">
              <span class="cdm-summary-stat-val text-red-600 dark:text-red-400">{{ duplicadosErrores.notags.toLocaleString() }}</span>
              <span class="cdm-summary-stat-label">Sin tag</span>
            </div>
          </div>
          <div class="tops-detalle-tabs">
            <button class="tops-tab" :class="{ active: dupErrTab === 'duplicadas' }" @click="dupErrTab = 'duplicadas'">
              Duplicadas <span class="tops-tab-badge warn">{{ duplicadosErrores.repetidas }}</span>
            </button>
            <button class="tops-tab" :class="{ active: dupErrTab === 'sin_tag' }" @click="dupErrTab = 'sin_tag'">
              Sin tag <span class="tops-tab-badge removed">{{ duplicadosErrores.notags }}</span>
            </button>
          </div>
          <div class="cdm-search">
            <i class="pi pi-search cdm-search-icon"></i>
            <input v-model="dupErrSearch" type="text" class="cdm-search-input" placeholder="Buscar canción o artista…" />
          </div>
          <div class="cdm-table-wrap">
            <table class="cdm-table">
              <thead>
                <tr>
                  <th>Canción</th>
                  <th>Artista</th>
                  <th class="cdm-col-center">{{ dupErrTab === 'duplicadas' ? 'Copias' : 'Estado' }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(s, i) in dupErrFiltered" :key="i">
                  <td class="font-semibold text-zinc-700 dark:text-zinc-200">{{ s.name || '—' }}</td>
                  <td class="text-zinc-500 dark:text-zinc-400">{{ s.artist || '—' }}</td>
                  <td class="cdm-col-center">
                    <span v-if="dupErrTab === 'duplicadas'" class="dup-errores-badge dup-errores-badge--amber">{{ s.no }}</span>
                    <span v-else class="dup-errores-badge dup-errores-badge--red">Sin tag</span>
                  </td>
                </tr>
                <tr v-if="!dupErrFiltered.length">
                  <td colspan="3" class="cdm-empty">{{ dupErrSearch ? 'Sin resultados' : 'Sin datos' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Dialog>
      <section id="section-indicadores" class="kpi-section mb-5" :class="[{ 'kpi-section--filtered': asesorSeleccionado, 'kpi-section--loading': sectionLoading, 'kpi-section-collapsed': collapsed.indicadores }]">
        <div class="kpi-section-header">
          <h3 class="kpi-section-title" @click="toggleSeccion('indicadores')"><i class="pi pi-chart-bar text-xs"></i>Indicadores por canal
            <span v-if="sectionLoading" class="kpi-loading-dot" title="Cargando..."></span>
            <button v-if="asesorSeleccionado" type="button" class="kpi-filter-chip" @click="quitarFiltroAsesor" title="Quitar filtro de asesor">
            <i class="pi pi-filter"></i>
            <span class="kpi-filter-chip-name">{{ asesorPrimerNombre }}</span>
            <span class="kpi-filter-chip-close">&times;</span>
          </button>
            <button type="button" class="kpi-collapse-toggle" @click.stop="toggleSeccion('indicadores')" :aria-label="collapsed.indicadores ? 'Expandir sección' : 'Colapsar sección'">
              <i class="pi pi-chevron-up" :class="{ 'kpi-chevron-collapsed': collapsed.indicadores }"></i>
            </button>
          </h3>
        </div>

        <transition name="kpi-collapse">
          <div v-show="!collapsed.indicadores" class="kpi-section-body">
        <div class="kpi-section-actions kpi-inline-controls">
            <div class="kpi-inline-controls-search">
              <div class="kpi-inline-controls-search-input">
                <i class="pi pi-search kpi-search-icon"></i>
                <InputText
                  v-model="filtroTexto"
                  placeholder="Buscar canal o cliente..."
                  class="kpi-table-search kpi-table-search-with-icon"
                />
              </div>
              <label class="kpi-metaspots-filter" :class="{ 'is-active': soloConMetasSpots }">
                <input
                  type="checkbox"
                  v-model="soloConMetasSpots"
                />
                <span>Con metas</span>
              </label>
            </div>
            <div class="kpi-inline-controls-filters">
              <div class="kpi-type-filters" role="group" aria-label="Filtrar por tipo">
                <label class="kpi-type-chip kpi-type-chip--todos" :class="{ 'is-active': tipoFiltrosSeleccionados.includes('todos') }">
                  <input
                    type="checkbox"
                    :checked="tipoFiltrosSeleccionados.includes('todos')"
                    @change="toggleTipoFiltro('todos')"
                  />
                  <span>Todos</span>
                </label>
                <label class="kpi-type-chip kpi-type-chip--activos" :class="{ 'is-active': tipoFiltrosSeleccionados.includes('activos') }">
                  <input
                    type="checkbox"
                    :checked="tipoFiltrosSeleccionados.includes('activos')"
                    @change="toggleTipoFiltro('activos')"
                  />
                  <span>Activos</span>
                </label>
                <label class="kpi-type-chip kpi-type-chip--demos" :class="{ 'is-active': tipoFiltrosSeleccionados.includes('demos') }">
                  <input
                    type="checkbox"
                    :checked="tipoFiltrosSeleccionados.includes('demos')"
                    @change="toggleTipoFiltro('demos')"
                  />
                  <span>Demos</span>
                </label>
                <label class="kpi-type-chip kpi-type-chip--intercambio" :class="{ 'is-active': tipoFiltrosSeleccionados.includes('intercambio') }">
                  <input
                    type="checkbox"
                    :checked="tipoFiltrosSeleccionados.includes('intercambio')"
                    @change="toggleTipoFiltro('intercambio')"
                  />
                  <span>Intercambio</span>
                </label>
                <label class="kpi-type-chip kpi-type-chip--cortesia" :class="{ 'is-active': tipoFiltrosSeleccionados.includes('cortesia') }">
                  <input
                    type="checkbox"
                    :checked="tipoFiltrosSeleccionados.includes('cortesia')"
                    @change="toggleTipoFiltro('cortesia')"
                  />
                  <span>Cortesía</span>
                </label>
              </div>

            </div>
          </div>
        <div class="kpi-inline-count">
          <span>{{ canalesFiltrados.length }} canales del filtro activo</span>
        </div>

        <DataTable
          :value="canalesFiltrados"
          :loading="loading"
          responsiveLayout="scroll"
          stripedRows
          class="text-sm kpi-spots-table"
        >
          <Column field="radio_name" header="Canal / Cliente" sortable style="min-width:240px">
            <template #body="{ data: row }">
              <div class="flex items-center gap-2.5">
                <div
                  class="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center"
                  :style="logoBackgroundStyle(row)"
                >
                  <img
                    v-if="getLogoUrl(row)"
                    :src="getLogoUrl(row)"
                    :alt="row.radio_name || ''"
                    class="max-w-full max-h-full object-contain"
                    draggable="false"
                  />
                  <i v-else class="pi pi-megaphone text-white" style="font-size:0.85rem;opacity:0.5"></i>
                </div>
                <div class="flex flex-col leading-tight gap-1 min-w-0">
                  <span class="font-semibold text-zinc-700 dark:text-zinc-200 truncate">{{ row.radio_name }}</span>
                  <span v-if="row.client_name !== row.radio_name" class="text-xs text-zinc-400 dark:text-zinc-500 truncate">{{ row.client_name }}</span>
                  <span :class="row.excluido_global ? 'text-zinc-400 italic text-xs' : 'text-zinc-400 text-xs'">
                    {{ row.radio_type || '—' }}
                  </span>
                </div>
              </div>
            </template>
          </Column>
          <Column field="meta_spots" header="Meta" sortable style="width:78px">
            <template #body="{ data: row }">
              {{ row.meta_spots ?? '—' }}
            </template>
          </Column>
          <Column field="spots_locucion_logrados" header="Spots" sortable style="width:78px">
            <template #body="{ data: row }">
              <span v-if="row.spots_compartidos" class="text-zinc-400 dark:text-zinc-500 italic cursor-help" v-tooltip.top="'Comparte cuota con ' + (row.client_name || row.radio_name)">—</span>
              <span v-else>{{ row.spots_locucion_logrados ?? 0 }}</span>
            </template>
          </Column>
          <Column field="eficiencia_locucion" header="Eficiencia" sortable style="min-width:120px">
            <template #body="{ data: row }">
              <span v-if="row.spots_compartidos" class="text-zinc-400 dark:text-zinc-500 italic">—</span>
              <div v-else class="flex flex-col gap-1 leading-tight">
                <span class="kpi-pct-badge" :class="claseEficiencia(row.eficiencia_locucion)">
                  {{ formatPct(row.eficiencia_locucion) }}
                </span>
                <span class="text-xs text-zinc-400 dark:text-zinc-500" title="Eficiencia real (spots normales vs meta total)">
                  Real: {{ formatPct(row.eficiencia_locucion_real) }}
                </span>
              </div>
            </template>
          </Column>
          <Column field="obligation_ia" header="Meta IA" sortable style="width:78px">
            <template #body="{ data: row }">{{ row.obligation_ia || '—' }}</template>
          </Column>
          <Column field="spots_ia_efectivos" header="Spots IA" sortable style="width:84px">
            <template #body="{ data: row }">
              <span v-if="row.spots_compartidos" class="text-zinc-400 dark:text-zinc-500 italic">—</span>
              <span v-else>{{ row.spots_ia_efectivos ?? row.spots_ia_logrados }}</span>
            </template>
          </Column>
          <Column field="eficiencia_ia_real" header="Ef. IA" sortable style="min-width:120px">
            <template #body="{ data: row }">
              <div v-if="row.obligation_ia" class="flex flex-col gap-1 leading-tight">
                <span class="kpi-pct-badge" :class="claseEficiencia(row.eficiencia_ia)">
                  {{ formatPct(row.eficiencia_ia) }}
                </span>
                <span class="text-xs text-zinc-400 dark:text-zinc-500" title="Eficiencia IA sin capar al 100%">
                  Real: {{ formatPct(row.eficiencia_ia_real) }}
                </span>
              </div>
              <span v-else class="text-zinc-400 text-xs">—</span>
            </template>
          </Column>
          <Column field="llamadas" header="Contacto" sortable style="min-width:136px">
            <template #body="{ data: row }">
              <div class="tdm-contact-cell">
                <span v-if="(row.llamadas ?? 0) > 0 && (row.minutas ?? 0) > 0" class="tdm-contact-badge tdm-contact--completo" title="Llamada y minuta registradas">
                  <i class="pi pi-check-circle"></i> Completo
                </span>
                <span v-else-if="(row.llamadas ?? 0) > 0 && !((row.minutas ?? 0) > 0)" class="tdm-contact-badge tdm-contact--parcial" title="Llamada registrada, sin minuta">
                  <i class="pi pi-phone"></i> Pendiente
                </span>
                <span v-else-if="!((row.llamadas ?? 0) > 0) && (row.minutas ?? 0) > 0" class="tdm-contact-badge tdm-contact--parcial" title="Minuta registrada, sin llamada">
                  <i class="pi pi-file-edit"></i> Pendiente
                </span>
                <span v-else class="tdm-contact-badge tdm-contact--vacio" title="Sin contacto este mes">
                  <i class="pi pi-minus-circle"></i> Sin contacto
                </span>
              </div>
            </template>
          </Column>
        </DataTable>
        </div>
      </transition>
      </section>

      </div><!-- /kpi-sections-refreshing -->
    </template>

    <ConectadosDetalleModal
      v-model:visible="showConectadosModal"
      :conectadosAhora="conectadosAhora"
      :totalSucursalesKpi="conectados.total_sucursales"
    />

    <Dialog
      v-model:visible="showTemporadaModal"
      modal
      :style="{ width: 'min(95vw, 860px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Genéricos de Temporada"
      class="temporada-detalle-modal"
    >
      <div class="tdm-toolbar">
        <div class="tdm-search">
          <i class="pi pi-search tdm-search-icon"></i>
          <input v-model="temporadaDetalleSearch" type="text" class="tdm-search-input" placeholder="Buscar por spot o solicitud..." />
        </div>
        <span class="tdm-total">{{ temporadaDetalle.length }} spot{{ temporadaDetalle.length !== 1 ? 's' : '' }}</span>
        <button class="tdm-export-btn" @click="exportarTemporadaCSV" :disabled="!temporadaDetalle.length" title="Exportar CSV">
          <i class="pi pi-download"></i>
          <span>CSV</span>
        </button>
      </div>

      <div v-if="temporadaDetalleLoading" class="tdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando detalle...</span>
      </div>

      <div v-else-if="!temporadaDetalleFiltrados.length" class="tdm-empty">
        <i class="pi pi-info-circle"></i>
        <p>{{ temporadaDetalle.length ? 'Sin resultados para la búsqueda.' : 'No hay spots de genéricos de temporada para este mes.' }}</p>
      </div>

      <div v-else class="tdm-table-wrap">
        <table class="tdm-table">
          <thead>
            <tr>
              <th class="tdm-col-expand"></th>
              <th class="tdm-col-req">Solicitud</th>
              <th>Spot</th>
              <th class="tdm-col-status">Estado</th>
              <th class="tdm-col-date">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="s in temporadaDetalleFiltrados" :key="s.spot_id">
              <tr>
                <td class="tdm-col-expand">
                  <span v-if="s.schedule_clients" class="tdm-chevron" :class="{ expanded: expandedRowId === s.spot_id }" @click="expandedRowId = expandedRowId === s.spot_id ? null : s.spot_id">›</span>
                </td>
                <td class="tdm-col-req">
                  <span class="tdm-id-click" @click.stop="copiarAlPortapapeles('#' + s.request_id, 'req-' + s.spot_id)" title="Copiar folio">
                    #{{ s.request_id }}
                    <span v-if="copiedId === 'req-' + s.spot_id" class="tdm-copied-feedback">Copiado</span>
                  </span>
                </td>
                <td>
                  <span class="tdm-spot-name">{{ s.spot_name || 'Spot #' + s.spot_id }}</span>
                  <span class="tdm-spot-id tdm-id-click" @click.stop="copiarAlPortapapeles('#' + s.spot_id, 'spot-' + s.spot_id)" title="Copiar ID">
                    #{{ s.spot_id }}
                    <span v-if="copiedId === 'spot-' + s.spot_id" class="tdm-copied-feedback">Copiado</span>
                  </span>
                </td>
                <td class="tdm-col-status">
                  <span class="tdm-badge" :class="estadoClase(s.status_label)">{{ s.status_label }}</span>
                </td>
                <td class="tdm-col-date">{{ s.fecha || '—' }}</td>
              </tr>
              <tr v-if="expandedRowId === s.spot_id" class="tdm-expanded-row">
                <td colspan="5">
                  <div class="tdm-expanded-content">
                    <i class="pi pi-building"></i>
                    <span>Programado en:</span>
                    <span class="tdm-sched-clients">{{ s.schedule_clients }}</span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </Dialog>

    <!-- TOP 50 Detalle -->
    <Dialog
      v-model:visible="showTopDetalleModal"
      modal
      :style="{ width: 'min(95vw, 760px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      :header="topDetalleTitulo"
      class="top-detalle-modal"
    >
      <!-- Tabs -->
      <div class="tops-detalle-tabs">
        <button
          class="tops-tab"
          :class="{ active: topDetalleTab === 'added' }"
          @click="topDetalleTab = 'added'"
        >
          Agregadas
          <span class="tops-tab-badge added">{{ (topDetalleTop?.songs_added || []).length }}</span>
        </button>
        <button
          class="tops-tab"
          :class="{ active: topDetalleTab === 'removed' }"
          @click="topDetalleTab = 'removed'"
        >
          Eliminadas
          <span class="tops-tab-badge removed">{{ (topDetalleTop?.songs_removed || []).length }}</span>
        </button>
        <button
          class="tops-tab"
          :class="{ active: topDetalleTab === 'tag_changes' }"
          @click="topDetalleTab = 'tag_changes'"
        >
          Cambios por tag
          <span class="tops-tab-badge tag">{{ topDetalleSongsTagChanges.length }}</span>
        </button>
      </div>

      <!-- Toolbar -->
      <div class="tdm-toolbar">
        <div class="tdm-search">
          <i class="pi pi-search tdm-search-icon"></i>
          <input v-model="topDetalleSearch" type="text" class="tdm-search-input" placeholder="Buscar canción o artista..." />
        </div>
        <button class="tdm-export-btn" @click="exportarTopCSV" :disabled="!topDetalleSongsFiltrados.length" title="Exportar CSV">
          <i class="pi pi-download"></i>
          <span>CSV</span>
        </button>
      </div>

      <!-- Sin datos -->
      <div v-if="!topDetalleSongs.length" class="tdm-empty">
        <i class="pi pi-info-circle"></i>
        <p v-if="topDetalleTab === 'tag_changes'">Ningún cambio por tag este mes.</p>
        <p v-else>Ninguna canción {{ topDetalleTab === 'added' ? 'agregada' : 'eliminada' }} este mes.</p>
      </div>

      <div v-else-if="!topDetalleSongsFiltrados.length" class="tdm-empty">
        <i class="pi pi-info-circle"></i>
        <p>Sin resultados para la búsqueda.</p>
      </div>

      <!-- Tabla -->
      <div v-else class="tdm-table-wrap">
        <table class="tdm-table tops-detalle-table">
          <thead>
            <tr>
              <th>Canción</th>
              <th>Artista</th>
              <th v-if="topDetalleTab === 'tag_changes'" class="tdm-col-tags">Tags</th>
              <th v-if="topDetalleTab === 'tag_changes'">Tipo</th>
              <th class="tdm-col-date">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in topDetalleSongsFiltrados" :key="s.id">
              <td class="tops-detalle-song">{{ s.name || '—' }}</td>
              <td class="tops-detalle-artist">{{ s.artist || '—' }}</td>
              <td v-if="topDetalleTab === 'tag_changes'" class="tops-detalle-tags">
                <div class="tdm-tags-col">
                  <div class="tdm-tag-chips" :title="s.old_tags || ''">
                    <template v-if="s.old_tags">
                      <span v-for="(t, ti) in s.old_tags.split(',').map(x => x.trim()).filter(Boolean)" :key="'o'+ti" class="tdm-chip tdm-chip-old">{{ t }}</span>
                    </template>
                    <span v-else class="tdm-chip-none">—</span>
                  </div>
                  <span class="tdm-tag-arrow">&rarr;</span>
                  <div class="tdm-tag-chips" :title="s.new_tags || ''">
                    <template v-if="s.new_tags">
                      <span v-for="(t, ti) in s.new_tags.split(',').map(x => x.trim()).filter(Boolean)" :key="'n'+ti" class="tdm-chip tdm-chip-new">{{ t }}</span>
                    </template>
                    <span v-else class="tdm-chip-none">—</span>
                  </div>
                </div>
              </td>
              <td v-if="topDetalleTab === 'tag_changes'" class="tdm-col-type">
                <span class="tdm-tipo-badge" :class="s._tipo === 'entrada' ? 'tipo-entrada' : 'tipo-salida'">
                  {{ s._tipo === 'entrada' ? 'Entrada' : 'Salida' }}
                </span>
              </td>
              <td class="tdm-col-date">
                <template v-if="topDetalleTab === 'tag_changes'">{{ formatDateOnly(s._fecha) || '—' }}</template>
                <template v-else>{{ formatDateOnly(topDetalleTab === 'added' ? s.created_at : s.deleted_at) || '—' }}</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Dialog>

    <!-- Modal detalle por canal -->
    <Dialog
      v-model:visible="showCanalDetalleModal"
      modal
      :style="{ width: 'min(95vw, 720px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      :header="canalDetalleTitulo"
      class="canal-detalle-modal"
    >
      <div v-if="canalDetalleData" class="canal-detalle-body">
        <!-- Resumen -->
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val" :class="canalDetalleData.cumplimiento ? 'text-green-600 dark:text-green-400' : 'text-zinc-400 dark:text-zinc-500'">
              {{ canalDetalleData.cumplimiento ? '✓' : '✗' }}
            </span>
            <span class="cdm-summary-stat-label">{{ canalDetalleData.cumplimiento ? 'Cumple' : 'No cumple' }}</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ canalDetalleData.playlists_actualizadas }}/{{ canalDetalleData.playlists_total }}</span>
            <span class="cdm-summary-stat-label">Playlists actualizadas</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ canalDetalleData.last_update_at ? formatDateOnly(canalDetalleData.last_update_at) : '—' }}</span>
            <span class="cdm-summary-stat-label">Última actualización</span>
          </div>
        </div>
        <!-- Búsqueda -->
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="canalDetalleSearch" type="text" class="cdm-search-input" placeholder="Buscar playlist..." />
        </div>
        <!-- Filtros -->
        <div class="cdm-filters">
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Estado:</span>
            <button class="cdm-filter-chip" :class="{ active: canalFiltroEstado === 'todas' }" @click="canalFiltroEstado = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: canalFiltroEstado === 'actualizadas' }" @click="canalFiltroEstado = 'actualizadas'">Actualizadas</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: canalFiltroEstado === 'pendientes' }" @click="canalFiltroEstado = 'pendientes'">Pendientes</button>
          </div>
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Cambios:</span>
            <button class="cdm-filter-chip" :class="{ active: canalFiltroCambios === 'todas' }" @click="canalFiltroCambios = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: canalFiltroCambios === 'min5' }" @click="canalFiltroCambios = 'min5'">≥5</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: canalFiltroCambios === 'menos5' }" @click="canalFiltroCambios = 'menos5'">&lt;5</button>
          </div>
        </div>
        <!-- Tabla -->
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Playlist</th>
                <th class="cdm-col-center">Estado</th>
                <th class="cdm-col-center">Cambios</th>
                <th>Últ. actualización</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pl in canalDetallePlaylistsFiltradas" :key="pl.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                <td class="cdm-col-center">
                  <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">
                    {{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}
                  </span>
                </td>
                <td class="cdm-col-center">
                  <span class="cdm-cambios-val" :class="pl.changes >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes }}</span>
                </td>
                <td class="cdm-col-date">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
              </tr>
              <tr v-if="!canalDetallePlaylistsFiltradas.length">
                <td colspan="4" class="cdm-empty">Sin resultados</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Modal playlists actualizadas -->
    <Dialog
      v-model:visible="showPlaylistsDetalleModal"
      modal
      :style="{ width: 'min(95vw, 720px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Playlists actualizadas"
      class="playlists-detalle-modal"
    >
      <div v-if="playlistsDetalleData.length" class="canal-detalle-body">
        <!-- Resumen -->
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ playlistsDetalleData.filter(p => p.actualizada).length }}/{{ playlistsDetalleData.length }}</span>
            <span class="cdm-summary-stat-label">Playlists</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ playlistsDetalleData.filter(p => !p.actualizada).length }}</span>
            <span class="cdm-summary-stat-label">Pendientes</span>
          </div>
        </div>
        <!-- Búsqueda -->
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="playlistsDetalleSearch" type="text" class="cdm-search-input" placeholder="Buscar playlist..." />
        </div>
        <!-- Filtros -->
        <div class="cdm-filters">
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Estado:</span>
            <button class="cdm-filter-chip" :class="{ active: playlistsFiltroEstado === 'todas' }" @click="playlistsFiltroEstado = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: playlistsFiltroEstado === 'actualizadas' }" @click="playlistsFiltroEstado = 'actualizadas'">Actualizadas</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: playlistsFiltroEstado === 'pendientes' }" @click="playlistsFiltroEstado = 'pendientes'">Pendientes</button>
          </div>
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Cambios:</span>
            <button class="cdm-filter-chip" :class="{ active: playlistsFiltroCambios === 'todas' }" @click="playlistsFiltroCambios = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: playlistsFiltroCambios === 'min5' }" @click="playlistsFiltroCambios = 'min5'">≥5</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: playlistsFiltroCambios === 'menos5' }" @click="playlistsFiltroCambios = 'menos5'">&lt;5</button>
          </div>
        </div>
        <!-- Tabla -->
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Playlist</th>
                <th class="cdm-col-center">Estado</th>
                <th class="cdm-col-center">Cambios</th>
                <th>Últ. actualización</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pl in playlistsDetalleFiltradas" :key="pl.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                <td class="cdm-col-center">
                  <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">
                    {{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}
                  </span>
                </td>
                <td class="cdm-col-center">
                  <span class="cdm-cambios-val" :class="pl.changes >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes }}</span>
                </td>
                <td class="cdm-col-date">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
              </tr>
              <tr v-if="!playlistsDetalleFiltradas.length">
                <td colspan="4" class="cdm-empty">Sin resultados</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Modal detalle de playlist -->
    <Dialog
      v-model:visible="showPlaylistDetalleModal"
      modal
      :style="{ width: 'min(95vw, 640px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      :header="playlistDetalleTitulo"
      class="playlist-detalle-modal"
    >
      <div v-if="playlistDetalleLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else-if="playlistDetalleData" class="canal-detalle-body">
        <!-- Tabs -->
        <div class="tops-detalle-tabs">
          <button class="tops-tab" :class="{ active: playlistDetalleTab === 'added' }" @click="playlistDetalleTab = 'added'">
            Agregadas <span class="tops-tab-badge added">{{ playlistDetalleData.songs_added.length }}</span>
          </button>
          <button class="tops-tab" :class="{ active: playlistDetalleTab === 'removed' }" @click="playlistDetalleTab = 'removed'">
            Eliminadas <span class="tops-tab-badge removed">{{ playlistDetalleData.songs_removed.length }}</span>
          </button>
          <button v-if="playlistDetalleData.songs_catalog.length" class="tops-tab" :class="{ active: playlistDetalleTab === 'catalog' }" @click="playlistDetalleTab = 'catalog'">
            Catálogo <span class="tops-tab-badge tag">{{ playlistDetalleData.songs_catalog.length }}</span>
          </button>
        </div>
        <!-- Search -->
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="playlistDetalleSearch" type="text" class="cdm-search-input" placeholder="Buscar canción o artista..." />
        </div>
        <!-- Table -->
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Canción</th>
                <th>Artista</th>
                <th class="cdm-col-center">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in playlistDetalleSongsFiltrados" :key="s.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200">{{ s.name || '—' }}</td>
                <td class="text-zinc-500 dark:text-zinc-400">{{ s.artist || '—' }}</td>
                <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(s.date) || '—' }}</td>
              </tr>
              <tr v-if="!playlistDetalleSongsFiltrados.length">
                <td colspan="3" class="cdm-empty">{{ playlistDetalleSearch ? 'Sin resultados' : (playlistDetalleTab === 'catalog' ? 'Sin catálogo' : 'Sin cambios este mes') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Playlists Nuevas Modal -->
    <Dialog
      v-model:visible="showPlaylistsNuevasModal"
      modal
      :style="{ width: 'min(95vw, 600px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Playlists nuevas"
      class="playlists-nuevas-modal"
    >
      <div v-if="playlistsNuevasLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ playlistsNuevasData.length }}</span>
            <span class="cdm-summary-stat-label">Nuevas este mes</span>
          </div>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="playlistsNuevasSearch" type="text" class="cdm-search-input" placeholder="Buscar playlist..." />
        </div>
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Playlist</th>
                <th class="cdm-col-center">Tipo</th>
                <th class="cdm-col-center">Creada</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pl in playlistsNuevasFiltradas" :key="pl.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                <td class="cdm-col-center">
                  <span class="cdm-estado-badge" :class="pl.es_video ? 'cdm-tipo-video' : 'cdm-tipo-audio'">{{ pl.es_video ? 'Video' : 'Audio' }}</span>
                </td>
                <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.created_at) || '—' }}</td>
              </tr>
              <tr v-if="!playlistsNuevasFiltradas.length">
                <td colspan="3" class="cdm-empty">{{ playlistsNuevasSearch ? 'Sin resultados' : 'Sin playlists nuevas este mes' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Canciones del Mes Modal -->
    <Dialog
      v-model:visible="showCancionesMesModal"
      modal
      :style="{ width: 'min(95vw, 720px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Canciones del mes"
      class="canciones-mes-modal"
    >
      <div v-if="cancionesMesLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else-if="cancionesMesData" class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-green-600 dark:text-green-400">+{{ cancionesMesData.totalAgregadas.toLocaleString() }}</span>
            <span class="cdm-summary-stat-label">Agregadas</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-red-500">-{{ cancionesMesData.totalEliminadas.toLocaleString() }}</span>
            <span class="cdm-summary-stat-label">Eliminadas</span>
          </div>
        </div>
        <div class="tops-detalle-tabs">
          <button class="tops-tab" :class="{ active: cancionesMesTab === 'added' }" @click="cancionesMesTab = 'added'">
            Agregadas <span class="tops-tab-badge added">{{ cancionesMesData.totalAgregadas }}</span>
          </button>
          <button class="tops-tab" :class="{ active: cancionesMesTab === 'removed' }" @click="cancionesMesTab = 'removed'">
            Eliminadas <span class="tops-tab-badge removed">{{ cancionesMesData.totalEliminadas }}</span>
          </button>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="cancionesMesSearch" type="text" class="cdm-search-input" placeholder="Buscar canción o artista..." />
        </div>
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Canción</th>
                <th>Artista</th>
                <th class="cdm-col-center">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in cancionesMesFiltrados" :key="s.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200">{{ s.name || '—' }}</td>
                <td class="text-zinc-500 dark:text-zinc-400">{{ s.artist || '—' }}</td>
                <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(s.date) || '—' }}</td>
              </tr>
              <tr v-if="!cancionesMesFiltrados.length">
                <td colspan="3" class="cdm-empty">{{ cancionesMesSearch ? 'Sin resultados' : 'Sin canciones este mes' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Video Playlists Detalle Modal -->
    <Dialog
      v-model:visible="showVideoPlaylistsDetalleModal"
      modal
      :style="{ width: 'min(95vw, 680px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Canales video actualizados"
      class="video-playlists-detalle-modal"
    >
      <div v-if="videoPlaylistsDetalleLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ videoPlaylistsDetalleData.filter(c => c.cumplimiento).length }}/{{ videoPlaylistsDetalleData.length }}</span>
            <span class="cdm-summary-stat-label">Canales actualizados</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ videoPlaylistsDetalleTotalAct }}</span>
            <span class="cdm-summary-stat-label">Playlists actualizadas</span>
          </div>
        </div>
        <div class="cdm-filters">
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Estado:</span>
            <button class="cdm-filter-chip" :class="{ active: videoDetalleFiltroEstado === 'todas' }" @click="videoDetalleFiltroEstado = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: videoDetalleFiltroEstado === 'actualizadas' }" @click="videoDetalleFiltroEstado = 'actualizadas'">Cumplen</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: videoDetalleFiltroEstado === 'pendientes' }" @click="videoDetalleFiltroEstado = 'pendientes'">No cumplen</button>
          </div>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="videoPlaylistsDetalleSearch" type="text" class="cdm-search-input" placeholder="Buscar canal o playlist..." />
        </div>
        <div v-if="!videoPlaylistsDetalleFiltradas.length" class="cdm-empty" style="padding:28px 12px">
          {{ videoPlaylistsDetalleSearch ? 'Sin resultados' : 'Sin datos' }}
        </div>
        <div v-else class="video-canales-accordion">
          <div
            v-for="c in videoPlaylistsDetalleFiltradas"
            :key="c.stream"
            class="video-canal-card"
            :class="{ 'video-canal-card--open': videoDetalleExpandedStream === c.stream }"
          >
            <div class="video-canal-header" @click="videoDetalleExpandedStream = videoDetalleExpandedStream === c.stream ? null : c.stream">
              <div class="video-canal-header-left">
                <span class="video-canal-name">{{ c.radio_name }}</span>
                <span class="video-canal-count" :class="{ 'video-canal-count--ok': c.cumplimiento }">
                  {{ c.playlists_actualizadas ?? 0 }}/{{ c.playlists_total ?? 0 }}
                </span>
                <span v-if="!c.playlists_total" class="cdm-estado-badge cdm-estado-ghost" style="margin-left:6px">Sin contenido</span>
              </div>
              <i class="pi video-canal-chevron" :class="videoDetalleExpandedStream === c.stream ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </div>
            <div v-if="videoDetalleExpandedStream === c.stream" class="video-canal-body">
              <template v-if="c.playlists.filter(pl => pl.es_video).length">
                <div class="cdm-pl-group-header">
                  <i class="pi pi-video cdm-pl-group-icon cdm-pl-group-icon--video"></i>
                  <span class="cdm-pl-group-title">Playlists de video</span>
                  <span class="cdm-pl-group-count">{{ c.playlists.filter(pl => pl.es_video).length }}</span>
                </div>
                <table class="cdm-table video-pl-table">
                  <thead>
                    <tr>
                      <th>Playlist</th>
                      <th class="cdm-col-center" style="width:80px">Estado</th>
                      <th class="cdm-col-center" style="width:70px">Cambios</th>
                      <th class="cdm-col-center" style="width:105px">Últ. config</th>
                      <th class="cdm-col-center" style="width:105px">Últ. cambio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pl in c.playlists.filter(p => p.es_video)" :key="pl.id" :class="{ 'video-pl-row--ok': pl.actualizada }">
                      <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="showVideoPlaylistsDetalleModal = false; abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                      <td class="cdm-col-center">
                        <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">{{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}</span>
                      </td>
                      <td class="cdm-col-center">
                        <span class="cdm-cambios-val" :class="pl.changes >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes }}</span>
                      </td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.config_updated_at) || '—' }}</td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-if="c.playlists.filter(pl => !pl.es_video).length">
                <div class="cdm-pl-group-header">
                  <i class="pi pi-volume-up cdm-pl-group-icon cdm-pl-group-icon--audio"></i>
                  <span class="cdm-pl-group-title">Playlists de música</span>
                  <span class="cdm-pl-group-count">{{ c.playlists.filter(pl => !pl.es_video).length }}</span>
                </div>
                <table class="cdm-table video-pl-table">
                  <thead>
                    <tr>
                      <th>Playlist</th>
                      <th class="cdm-col-center" style="width:80px">Estado</th>
                      <th class="cdm-col-center" style="width:70px">Cambios</th>
                      <th class="cdm-col-center" style="width:105px">Últ. config</th>
                      <th class="cdm-col-center" style="width:105px">Últ. cambio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pl in c.playlists.filter(p => !p.es_video)" :key="pl.id" :class="{ 'video-pl-row--ok': pl.actualizada }">
                      <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="showVideoPlaylistsDetalleModal = false; abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                      <td class="cdm-col-center">
                        <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">{{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}</span>
                      </td>
                      <td class="cdm-col-center">
                        <span class="cdm-cambios-val" :class="pl.changes >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes }}</span>
                      </td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.config_updated_at) || '—' }}</td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <div v-if="!c.playlists.length" class="cdm-empty" style="padding:16px 12px">Sin playlists configuradas</div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- Video Playlists Nuevas Modal -->
    <Dialog
      v-model:visible="showVideoPlaylistsNuevasModal"
      modal
      :style="{ width: 'min(95vw, 600px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Playlists de video nuevas"
      class="video-playlists-nuevas-modal"
    >
      <div v-if="videoPlaylistsNuevasLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ videoPlaylistsNuevasData.length }}</span>
            <span class="cdm-summary-stat-label">Nuevas este mes</span>
          </div>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="videoPlaylistsNuevasSearch" type="text" class="cdm-search-input" placeholder="Buscar playlist..." />
        </div>
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Playlist</th>
                <th class="cdm-col-center">Tipo</th>
                <th class="cdm-col-center">Creada</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pl in videoPlaylistsNuevasFiltradas" :key="pl.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                <td class="cdm-col-center">
                  <span class="cdm-estado-badge" :class="pl.es_video ? 'cdm-tipo-video' : 'cdm-tipo-audio'">{{ pl.es_video ? 'Video' : 'Audio' }}</span>
                </td>
                <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.created_at) || '—' }}</td>
              </tr>
              <tr v-if="!videoPlaylistsNuevasFiltradas.length">
                <td colspan="3" class="cdm-empty">{{ videoPlaylistsNuevasSearch ? 'Sin resultados' : 'Sin playlists de video nuevas este mes' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Video Canciones del Mes Modal -->
    <Dialog
      v-model:visible="showVideoCancionesMesModal"
      modal
      :style="{ width: 'min(95vw, 720px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Videos del mes"
      class="video-canciones-mes-modal"
    >
      <div v-if="videoCancionesMesLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else-if="videoCancionesMesData" class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-green-600 dark:text-green-400">+{{ videoCancionesMesData.totalAgregadas.toLocaleString() }}</span>
            <span class="cdm-summary-stat-label">Agregados</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-red-500">-{{ videoCancionesMesData.totalEliminadas.toLocaleString() }}</span>
            <span class="cdm-summary-stat-label">Eliminados</span>
          </div>
        </div>
        <div class="tops-detalle-tabs">
          <button class="tops-tab" :class="{ active: videoCancionesMesTab === 'added' }" @click="videoCancionesMesTab = 'added'">
            Agregados <span class="tops-tab-badge added">{{ videoCancionesMesData.totalAgregadas }}</span>
          </button>
          <button class="tops-tab" :class="{ active: videoCancionesMesTab === 'removed' }" @click="videoCancionesMesTab = 'removed'">
            Eliminados <span class="tops-tab-badge removed">{{ videoCancionesMesData.totalEliminadas }}</span>
          </button>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="videoCancionesMesSearch" type="text" class="cdm-search-input" placeholder="Buscar canción o artista..." />
        </div>
        <div class="cdm-table-wrap">
          <table class="cdm-table">
            <thead>
              <tr>
                <th>Canción</th>
                <th>Artista</th>
                <th class="cdm-col-center">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in videoCancionesMesFiltrados" :key="s.id">
                <td class="font-semibold text-zinc-700 dark:text-zinc-200">{{ s.name || '—' }}</td>
                <td class="text-zinc-500 dark:text-zinc-400">{{ s.artist || '—' }}</td>
                <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(s.date) || '—' }}</td>
              </tr>
              <tr v-if="!videoCancionesMesFiltrados.length">
                <td colspan="3" class="cdm-empty">{{ videoCancionesMesSearch ? 'Sin resultados' : 'Sin videos este mes' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Contactos (Llamadas / Minutas) Detalle Modal -->
    <Dialog
      v-model:visible="showContactosDetalleModal"
      modal
      :style="{ width: 'min(95vw, 820px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Llamadas y Minutas"
      class="contactos-detalle-modal"
    >
      <div v-if="contactosDetalleLoading" class="pdm-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>
      <div v-else class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-green-600 dark:text-green-400">{{ contactosDetalleCumplidos }}</span>
            <span class="cdm-summary-stat-label">Cumplidos</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-yellow-600 dark:text-yellow-400">{{ contactosDetalleParcial }}</span>
            <span class="cdm-summary-stat-label">Parcial</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val text-red-600 dark:text-red-400">{{ contactosDetallePendientes }}</span>
            <span class="cdm-summary-stat-label">Pendientes</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ contactosDetalleData.length }}</span>
            <span class="cdm-summary-stat-label">Total canales</span>
          </div>
        </div>
        <div class="cdm-filters">
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Estado:</span>
            <button class="cdm-filter-chip" :class="{ active: contactosDetalleFiltroEstado === 'todos' }" @click="contactosDetalleFiltroEstado = 'todos'">Todos</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: contactosDetalleFiltroEstado === 'cumplido' }" @click="contactosDetalleFiltroEstado = 'cumplido'">Cumplidos</button>
            <button class="cdm-filter-chip cdm-filter-chip-warn" :class="{ active: contactosDetalleFiltroEstado === 'parcial' }" @click="contactosDetalleFiltroEstado = 'parcial'">Parcial</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: contactosDetalleFiltroEstado === 'pendiente' }" @click="contactosDetalleFiltroEstado = 'pendiente'">Pendientes</button>
          </div>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="contactosDetalleSearch" type="text" class="cdm-search-input" placeholder="Buscar canal o cliente..." />
        </div>
        <div class="cdm-table-wrap">
          <table class="cdm-table contactos-table">
            <thead>
              <tr>
                <th>Canal / Cliente</th>
                <th class="cdm-col-center" style="min-width:140px">Llamada</th>
                <th class="cdm-col-center" style="min-width:140px">Minuta</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="c in contactosDetalleFiltrados" :key="c.radio_id">
                <tr class="contactos-row" :class="{ 'contactos-row--expanded': contactosExpandedId === c.radio_id }" @click="contactosExpandedId = contactosExpandedId === c.radio_id ? null : c.radio_id">
                  <td class="contactos-canal-cell">
                    <div class="flex items-center gap-2.5">
                      <div
                        class="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center"
                        :style="logoBackgroundStyle(c)"
                      >
                        <img
                          v-if="getLogoUrl(c)"
                          :src="getLogoUrl(c)"
                          :alt="c.radio_name || ''"
                          class="max-w-full max-h-full object-contain"
                          draggable="false"
                        />
                        <i v-else class="pi pi-megaphone text-white" style="font-size:0.85rem;opacity:0.5"></i>
                      </div>
                      <div class="flex flex-col leading-tight gap-0.5 min-w-0">
                        <span class="font-semibold text-zinc-700 dark:text-zinc-200 truncate">{{ c.radio_name }}</span>
                        <span v-if="c.client_name && c.client_name !== c.radio_name" class="text-xs text-zinc-400 dark:text-zinc-500 truncate">{{ c.client_name }}</span>
                        <span v-if="c.radio_type" class="text-[0.65rem] text-zinc-400 italic">{{ c.radio_type }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="cdm-col-center cursor-pointer">
                    <span v-if="c.llamada" class="contact-chip chip-llamada">
                      <i class="pi pi-check-circle chip-icon"></i>
                      <span>{{ formatContactoFecha(c.llamada.occurred_at) }}</span>
                      <span v-if="c.llamadaCount > 1" class="chip-count">x{{ c.llamadaCount }}</span>
                    </span>
                    <span v-else class="contact-chip chip-pendiente">
                      <i class="pi pi-minus-circle chip-icon"></i>
                      <span>Sin llamada</span>
                    </span>
                  </td>
                  <td class="cdm-col-center cursor-pointer">
                    <span v-if="c.minuta" class="contact-chip chip-minuta">
                      <i class="pi pi-check-circle chip-icon"></i>
                      <span>{{ formatContactoFecha(c.minuta.occurred_at) }}</span>
                      <span v-if="c.minutaCount > 1" class="chip-count">x{{ c.minutaCount }}</span>
                    </span>
                    <span v-else class="contact-chip chip-pendiente">
                      <i class="pi pi-minus-circle chip-icon"></i>
                      <span>Sin minuta</span>
                    </span>
                  </td>
                </tr>
                <tr v-if="contactosExpandedId === c.radio_id" class="contactos-expanded-row">
                  <td colspan="3" class="!p-0">
                    <table class="cdm-table contactos-sub-table">
                      <thead>
                        <tr>
                          <th style="width:52px">Tipo</th>
                          <th style="width:120px">Fecha</th>
                          <th>Notas</th>
                          <th style="width:110px">Registró</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="r in c.registros" :key="r.id">
                          <td class="cdm-col-center">
                            <span :class="r.contact_type === 'llamada' ? 'text-blue-600 dark:text-blue-400' : 'text-green-600 dark:text-green-400'" style="font-size:0.9rem">{{ r.contact_type === 'llamada' ? '📞' : '📋' }}</span>
                          </td>
                          <td class="cdm-col-date" style="white-space:nowrap">{{ formatContactoFecha(r.occurred_at) }}</td>
                          <td class="text-xs text-zinc-600 dark:text-zinc-400" style="max-width:300px">{{ r.notes || '—' }}</td>
                          <td class="text-xs text-zinc-400 dark:text-zinc-500">{{ r.recorded_by_name || '—' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
              <tr v-if="!contactosDetalleFiltrados.length">
                <td colspan="3" class="cdm-empty">{{ contactosDetalleSearch ? 'Sin resultados' : 'Sin contactos este mes' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- Canales Actualizados Detalle Modal -->
    <Dialog
      v-model:visible="showCanalesActualizadosModal"
      modal
      :style="{ width: 'min(95vw, 680px)' }"
      :dismissableMask="true"
      :draggable="false"
      :closable="true"
      header="Canales actualizados"
      class="canales-actualizados-modal"
    >
      <div class="canal-detalle-body">
        <div class="cdm-summary">
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ musKpi.global.canales_con_cumplimiento ?? '—' }}/{{ musKpi.global.canales_total ?? '—' }}</span>
            <span class="cdm-summary-stat-label">Canales actualizados</span>
          </div>
          <div class="cdm-summary-divider"></div>
          <div class="cdm-summary-stat">
            <span class="cdm-summary-stat-val">{{ musKpi.global.playlists_actualizadas ?? '—' }}</span>
            <span class="cdm-summary-stat-label">Playlists actualizadas</span>
          </div>
        </div>
        <div class="cdm-filters">
          <div class="cdm-filter-group">
            <span class="cdm-filter-label">Estado:</span>
            <button class="cdm-filter-chip" :class="{ active: canalesActualizadosFiltro === 'todas' }" @click="canalesActualizadosFiltro = 'todas'">Todas</button>
            <button class="cdm-filter-chip cdm-filter-chip-ok" :class="{ active: canalesActualizadosFiltro === 'cumplen' }" @click="canalesActualizadosFiltro = 'cumplen'">Cumplen</button>
            <button class="cdm-filter-chip cdm-filter-chip-no" :class="{ active: canalesActualizadosFiltro === 'nocumplen' }" @click="canalesActualizadosFiltro = 'nocumplen'">No cumplen</button>
            <button class="cdm-filter-chip cdm-filter-chip-ghost" :class="{ active: canalesActualizadosFiltro === 'sincontenido' }" @click="canalesActualizadosFiltro = 'sincontenido'">Sin contenido</button>
          </div>
        </div>
        <div class="cdm-search">
          <i class="pi pi-search cdm-search-icon"></i>
          <input v-model="canalesActualizadosSearch" type="text" class="cdm-search-input" placeholder="Buscar canal o playlist..." />
        </div>
        <div v-if="!canalesActualizadosFiltradas.length" class="cdm-empty" style="padding:28px 12px">
          {{ canalesActualizadosSearch ? 'Sin resultados' : 'Sin datos' }}
        </div>
        <div v-else class="video-canales-accordion">
          <div
            v-for="c in canalesActualizadosFiltradas"
            :key="c.stream"
            class="video-canal-card"
            :class="{ 'video-canal-card--open': canalesActExpandedStream === c.stream }"
          >
            <div class="video-canal-header" @click="canalesActExpandedStream = canalesActExpandedStream === c.stream ? null : c.stream">
              <div class="video-canal-header-left">
                <span class="video-canal-name">{{ c.radio_name }}</span>
                <span class="video-canal-count" :class="{ 'video-canal-count--ok': c.cumplimiento }">
                  {{ c.playlists_actualizadas ?? 0 }}/{{ c.playlists_total ?? 0 }}
                </span>
                <span v-if="!c.playlists_total" class="cdm-estado-badge cdm-estado-ghost" style="margin-left:6px">Sin contenido</span>
              </div>
              <i class="pi video-canal-chevron" :class="canalesActExpandedStream === c.stream ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            </div>
            <div v-if="canalesActExpandedStream === c.stream" class="video-canal-body">
              <template v-if="c.playlists.filter(pl => pl.es_video).length">
                <div class="cdm-pl-group-header">
                  <i class="pi pi-video cdm-pl-group-icon cdm-pl-group-icon--video"></i>
                  <span class="cdm-pl-group-title">Playlists de video</span>
                  <span class="cdm-pl-group-count">{{ c.playlists.filter(pl => pl.es_video).length }}</span>
                </div>
                <table class="cdm-table video-pl-table">
                  <thead>
                    <tr>
                      <th>Playlist</th>
                      <th class="cdm-col-center" style="width:80px">Estado</th>
                      <th class="cdm-col-center" style="width:70px">Cambios</th>
                      <th class="cdm-col-center" style="width:105px">Últ. config</th>
                      <th class="cdm-col-center" style="width:105px">Últ. cambio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pl in c.playlists.filter(p => p.es_video)" :key="pl.id" :class="{ 'video-pl-row--ok': pl.actualizada }">
                      <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="showCanalesActualizadosModal = false; abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                      <td class="cdm-col-center">
                        <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">{{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}</span>
                      </td>
                      <td class="cdm-col-center">
                        <span class="cdm-cambios-val" :class="(pl.changes || 0) >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes ?? 0 }}</span>
                      </td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.config_updated_at) || '—' }}</td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-if="c.playlists.filter(pl => !pl.es_video).length">
                <div class="cdm-pl-group-header">
                  <i class="pi pi-volume-up cdm-pl-group-icon cdm-pl-group-icon--audio"></i>
                  <span class="cdm-pl-group-title">Playlists de música</span>
                  <span class="cdm-pl-group-count">{{ c.playlists.filter(pl => !pl.es_video).length }}</span>
                </div>
                <table class="cdm-table video-pl-table">
                  <thead>
                    <tr>
                      <th>Playlist</th>
                      <th class="cdm-col-center" style="width:80px">Estado</th>
                      <th class="cdm-col-center" style="width:70px">Cambios</th>
                      <th class="cdm-col-center" style="width:105px">Últ. config</th>
                      <th class="cdm-col-center" style="width:105px">Últ. cambio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pl in c.playlists.filter(p => !p.es_video)" :key="pl.id" :class="{ 'video-pl-row--ok': pl.actualizada }">
                      <td class="font-semibold text-zinc-700 dark:text-zinc-200 cdm-pl-name" @click="showCanalesActualizadosModal = false; abrirPlaylistDetalle(pl)">{{ pl.name }}</td>
                      <td class="cdm-col-center">
                        <span class="cdm-estado-badge" :class="pl.actualizada ? 'cdm-estado-ok' : 'cdm-estado-no'">{{ pl.actualizada ? 'Actualizada' : 'Pendiente' }}</span>
                      </td>
                      <td class="cdm-col-center">
                        <span class="cdm-cambios-val" :class="(pl.changes || 0) >= 5 ? 'cdm-cambios-ok' : 'cdm-cambios-pocos'">{{ pl.changes ?? 0 }}</span>
                      </td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.config_updated_at) || '—' }}</td>
                      <td class="cdm-col-date cdm-col-center">{{ formatDateOnly(pl.last_change_at) || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <div v-if="!c.playlists.length" class="cdm-empty" style="padding:16px 12px">Sin playlists configuradas</div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- Capacidad Instalada Dialog -->
    <Dialog v-model:visible="capacidadDialogVisible" header="Capacidad Instalada" :modal="true" :style="{ width: '400px' }">
      <div class="flex flex-col gap-3 pt-2">
        <div class="text-sm">Período: <strong>{{ mes }}</strong></div>
        <div class="flex flex-col gap-1">
          <label class="text-sm font-medium">Capacidad teórica de producción</label>
          <InputNumber v-model="capacidadForm.capacidad" :min="0" :useGrouping="false" class="w-full" />
          <span class="text-xs text-zinc-400">Según estudios de productividad de Vybroo</span>
        </div>
      </div>
      <template #footer>
        <Button label="Cancelar" class="p-button-text" @click="capacidadDialogVisible = false" />
        <Button label="Guardar" :loading="guardandoCapacidad" @click="guardarCapacidad" />
      </template>
    </Dialog>

    <!-- Producción Desglosada Detalle Dialog -->
    <Dialog v-model:visible="desgloseDetalleVisible" :header="'Producción desglosada: ' + (desgloseDetalleNombre || '')" :modal="true" :style="{ width: '700px' }">
      <div v-if="desgloseDetalleCargando" class="flex items-center justify-center py-8">
        <i class="pi pi-spin pi-spinner mr-2" style="font-size:1.2rem"></i>
        <span class="text-sm text-zinc-500">Cargando detalle...</span>
      </div>
      <div v-else-if="desgloseDetalleError" class="text-center py-6 text-red-500 text-sm">
        <i class="pi pi-exclamation-triangle mr-1"></i> {{ desgloseDetalleError }}
      </div>
      <template v-else-if="desgloseDetalleData">
        <!-- Cabecera -->
        <div class="flex items-center gap-3 mb-4 p-3 rounded-lg" style="background:rgba(59,130,246,0.06)">
          <i class="pi pi-chart-bar" style="font-size:1.1rem;color:#3b82f6"></i>
          <div class="flex items-center gap-3 text-sm">
            <span class="text-zinc-600 dark:text-zinc-300">{{ desgloseDetalleDescripcion }}</span>
            <span class="text-zinc-400">·</span>
            <span class="text-zinc-500">{{ desgloseDetalleData.totales?.canales || 0 }} canales</span>
          </div>
        </div>
        <!-- Totales -->
        <div class="kpi-mus-strip mb-4">
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val kpi-mus-val-neutral">{{ (desgloseDetalleData.totales?.meta_spots || 0).toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Meta Spots</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val" style="color:#10b981">{{ (desgloseDetalleData.totales?.spots_locucion || 0).toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Prod. Spots</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span
              class="kpi-mus-stat-val"
              :class="desgloseDetalleData.totales?.eficiencia_humano != null ? (desgloseDetalleData.totales.eficiencia_humano >= 0.95 ? 'kpi-mus-val-green' : desgloseDetalleData.totales.eficiencia_humano >= 0.7 ? 'kpi-mus-val-yellow' : 'kpi-mus-val-red') : 'kpi-mus-val-neutral'"
            >{{ desgloseDetalleData.totales?.eficiencia_humano != null ? formatPct(desgloseDetalleData.totales.eficiencia_humano) : '—' }}</span>
            <span class="kpi-mus-stat-label">Ef. Spots</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val" style="color:#8b5cf6">{{ (desgloseDetalleData.totales?.meta_ia || 0).toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Meta IA</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span class="kpi-mus-stat-val" style="color:#8b5cf6">{{ (desgloseDetalleData.totales?.spots_ia || 0).toLocaleString() }}</span>
            <span class="kpi-mus-stat-label">Prod. IA</span>
          </div>
          <div class="kpi-mus-stat-divider"></div>
          <div class="kpi-mus-stat">
            <span
              class="kpi-mus-stat-val"
              :class="desgloseDetalleData.totales?.eficiencia_ia != null ? (desgloseDetalleData.totales.eficiencia_ia >= 0.95 ? 'kpi-mus-val-green' : desgloseDetalleData.totales.eficiencia_ia >= 0.7 ? 'kpi-mus-val-yellow' : 'kpi-mus-val-red') : 'kpi-mus-val-neutral'"
            >{{ desgloseDetalleData.totales?.eficiencia_ia != null ? formatPct(desgloseDetalleData.totales.eficiencia_ia) : '—' }}</span>
            <span class="kpi-mus-stat-label">Ef. IA</span>
          </div>
        </div>
        <!-- Tabla de canales -->
        <DataTable
          :value="desgloseDetalleData.canales || []"
          responsiveLayout="scroll"
          stripedRows
          class="text-sm kpi-spots-table"
          :paginator="true"
          :rows="10"
          sortField="spots_total"
          :sortOrder="-1"
        >
          <Column field="radio_name" header="Canal" sortable style="min-width:160px">
            <template #body="{ data: row }">
              <div class="flex items-center gap-2.5">
                <div class="w-7 h-7 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center" :style="{ background: row.radio_color || '#3b82f6' }">
                  <span class="text-white font-semibold" style="font-size:0.65rem">{{ (row.radio_name || '?')[0].toUpperCase() }}</span>
                </div>
                <div class="flex flex-col leading-tight min-w-0">
                  <span class="font-semibold text-zinc-700 dark:text-zinc-200 truncate">{{ row.radio_name }}</span>
                  <span v-if="row.client_name !== row.radio_name" class="text-xs text-zinc-400 dark:text-zinc-500 truncate">{{ row.client_name }}</span>
                </div>
              </div>
            </template>
          </Column>
          <Column field="spots_locucion" header="Spots" sortable style="min-width:140px">
            <template #body="{ data }">
              <DesgloseCell :prod="data.spots_locucion || 0" :meta="data.meta_spots || 0" type="spots" />
            </template>
          </Column>
          <Column field="spots_ia" header="Spots IA" sortable style="min-width:140px">
            <template #body="{ data }">
              <DesgloseCell :prod="data.spots_ia || 0" :meta="data.meta_ia || 0" type="ia" />
            </template>
          </Column>
        </DataTable>
        <div v-if="!(desgloseDetalleData.canales || []).length" class="text-center py-4 text-sm text-zinc-400">
          No hay canales en esta agrupación para el período seleccionado
        </div>
      </template>
      <template #footer>
        <Button label="Cerrar" class="p-button-text" @click="desgloseDetalleVisible = false" />
      </template>
    </Dialog>

    <!-- Scroll-to-top FAB -->
    <transition name="kpi-top-fab">
      <button
        v-if="showBackToTop"
        type="button"
        class="kpi-top-fab"
        @click="scrollToTop"
        aria-label="Volver arriba"
        title="Ir arriba"
      >
        <i class="pi pi-arrow-up"></i>
      </button>
    </transition>

  </div>
</template>

<script>
import KpiProgressBar from '@/components/KpiProgressBar.vue';
import KpiSectionSkeleton from '@/components/KpiSectionSkeleton.vue';
import ConectadosDetalleModal from '@/components/ConectadosDetalleModal.vue';
import DesgloseCell from '@/components/DesgloseCell.vue';
import axiosInstance from '@/axiosInstance';
import { useGlobalFilter } from '@/stores/globalFilterStore';

const gf = useGlobalFilter();

export default {
  name: 'IndicadoresOpKpi',

  components: { KpiProgressBar, KpiSectionSkeleton, ConectadosDetalleModal, DesgloseCell },

  data() {
    const now = new Date();
    const mesActual = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    return {
      includeUnscheduled: true,
      mes: mesActual,
      mesMax: mesActual,
      filtroTexto: '',
      tipoFiltrosSeleccionados: ['activos'],
      soloConMetasSpots: false,
      loading: false,
      error: null,
      data: null,
      locucionPersonasData: null,
      loadingPersonas: false,
      errorPersonas: null,
      desgloseExpandido: false,
      rolesVisibles: ['Locutor', 'IA'],
      musicalizacionData: null,
      musicalizacionUpdatedAt: null,
      loadingMus: false,
      errorMus: null,
      musExpandido: false,
      mostrarTodosCanalesMus: true,
      musFiltroTexto: '',
      // Duplicados y Errores (global, estado actual)
      duplicadosErrores: null,
      duplicadosErroresLoading: false,
      duplicadosErroresError: null,
      showDuplicadosErroresModal: false,
      dupErrTab: 'duplicadas',
      dupErrSearch: '',
      // Refresh UX
      refreshing: false,
      refreshStatus: null,
      lastUpdated: null,
      prevSnapshot: null,
      refreshStatusTimer: null,
      invalidando: false,
      invalidandoOp: false,
      // Filtro por asesor
      asesorSeleccionado: null,
      // Flags para prevenir race conditions en cargar() concurrentes
      cargandoEnProgreso: false,
      cargarPendiente: false,
      // Section loading shimmer con threshold para evitar flash
      sectionLoadingDelayed: false,
      showConectadosModal: false,
      showTemporadaModal: false,
      temporadaDetalle: [],
      temporadaDetalleLoading: false,
      temporadaDetalleSearch: '',
      copiedId: null,
      expandedRowId: null,
      sectionLoadingTimer: null,
      // Conectados en tiempo real
      conectadosAhora: null,
      conectadosTimer: null,
      conectadosTicker: 0,
      conectadosTickerTimer: null,
      // TOP 50 detalle
      showTopDetalleModal: false,
      topDetalleTop: null,
      topDetalleTab: 'added',
      topDetalleSearch: '',
      // Canal detalle modal
      showCanalDetalleModal: false,
      canalDetalleData: null,
      canalDetalleSearch: '',
      canalFiltroEstado: 'todas',
      canalFiltroCambios: 'todas',
      // Playlists detalle modal
      showPlaylistsDetalleModal: false,
      playlistsDetalleData: [],
      playlistsDetalleSearch: '',
      playlistsFiltroEstado: 'todas',
      playlistsFiltroCambios: 'todas',
      // Playlist detalle modal
      showPlaylistDetalleModal: false,
      playlistDetalleData: null,
      playlistDetalleLoading: false,
      playlistDetalleTab: 'added',
      playlistDetalleSearch: '',
      // Playlists nuevas modal
      showPlaylistsNuevasModal: false,
      playlistsNuevasData: [],
      playlistsNuevasLoading: false,
      playlistsNuevasSearch: '',
      // Canciones del mes modal
      showCancionesMesModal: false,
      cancionesMesData: null,
      cancionesMesLoading: false,
      cancionesMesTab: 'added',
      cancionesMesSearch: '',
      // Video playlists detalle modal
      showVideoPlaylistsDetalleModal: false,
      videoPlaylistsDetalleData: [],
      videoPlaylistsDetalleLoading: false,
      videoPlaylistsDetalleSearch: '',
      videoDetalleExpandedStream: null,
      videoDetalleFiltroEstado: 'todas',
      // Video playlists nuevas modal (filter from playlistsNuevas)
      showVideoPlaylistsNuevasModal: false,
      videoPlaylistsNuevasData: [],
      videoPlaylistsNuevasLoading: false,
      videoPlaylistsNuevasSearch: '',
      // Video canciones del mes modal
      showVideoCancionesMesModal: false,
      videoCancionesMesData: null,
      videoCancionesMesLoading: false,
      videoCancionesMesTab: 'added',
      videoCancionesMesSearch: '',
      // Canales actualizados detalle modal
      showCanalesActualizadosModal: false,
      canalesActualizadosSearch: '',
      canalesActualizadosFiltro: 'todas',
      canalesActExpandedStream: null,
      // Contactos (Llamadas / Minutas) detalle modal
      showContactosDetalleModal: false,
      contactosDetalleData: [],
      contactosDetalleLoading: false,
      contactosDetalleSearch: '',
      contactosDetalleFiltroEstado: 'todos', // 'todos' | 'cumplido' | 'parcial' | 'pendiente'
      contactosExpandedId: null,
      // Collapsible sections
      collapsed: {
        conectados: false,
        global: false,
        produccion: false,
        musicalizacion: false,
        indicadores: false,
      },
      // Scroll-to-top
      showBackToTop: false,
      backToTopScrollTarget: null,
      // Capacidad Instalada
      capacidadDialogVisible: false,
      capacidadForm: { capacidad: 1000 },
      guardandoCapacidad: false,
      // Producción Desglosada
      desglosadaVisible: false,
      produccionDesglosada: null,
      // Detalle de desglose
      desgloseDetalleVisible: false,
      desgloseDetalleNombre: '',
      desgloseDetalleCargando: false,
      desgloseDetalleError: null,
      desgloseDetalleData: null,
    };
  },

  computed: {
    isAdmin() {
      try {
        const data = JSON.parse(localStorage.getItem('clientData') || '{}');
        return Array.isArray(data.permissions) && data.permissions.includes('admin');
      } catch { return false; }
    },

    canalesFiltrados() {
      if (!this.data) return [];
      return this.data.canales.filter((c) => {
        const tipoNorm = this.normalizarTipoRadio(c.radio_type);
        const esActivo = this.esTipoActivo(tipoNorm);
        const tieneMetasSpots = this.tieneMetasSpots(c);

        if (this.soloConMetasSpots && !tieneMetasSpots) {
          return false;
        }

        if (!this.tipoFiltrosSeleccionados.includes('todos')) {
          const cumpleTipo =
            (this.tipoFiltrosSeleccionados.includes('activos') && esActivo) ||
            (this.tipoFiltrosSeleccionados.includes('demos') && tipoNorm.includes('demo')) ||
            (this.tipoFiltrosSeleccionados.includes('intercambio') && tipoNorm === 'intercambio') ||
            (this.tipoFiltrosSeleccionados.includes('cortesia') && tipoNorm === 'cortesia') ||
            (this.tipoFiltrosSeleccionados.includes('pruebas') && tipoNorm === 'pruebas');

          if (!cumpleTipo) return false;
        }

        if (this.filtroTexto) {
          const q = this.filtroTexto.toLowerCase();
          return (
            c.radio_name.toLowerCase().includes(q) ||
            c.client_name.toLowerCase().includes(q)
          );
        }
        return true;
      });
    },

    temporada() {
      const t = this.data?.temporada || {};
      const meta = Number(t.meta ?? 10);
      const producidos = Number(t.producidos ?? 0);
      const eficiencia = (t.eficiencia === null || t.eficiencia === undefined)
        ? (meta > 0 ? Math.min(producidos, meta) / meta : null)
        : Number(t.eficiencia);

      return {
        meta,
        producidos,
        cumplida: Boolean(t.cumplida ?? (producidos >= meta)),
        eficiencia,
      };
    },

    produccionDesglosadaAgrupaciones() {
      if (!this.produccionDesglosada) return [];
      const agrup = this.produccionDesglosada.agrupaciones || {};
      return Object.values(agrup);
    },

    desgloseDetalleDescripcion() {
      const d = this.desgloseDetalleData;
      if (!d) return '';
      const map = {
        canal_tipo: 'Canales de tipo',
        cliente: 'Cliente',
        cliente_contiene: 'Clientes que contienen',
        sonara: 'Canales en plataforma Sonara',
      };
      const prefix = map[d.tipo] || d.tipo;
      return d.valor ? `${prefix} «${d.valor}»` : prefix;
    },

    temporadaDetalleFiltrados() {
      const q = this.temporadaDetalleSearch.toLowerCase().trim();
      let list = this.temporadaDetalle;
      if (q) {
        list = list.filter(s =>
          s.spot_name?.toLowerCase().includes(q) ||
          s.request_name?.toLowerCase().includes(q) ||
          s.status_label?.toLowerCase().includes(q) ||
          String(s.spot_id).includes(q) ||
          String(s.request_id).includes(q)
        );
      }
      return list;
    },

    topDetalleSongs() {
      const top = this.topDetalleTop;
      if (!top) return [];
      if (this.topDetalleTab === 'added') return top.songs_added || [];
      if (this.topDetalleTab === 'removed') return top.songs_removed || [];
      if (this.topDetalleTab === 'tag_changes') return this.topDetalleSongsTagChanges;
      return [];
    },

    topDetalleSongsTagChanges() {
      const top = this.topDetalleTop;
      if (!top) return [];
      const added = (top.songs_added || []).filter(s => s.tag_change);
      const removed = (top.songs_removed || []).filter(s => s.tag_change);
      // Merge and sort by date desc
      const merged = added.map(s => ({ ...s, _tipo: 'entrada', _fecha: s.created_at }))
        .concat(removed.map(s => ({ ...s, _tipo: 'salida', _fecha: s.deleted_at })));
      merged.sort((a, b) => {
        const da = a._fecha || '';
        const db = b._fecha || '';
        return db.localeCompare(da);
      });
      return merged;
    },

    topDetalleSongsFiltrados() {
      const q = this.topDetalleSearch.toLowerCase().trim();
      let list = this.topDetalleSongs;
      if (q) {
        list = list.filter(s =>
          (s.name || '').toLowerCase().includes(q) ||
          (s.artist || '').toLowerCase().includes(q)
        );
      }
      return list;
    },

    topDetalleTitulo() {
      if (!this.topDetalleTop) return 'TOP 50';
      return 'Detalle: ' + this.topDetalleTop.name;
    },

    canalDetalleTitulo() {
      if (!this.canalDetalleData) return 'Detalle por canal';
      return 'Canal: ' + this.canalDetalleData.radio_name;
    },

    playlistDetalleTitulo() {
      if (!this.playlistDetalleData) return 'Playlist';
      return 'Playlist: ' + (this.playlistDetalleData.playlist_name || '—');
    },

    playlistDetalleSongsFiltrados() {
      if (!this.playlistDetalleData) return [];
      let list;
      if (this.playlistDetalleTab === 'added') {
        list = this.playlistDetalleData.songs_added;
      } else if (this.playlistDetalleTab === 'removed') {
        list = this.playlistDetalleData.songs_removed;
      } else {
        list = this.playlistDetalleData.songs_catalog;
      }
      if (!Array.isArray(list)) return [];
      const q = (this.playlistDetalleSearch || '').trim().toLowerCase();
      if (!q) return list;
      return list.filter(s =>
        String(s.name || '').toLowerCase().includes(q) ||
        String(s.artist || '').toLowerCase().includes(q)
      );
    },

    playlistsNuevasFiltradas() {
      const q = (this.playlistsNuevasSearch || '').trim().toLowerCase();
      let list = this.playlistsNuevasData;
      if (!q) return list;
      return list.filter(p =>
        String(p.name || '').toLowerCase().includes(q)
      );
    },

    videoPlaylistsDetalleFlat() {
      const flat = [];
      for (const c of this.videoPlaylistsDetalleData) {
        if (!Array.isArray(c.playlists)) continue;
        for (const p of c.playlists) {
          flat.push({ ...p, radio_name: c.radio_name, stream: c.stream });
        }
      }
      return flat;
    },
    videoPlaylistsDetalleFiltradas() {
      const q = (this.videoPlaylistsDetalleSearch || '').trim().toLowerCase();
      const filtro = this.videoDetalleFiltroEstado;
      let canales = this.videoPlaylistsDetalleData;
      if (!q && filtro === 'todas') return canales;
      return canales
        .map(c => {
          let pls = (c.playlists || []);
          // Filtrar a nivel CANAL, no playlist
          if (filtro === 'actualizadas' && !pls.some(p => p.actualizada)) return null;
          if (filtro === 'pendientes' && pls.some(p => p.actualizada)) return null;
          if (q) {
            const chMatch = String(c.radio_name || '').toLowerCase().includes(q);
            pls = pls.filter(p => chMatch || String(p.name || '').toLowerCase().includes(q));
          }
          pls.sort((a, b) => (b.actualizada ? 1 : 0) - (a.actualizada ? 1 : 0));
          if (pls.length > 0 || (q && String(c.radio_name || '').toLowerCase().includes(q))) {
            return { ...c, playlists: pls };
          }
          return null;
        })
        .filter(Boolean);
    },
    videoPlaylistsDetalleCanalesAct() {
      return this.videoPlaylistsDetalleData.filter(c =>
        (c.playlists || []).some(p => p.actualizada)
      ).length;
    },
    videoPlaylistsDetalleTotal() {
      return this.videoPlaylistsDetalleData.reduce((sum, c) => sum + (c.playlists?.length || 0), 0);
    },
    videoPlaylistsDetalleTotalAct() {
      return this.videoPlaylistsDetalleData.reduce((sum, c) =>
        sum + (c.playlists || []).filter(p => p.actualizada).length, 0);
    },

    videoCanalesPct() {
      const t = this.musKpi?.global?.canales_con_video;
      const a = this.musKpi?.global?.canales_con_video_actualizadas;
      if (!t || t === 0) return 0;
      return (a || 0) / t;
    },

    videoPlaylistsNuevasFiltradas() {
      const q = (this.videoPlaylistsNuevasSearch || '').trim().toLowerCase();
      let list = this.videoPlaylistsNuevasData;
      if (!q) return list;
      return list.filter(p =>
        String(p.name || '').toLowerCase().includes(q)
      );
    },

    videoCancionesMesSongs() {
      if (!this.videoCancionesMesData) return [];
      const list = this.videoCancionesMesTab === 'added'
        ? this.videoCancionesMesData.agregadas
        : this.videoCancionesMesData.eliminadas;
      return Array.isArray(list) ? list : [];
    },

    videoCancionesMesFiltrados() {
      const q = (this.videoCancionesMesSearch || '').trim().toLowerCase();
      let list = this.videoCancionesMesSongs;
      if (!q) return list;
      return list.filter(s =>
        String(s.name || '').toLowerCase().includes(q) ||
        String(s.artist || '').toLowerCase().includes(q)
      );
    },

    canalesActualizadosLista() {
      const list = this.musKpi?.canales || [];
      if (this.canalesActualizadosFiltro === 'cumplen') return list.filter(c => c.cumplimiento);
      if (this.canalesActualizadosFiltro === 'nocumplen') return list.filter(c => !c.cumplimiento && !c.sin_playlists);
      if (this.canalesActualizadosFiltro === 'sincontenido') return list.filter(c => c.sin_playlists);
      return list;
    },
    canalesActualizadosFiltradas() {
      const q = (this.canalesActualizadosSearch || '').trim().toLowerCase();
      let list = this.canalesActualizadosLista;
      if (!q) return list;
      return list.filter(c => String(c.radio_name || '').toLowerCase().includes(q));
    },

    contactosDetalleConLlamada() {
      return this.canalesConLlamadas;
    },
    contactosDetalleConMinuta() {
      return this.canalesConMinutas;
    },
    // Estado de contacto de un canal del modal:
    //   'cumplido'  = tiene llamada Y minuta
    //   'parcial'   = tiene llamada O minuta, pero no ambos
    //   'pendiente' = no tiene ninguno
    contactosDetalleEstado() {
      return (canal) => {
        const tieneLlamada = (canal.llamadaCount || 0) > 0;
        const tieneMinuta = (canal.minutaCount || 0) > 0;
        if (tieneLlamada && tieneMinuta) return 'cumplido';
        if (!tieneLlamada && !tieneMinuta) return 'pendiente';
        return 'parcial';
      };
    },
    // Conteos por estado (sobre TODOS los canales, antes del filtro de búsqueda)
    contactosDetalleCumplidos() {
      return this.contactosDetalleData.filter(c => this.contactosDetalleEstado(c) === 'cumplido').length;
    },
    contactosDetalleParcial() {
      return this.contactosDetalleData.filter(c => this.contactosDetalleEstado(c) === 'parcial').length;
    },
    contactosDetallePendientes() {
      return this.contactosDetalleData.filter(c => this.contactosDetalleEstado(c) === 'pendiente').length;
    },
    contactosDetalleFiltrados() {
      const q = (this.contactosDetalleSearch || '').trim().toLowerCase();
      let list = this.contactosDetalleData;

      // Filtro de estado (chip Todos/Cumplidos/Parcial/Pendientes)
      const estadoFiltro = this.contactosDetalleFiltroEstado;
      if (estadoFiltro && estadoFiltro !== 'todos') {
        list = list.filter(c => this.contactosDetalleEstado(c) === estadoFiltro);
      }

      // Filtro de búsqueda
      if (q) {
        list = list.filter(c =>
          String(c.radio_name || '').toLowerCase().includes(q) ||
          String(c.client_name || '').toLowerCase().includes(q)
        );
      }

      return list;
    },

    cancionesMesSongs() {
      if (!this.cancionesMesData) return [];
      const list = this.cancionesMesTab === 'added'
        ? this.cancionesMesData.agregadas
        : this.cancionesMesData.eliminadas;
      return Array.isArray(list) ? list : [];
    },

    cancionesMesFiltrados() {
      const q = (this.cancionesMesSearch || '').trim().toLowerCase();
      let list = this.cancionesMesSongs;
      if (!q) return list;
      return list.filter(s =>
        String(s.name || '').toLowerCase().includes(q) ||
        String(s.artist || '').toLowerCase().includes(q)
      );
    },

    dupErrFiltered() {
      if (!this.duplicadosErrores) return [];
      const list = this.dupErrTab === 'duplicadas'
        ? this.duplicadosErrores.duplicadas
        : this.duplicadosErrores.sinTag;
      if (!Array.isArray(list)) return [];
      const q = (this.dupErrSearch || '').trim().toLowerCase();
      if (!q) return list;
      return list.filter(s =>
        String(s.name || '').toLowerCase().includes(q) ||
        String(s.artist || '').toLowerCase().includes(q)
      );
    },

    produccionLocucion() {
      const g = this.data?.produccion?.locucion?.global || {};
      return {
        meta: Number(g.meta ?? 0),
        spots_topados: Number(g.spots_topados ?? 0),
        spots_logrados: Number(g.spots_logrados ?? 0),
        eficiencia: (g.eficiencia === null || g.eficiencia === undefined) ? null : Number(g.eficiencia),
      };
    },

    spotsFueraMeta() {
      const g = this.data?.global || {};
      const total = Number(g.spots_fuera_meta_total || 0);
      const detalle = Array.isArray(g.spots_fuera_meta_detalle)
        ? g.spots_fuera_meta_detalle
            .map((item) => ({
              categoria: String(item?.categoria || '').trim(),
              spots: Number(item?.spots || 0),
            }))
            .filter((item) => item.categoria && item.spots > 0)
        : [];

      const norm = (value) => String(value || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      const liner = detalle
        .filter((item) => norm(item.categoria) === 'liner')
        .reduce((acc, item) => acc + item.spots, 0);

      const sello = detalle
        .filter((item) => norm(item.categoria) === 'sello de marca')
        .reduce((acc, item) => acc + item.spots, 0);

      return {
        total,
        detalle,
        liner,
        sello,
      };
    },

    locucionPersonas() {
      const personas = this.locucionPersonasData?.personas;
      return Array.isArray(personas) ? personas : [];
    },

    iaPersonas() {
      const personas = this.data?.produccion?.ia?.personas;
      return Array.isArray(personas) ? personas : [];
    },

    productorPersonas() {
      const personas = this.data?.produccion?.productores?.personas;
      return Array.isArray(personas) ? personas : [];
    },
    productorSpotsTotal() {
      return this.productorPersonas.reduce((s, p) => s + (Number(p.spots_logrados) || 0), 0);
    },

    conectados() {
      const c = this.data?.conectados || {};
      return {
        promedio_diario: Number(c.promedio_diario ?? 0),
        total_sucursales: Number(c.total_sucursales ?? 0),
        eficiencia: (c.eficiencia === null || c.eficiencia === undefined) ? null : Number(c.eficiencia),
        dias_con_datos: Number(c.dias_con_datos ?? 0),
        total_dias_mes: Number(c.total_dias_mes ?? 0),
      };
    },

    canalesConLlamadas() {
      return (this.data?.canales || []).filter(c => (c.llamadas ?? 0) > 0).length;
    },

    canalesConMinutas() {
      return (this.data?.canales || []).filter(c => (c.minutas ?? 0) > 0).length;
    },

    contactoLlamadasRatio() {
      const g = this.data?.global || {};
      const total = Number(g.canales_requieren_contacto)
        || Number(g.canales_en_global) || 1;
      return this.canalesConLlamadas / total;
    },

    contactoMinutasRatio() {
      const g = this.data?.global || {};
      const total = Number(g.canales_requieren_contacto)
        || Number(g.canales_en_global) || 1;
      return this.canalesConMinutas / total;
    },

    desgloseCompleto() {
      const prod = this.productorPersonas.map(p => ({ nombre: p.user_name, spots_logrados: p.spots_logrados, participacion: p.participacion, tipo: 'Productor' }));
      const loc  = this.locucionPersonas.map(p  => ({ nombre: p.host_name,  spots_logrados: p.spots_logrados, participacion: p.participacion, tipo: 'Locutor' }));
      const ia   = this.iaPersonas.map(p        => ({ nombre: p.host_name,  spots_logrados: p.spots_logrados, participacion: p.participacion, tipo: 'IA' }));
      return [...loc, ...ia, ...prod];
    },

    desgloseVisible() {
      return this.desgloseCompleto.filter(r => this.rolesVisibles.includes(r.tipo));
    },

    musKpi() {
      const d = this.musicalizacionData;
      if (!d) return null;
      return {
        source: d.source || null,
        global: d.global || {},
        canales: d.canales || [],
        tops_list: Array.isArray(d.tops_list) ? d.tops_list : [],
      };
    },

    musCanalesDetalle() {
      if (!this.musKpi || !Array.isArray(this.musKpi.canales)) return [];

      const asTs = (v) => {
        if (!v) return null;
        const t = new Date(v).getTime();
        return Number.isNaN(t) ? null : t;
      };

      const base = this.musicalizacionData?.canales || [];
      const filtradosTipo = this.mostrarTodosCanalesMus
        ? base.slice()
        : base.filter((r) => Number(r.playlists_actualizadas || 0) === 0);

      const q = (this.musFiltroTexto || '').trim().toLowerCase();
      const filtrados = !q
        ? filtradosTipo
        : filtradosTipo.filter((r) =>
          String(r.radio_name || '').toLowerCase().includes(q) ||
          String(r.stream || '').toLowerCase().includes(q)
        );

      filtrados.sort((a, b) => {
        const aUpd = Number(a.playlists_actualizadas || 0) > 0;
        const bUpd = Number(b.playlists_actualizadas || 0) > 0;
        if (aUpd !== bUpd) return aUpd ? 1 : -1;

        const aTs = asTs(a.last_update_at);
        const bTs = asTs(b.last_update_at);
        if (aTs === null && bTs === null) return 0;
        if (aTs === null) return -1;
        if (bTs === null) return 1;
        return aTs - bTs;
      });

      return filtrados;
    },

    canalDetallePlaylistsFiltradas() {
      if (!this.canalDetalleData || !Array.isArray(this.canalDetalleData.playlists)) return [];
      let list = this.canalDetalleData.playlists;
      const q = (this.canalDetalleSearch || '').trim().toLowerCase();
      if (q) list = list.filter(p => String(p.name || '').toLowerCase().includes(q));
      if (this.canalFiltroEstado === 'actualizadas') list = list.filter(p => p.actualizada);
      else if (this.canalFiltroEstado === 'pendientes') list = list.filter(p => !p.actualizada);
      if (this.canalFiltroCambios === 'min5') list = list.filter(p => (p.changes || 0) >= 5);
      else if (this.canalFiltroCambios === 'menos5') list = list.filter(p => (p.changes || 0) < 5);
      return list;
    },

    playlistsDetalleFiltradas() {
      if (!Array.isArray(this.playlistsDetalleData)) return [];
      let list = this.playlistsDetalleData;
      const q = (this.playlistsDetalleSearch || '').trim().toLowerCase();
      if (q) list = list.filter(p => String(p.name || '').toLowerCase().includes(q));
      if (this.playlistsFiltroEstado === 'actualizadas') list = list.filter(p => p.actualizada);
      else if (this.playlistsFiltroEstado === 'pendientes') list = list.filter(p => !p.actualizada);
      if (this.playlistsFiltroCambios === 'min5') list = list.filter(p => (p.changes || 0) >= 5);
      else if (this.playlistsFiltroCambios === 'menos5') list = list.filter(p => (p.changes || 0) < 5);
      return list;
    },

    lastUpdatedLabel() {
      if (!this.lastUpdated) return null;
      const h = String(this.lastUpdated.getHours()).padStart(2, '0');
      const m = String(this.lastUpdated.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    },

    isMesEnCurso() {
      return this.mes === this.mesMax;
    },        avanceMes() {
            if (!this.isMesEnCurso) return 1;
            const now = new Date();
            const day = now.getDate();
            const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
            if (!daysInMonth) return 1;
            const ratio = day / daysInMonth;
            return Math.max(0, Math.min(1, ratio));
        },

        asesorPrimerNombre() {
            if (!this.asesorSeleccionado) return '';
            const nombre = gf.get('globalAsesorName') || '';
            return nombre ? nombre.split(' ')[0] : '';
        },

        capacidadBarClass() {
            const pct = this.data?.uso_capacidad || 0;
            if (pct >= 80) return 'kpi-bar-green';
            if (pct >= 50) return 'kpi-bar-yellow';
            return 'kpi-bar-red';
        },

        tituloSeccionGlobal() {
            return 'Global';
        },

        sectionLoading() {
            // True con threshold de 300ms cuando se está recargando datos
            // pero ya había datos previos (cambio de filtro o mes).
            // El delay evita flash del shimmer en respuestas rápidas (Redis).
            return this.sectionLoadingDelayed && this.data !== null;
        },
    },

  watch: {
    loading(val) {
      if (val) {
        // Cuando empieza a cargar (cambio de filtro/mes), esperar 150ms
        // antes de mostrar el shimmer overlay para evitar flash en respuestas rápidas.
        this.sectionLoadingTimer = setTimeout(() => {
          this.sectionLoadingDelayed = true;
        }, 150);
      } else {
        // Cuando termina la carga, limpiar timer y ocultar shimmer inmediatamente
        clearTimeout(this.sectionLoadingTimer);
        this.sectionLoadingTimer = null;
        this.sectionLoadingDelayed = false;
      }
    },

    mes() {
      if (this.desglosadaVisible && this.produccionDesglosada) {
        this.produccionDesglosada = null;
        this.$nextTick(() => this.cargarDesglosada());
      }
    },

  },

  beforeUnmount() {
    clearTimeout(this.refreshStatusTimer);
    clearTimeout(this.sectionLoadingTimer);
    clearInterval(this.conectadosTimer);
    clearInterval(this.conectadosTickerTimer);
    if (this._unsubFilter) this._unsubFilter();
    this.unbindBackToTopScroll();
  },

  mounted() {

    this.asesorSeleccionado = gf.get('globalAsesorId');
    this._unsubFilter = gf.onChange(() => {
      this.asesorSeleccionado = gf.get('globalAsesorId');
      this.cargar(false);
      this.cargarConectadosAhora();
    });
    this.cargar();
    this.cargarConectadosAhora();
    this.conectadosTimer = setInterval(() => this.cargarConectadosAhora(), 30000);
    this.conectadosTickerTimer = setInterval(() => { this.conectadosTicker++; }, 1000);
    this.$nextTick(() => {
      this.backToTopScrollTarget = this.resolveScrollTarget();
      this.bindBackToTopScroll();
      this.handleBackToTopVisibility();
    });
  },

  methods: {
    normalizarMesValor(value) {
      const val = String(value || '').trim();
      return /^\d{4}-\d{2}$/.test(val) ? val : null;
    },

    clampMes(value) {
      const mes = this.normalizarMesValor(value);
      if (!mes) return this.mesMax;
      if (mes > this.mesMax) return this.mesMax;
      return mes;
    },

    toggleDesglosada() {
      this.desglosadaVisible = !this.desglosadaVisible;
      if (this.desglosadaVisible && !this.produccionDesglosada) {
        this.cargarDesglosada();
      }
    },

    async cargarDesglosada() {
      try {
        const token = localStorage.getItem('token');
        const res = await axiosInstance.post('/api/kpi_ops_produccion_desglosada', {
          token,
          month: this.mes,
        });
        if (res.data?.success) {
          this.produccionDesglosada = res.data;
        }
      } catch (e) {
        this.produccionDesglosada = null;
      }
    },

    async abrirDesgloseDetalle(event) {
      const nombre = event.data?.nombre;
      if (!nombre) return;
      this.desgloseDetalleVisible = true;
      this.desgloseDetalleNombre = nombre;
      this.desgloseDetalleCargando = true;
      this.desgloseDetalleError = null;
      this.desgloseDetalleData = null;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_produccion_desglosada_detalle', {
          token: localStorage.getItem('token'),
          month: this.mes,
          agrupacion_nombre: nombre,
        });
        if (res.data?.success) {
          this.desgloseDetalleData = res.data;
        } else {
          this.desgloseDetalleError = res.data?.error || 'Error al cargar detalle';
        }
      } catch {
        this.desgloseDetalleError = 'Error de conexión';
      }
      this.desgloseDetalleCargando = false;
    },

    async cargarConectadosAhora() {
      try {
        const token = localStorage.getItem('token');
        const res = await axiosInstance.get('/api/kpi_ops_conectados_ahora', {
          params: {
            token,
            operator_id: this.asesorSeleccionado ? Number(this.asesorSeleccionado) : null,
          },
        });
        const body = res && res.data ? res.data : {};
        const payload = (body && typeof body.data === 'object' && body.data !== null)
          ? body.data
          : body;

        const isOk = Boolean(body.success || body.ok || !body.error);
        if (!isOk || !payload || typeof payload !== 'object') {
          return;
        }

        const totalAhora = Number(
          payload.total ?? payload.conectados_ahora ?? payload.connected_now ?? 0
        );

        this.conectadosAhora = {
          total: Number.isFinite(totalAhora) ? totalAhora : 0,
          total_hoy: Number(payload.total_hoy ?? payload.today_total ?? 0),
          total_sucursales: Number(payload.total_sucursales ?? 0),
          actualizado_en: payload.actualizado_en || payload.timestamp || payload.updated_at || new Date().toISOString(),
          canales: Array.isArray(payload.canales) ? payload.canales : [],
        };
      } catch (e) {
        // Silently fail - old data persists
      }
    },

    conectadosProximoRefresh() {
      if (!this.conectadosAhora?.actualizado_en) return '—';
      const ts = new Date(this.conectadosAhora.actualizado_en).getTime();
      if (Number.isNaN(ts)) return '—';
      const secondsSinceUpdate = Math.max(0, Math.floor((Date.now() - ts) / 1000));
      const remaining = Math.max(0, 30 - secondsSinceUpdate);
      return remaining + 's';
    },

    estadoClase(label) {
      if (!label) return '';
      if (label.includes('Programado')) return 'tdm-badge--green';
      if (label.includes('Esperando')) return 'tdm-badge--amber';
      return 'tdm-badge--neutral';
    },

    copiarAlPortapapeles(texto, id) {
      navigator.clipboard.writeText(texto).then(() => {
        this.copiedId = id;
        setTimeout(() => {
          if (this.copiedId === id) this.copiedId = null;
        }, 1200);
      }).catch(() => {});
    },

    async cargarTemporadaDetalle() {
      this.temporadaDetalleLoading = true;
      this.temporadaDetalleSearch = '';
      try {
        const token = localStorage.getItem('token');
        const res = await axiosInstance.post('/api/kpi_ops_temporada_detalle', {
          token,
          month: this.mes,
        });
        const body = res && res.data ? res.data : {};
        const payload = (body && typeof body.data === 'object' && body.data !== null)
          ? body.data
          : body;
        if (body.success || body.ok) {
          this.temporadaDetalle = Array.isArray(payload.spots) ? payload.spots : [];
        } else {
          this.temporadaDetalle = [];
        }
      } catch (e) {
        this.temporadaDetalle = [];
      } finally {
        this.temporadaDetalleLoading = false;
      }
    },

    exportarTemporadaCSV() {
      const rows = this.temporadaDetalle;
      if (!rows.length) return;
      const header = 'Solicitud ID,Solicitud,Spot ID,Spot,Estado,Registro';
      const lines = rows.map(r =>
        [
          r.request_id,
          `"${r.request_name || ''}"`,
          r.spot_id,
          `"${r.spot_name || ''}"`,
          `"${r.status_label || ''}"`,
          r.fecha || '',
        ].join(',')
      );
      const csv = [header, ...lines].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `genericos_temporada_${this.mes}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },

    abrirTemporadaDetalle() {
      this.showTemporadaModal = true;
      this.cargarTemporadaDetalle();
    },

    abrirTopDetalle(top) {
      if (!top || !Array.isArray(top.songs_added) || !Array.isArray(top.songs_removed)) return;
      this.topDetalleTop = top;
      this.topDetalleTab = 'added';
      this.topDetalleSearch = '';
      this.showTopDetalleModal = true;
    },

    abrirCanalDetalle(row) {
      if (!row || !Array.isArray(row.playlists)) return;
      this.canalDetalleData = row;
      this.showCanalDetalleModal = true;
    },

    abrirPlaylistsDetalle() {
      const canales = this.musKpi?.canales;
      if (!Array.isArray(canales) || !canales.length) return;
      const map = new Map();
      for (const c of canales) {
        if (!Array.isArray(c.playlists)) continue;
        for (const p of c.playlists) {
          if (!p.id && p.id !== 0) continue;
          const prev = map.get(p.id);
          const changes = p.changes || 0;
          const act = p.actualizada === true;
          if (!prev || changes > (prev.changes || 0) || (changes === (prev.changes || 0) && act && !prev.actualizada)) {
            map.set(p.id, {
              id: p.id,
              name: p.name || '—',
              changes,
              actualizada: act,
              last_change_at: p.last_change_at || prev?.last_change_at || null,
            });
          }
        }
      }
      this.playlistsDetalleData = Array.from(map.values());
      this.showPlaylistsDetalleModal = true;
    },

    async abrirPlaylistsVideoDetalle() {
      this.playlistsDetalleData = [];
      this.showPlaylistsDetalleModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_video_playlists_detalle', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const canales = Array.isArray(res.data?.canales) ? res.data.canales : [];
        const map = new Map();
        for (const c of canales) {
          if (!Array.isArray(c.playlists)) continue;
          for (const p of c.playlists) {
            if (!p.id && p.id !== 0) continue;
            const prev = map.get(p.id);
            const changes = p.changes || 0;
            const act = p.actualizada === true;
            if (!prev || changes > (prev.changes || 0) || (changes === (prev.changes || 0) && act && !prev.actualizada)) {
              map.set(p.id, {
                id: p.id,
                name: p.name || '—',
                changes,
                actualizada: act,
                last_change_at: p.last_change_at || prev?.last_change_at || null,
              });
            }
          }
        }
        this.playlistsDetalleData = Array.from(map.values());
      } catch (e) {
        this.playlistsDetalleData = [];
      }
    },

    async abrirPlaylistDetalle(pl) {
      if (!pl || !pl.id) return;
      const month = this.mes;
      this.playlistDetalleData = null;
      this.playlistDetalleTab = 'added';
      this.playlistDetalleSearch = '';
      this.playlistDetalleLoading = true;
      this.showPlaylistDetalleModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_playlist_detalle', {
          playlist_id: pl.id,
          month,
          token: localStorage.getItem('token'),
        });
        const d = res.data || {};
        this.playlistDetalleData = {
          playlist_name: d.playlist_name || pl.name,
          songs_added: Array.isArray(d.songs_added) ? d.songs_added : [],
          songs_removed: Array.isArray(d.songs_removed) ? d.songs_removed : [],
          songs_catalog: Array.isArray(d.songs_catalog) ? d.songs_catalog : [],
        };
      } catch (e) {
        this.playlistDetalleData = { playlist_name: pl.name, songs_added: [], songs_removed: [], songs_catalog: [] };
      } finally {
        this.playlistDetalleLoading = false;
      }
    },

    async abrirPlaylistsNuevas() {
      this.playlistsNuevasData = [];
      this.playlistsNuevasSearch = '';
      this.playlistsNuevasLoading = true;
      this.showPlaylistsNuevasModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_playlists_nuevas', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const all = Array.isArray(res.data?.playlists) ? res.data.playlists : [];
        this.playlistsNuevasData = all.filter(p => p.es_video !== true);
      } catch (e) {
        this.playlistsNuevasData = [];
      } finally {
        this.playlistsNuevasLoading = false;
      }
    },

    async abrirCancionesMes() {
      this.cancionesMesData = null;
      this.cancionesMesSearch = '';
      this.cancionesMesTab = 'added';
      this.cancionesMesLoading = true;
      this.showCancionesMesModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_canciones_mes', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const d = res.data || {};
        this.cancionesMesData = {
          agregadas: Array.isArray(d.agregadas) ? d.agregadas : [],
          eliminadas: Array.isArray(d.eliminadas) ? d.eliminadas : [],
          totalAgregadas: Number(d.total_agregadas) || 0,
          totalEliminadas: Number(d.total_eliminadas) || 0,
        };
      } catch (e) {
        this.cancionesMesData = { agregadas: [], eliminadas: [], totalAgregadas: 0, totalEliminadas: 0 };
      } finally {
        this.cancionesMesLoading = false;
      }
    },

    async abrirVideoPlaylistsDetalle() {
      this.videoPlaylistsDetalleData = [];
      this.videoPlaylistsDetalleSearch = '';
      this.videoDetalleExpandedStream = null;
      this.videoPlaylistsDetalleLoading = true;
      this.showVideoPlaylistsDetalleModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_video_playlists_detalle', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        this.videoPlaylistsDetalleData = Array.isArray(res.data?.canales) ? res.data.canales : [];
      } catch (e) {
        this.videoPlaylistsDetalleData = [];
      } finally {
        this.videoPlaylistsDetalleLoading = false;
      }
    },

    async abrirVideoPlaylistsNuevas() {
      this.videoPlaylistsNuevasData = [];
      this.videoPlaylistsNuevasSearch = '';
      this.videoPlaylistsNuevasLoading = true;
      this.showVideoPlaylistsNuevasModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_playlists_nuevas', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const all = Array.isArray(res.data?.playlists) ? res.data.playlists : [];
        this.videoPlaylistsNuevasData = all.filter(p => p.es_video === true);
      } catch (e) {
        this.videoPlaylistsNuevasData = [];
      } finally {
        this.videoPlaylistsNuevasLoading = false;
      }
    },

    async abrirVideoCancionesMes() {
      this.videoCancionesMesData = null;
      this.videoCancionesMesSearch = '';
      this.videoCancionesMesTab = 'added';
      this.videoCancionesMesLoading = true;
      this.showVideoCancionesMesModal = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_video_canciones_mes', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const d = res.data || {};
        this.videoCancionesMesData = {
          agregadas: Array.isArray(d.agregadas) ? d.agregadas : [],
          eliminadas: Array.isArray(d.eliminadas) ? d.eliminadas : [],
          totalAgregadas: Number(d.total_agregadas) || 0,
          totalEliminadas: Number(d.total_eliminadas) || 0,
        };
      } catch (e) {
        this.videoCancionesMesData = { agregadas: [], eliminadas: [], totalAgregadas: 0, totalEliminadas: 0 };
      } finally {
        this.videoCancionesMesLoading = false;
      }
    },

    abrirCanalesActualizadosDetalle() {
      this.canalesActualizadosSearch = '';
      this.canalesActualizadosFiltro = 'todas';
      this.showCanalesActualizadosModal = true;
    },

    async abrirContactosDetalle() {
      this.contactosDetalleData = [];
      this.contactosDetalleSearch = '';
      this.contactosDetalleFiltroEstado = 'todos';
      this.contactosExpandedId = null;
      this.contactosDetalleLoading = true;
      this.showContactosDetalleModal = true;
      try {
        // Indexar data de canal (logo, color, tipo) por radio_id
        const canalInfo = {};
        (this.data?.canales || []).forEach(c => {
          canalInfo[c.radio_id] = {
            mobileimage: c.mobileimage || '',
            color: c.color || '',
            radio_type: c.radio_type || '',
            radio_name: c.radio_name,
            client_name: c.client_name || '',
          };
        });

        const res = await axiosInstance.post('/api/client_contact_records_list', {
          month: this.mes,
          token: localStorage.getItem('token'),
        });
        const items = Array.isArray(res.data?.items) ? res.data.items : [];
        const map = {};

        // Paso 1: agregar solo los canales que requieren contacto (requiere_llamada=true).
        //   Esto excluye canales como SERVICIOS ADICIONALES (cliente 108) que tienen
        //   requiere_contacto=false en la BD y por tanto no deben contar como "pendientes".
        //   `this.data.canales` ya viene filtrado por asesor si hay uno seleccionado,
        //   gracias a que la carga inicial pasa operator_id al endpoint kpi_ops_mes.
        (this.data?.canales || [])
          .filter(c => c.requiere_llamada !== false)
          .forEach(c => {
            map[c.radio_id] = {
              radio_id: c.radio_id,
              radio_name: c.radio_name,
              client_name: c.client_name || '',
              mobileimage: c.mobileimage || '',
              color: c.color || '',
              radio_type: c.radio_type || '',
              llamada: null,
              llamadaCount: 0,
              minuta: null,
              minutaCount: 0,
              registros: [],
            };
          });

        // Paso 2: enriquecer con los registros de contacto existentes.
        items.forEach(r => {
          if (!map[r.radio_id]) return; // Sanity: ignorar si no está en data.canales
          const row = map[r.radio_id];
          row.registros.push(r);
          if (r.contact_type === 'llamada') {
            row.llamadaCount++;
            if (!row.llamada) row.llamada = r;
          } else {
            row.minutaCount++;
            if (!row.minuta) row.minuta = r;
          }
        });

        this.contactosDetalleData = Object.values(map)
          .sort((a, b) => a.radio_name.localeCompare(b.radio_name));
      } catch (e) {
        this.contactosDetalleData = [];
      } finally {
        this.contactosDetalleLoading = false;
      }
    },

    formatContactoFecha(isoStr) {
      if (!isoStr) return '—';
      const d = new Date(isoStr);
      return d.toLocaleString('es-MX', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    },

    exportarTopCSV() {
      const top = this.topDetalleTop;
      if (!top) return;
      const isTag = this.topDetalleTab === 'tag_changes';
      const tipo = isTag ? 'Cambio por tag' : (this.topDetalleTab === 'added' ? 'Agregada' : 'Eliminada');
      const rows = this.topDetalleSongs;
      if (!rows.length) return;
      const header = isTag
        ? 'TOP 50,Canción,Artista,Tags Anteriores,Tags Nuevos,Tipo,Fecha'
        : 'TOP 50,Canción,Artista,Tipo,Fecha';
      const lines = rows.map(r => {
        if (isTag) {
          return [
            `"${top.name}"`,
            `"${r.name || ''}"`,
            `"${r.artist || ''}"`,
            `"${r.old_tags || ''}"`,
            `"${r.new_tags || ''}"`,
            r._tipo === 'entrada' ? 'Entrada' : 'Salida',
            r._fecha || '',
          ].join(',');
        }
        return [
          `"${top.name}"`,
          `"${r.name || ''}"`,
          `"${r.artist || ''}"`,
          tipo,
          this.topDetalleTab === 'added' ? (r.created_at || '') : (r.deleted_at || ''),
        ].join(',');
      });
      const csv = [header, ...lines].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `top50_${top.name.replace(/[^a-zA-Z0-9]/g, '_')}_${this.mes}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },

        abrirModalConectados() {
      this.showConectadosModal = true;
    },
    desplazarMes(value, delta) {
      const mes = this.normalizarMesValor(value) || this.mesMax;
      const parts = mes.split('-');
      const year = Number(parts[0]);
      const monthIndex = Number(parts[1]) - 1;
      if (Number.isNaN(year) || Number.isNaN(monthIndex)) {
        return this.mesMax;
      }

      const dt = new Date(year, monthIndex, 1);
      dt.setMonth(dt.getMonth() + delta);

      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      return `${y}-${m}`;
    },

    onMesInput(event) {
      const raw = event && event.target ? event.target.value : this.mes;
      const normalizado = this.normalizarMesValor(raw);
      if (!normalizado) return;

      const clamped = this.clampMes(normalizado);
      if (this.mes !== clamped) {
        this.mes = clamped;
      }
      if (event && event.target && event.target.value !== clamped) {
        event.target.value = clamped;
      }
    },

    onMesChange(event) {
      const raw = this.mes || (event && event.target ? event.target.value : '');
      const clamped = this.clampMes(raw);
      this.mes = clamped;
      if (event && event.target && event.target.value !== clamped) {
        event.target.value = clamped;
      }
      return this.cargar(false);
    },

    onMesKeydown(event) {
      const key = event.key;
      let delta = null;

      if (key === 'ArrowUp') delta = 1;
      if (key === 'ArrowDown') delta = -1;
      if (key === 'PageUp') delta = 12;
      if (key === 'PageDown') delta = -12;

      if (delta === null) return;

      event.preventDefault();

      const raw = this.mes || (event && event.target ? event.target.value : this.mesMax);
      const next = this.clampMes(this.desplazarMes(raw, delta));
      if (this.mes === next) return;

      this.mes = next;
      if (event && event.target) {
        event.target.value = next;
      }

      this.cargar(false);
    },

    toggleTipoFiltro(tipo) {
      const actual = [...this.tipoFiltrosSeleccionados];
      const tiene = actual.includes(tipo);

      if (tipo === 'todos' || tipo === 'activos') {
        this.tipoFiltrosSeleccionados = tiene ? [] : [tipo];
        return;
      }

      let next = actual.filter((t) => t !== 'todos');
      if (tiene) {
        next = next.filter((t) => t !== tipo);
      } else {
        next.push(tipo);
      }

      this.tipoFiltrosSeleccionados = next.length ? next : ['todos'];
    },

    normalizarTipoRadio(tipo) {
      return String(tipo || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },

    esTipoActivo(tipoNorm) {
      return !['demo', 'intercambio', 'cortesia'].includes(
        String(tipoNorm || '').toLowerCase().trim()
      );
    },

    tieneMetasSpots(canal) {
      const metaSpots = Number(canal && canal.meta_spots != null ? canal.meta_spots : 0);
      const metaIa = Number(canal && canal.obligation_ia != null ? canal.obligation_ia : 0);
      return metaSpots > 0 || metaIa > 0;
    },

    abrirEditorCapacidad() {
      this.capacidadForm.capacidad = this.data?.capacidad_instalada || 1000;
      this.capacidadDialogVisible = true;
    },

    async guardarCapacidad() {
      this.guardandoCapacidad = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_capacidad_instalada_save', {
          token: localStorage.getItem('token'),
          periodo: this.mes,
          capacidad: this.capacidadForm.capacidad,
        });
        if (res.data?.success) {
          this.capacidadDialogVisible = false;
          this.$toast.add({ severity:'success', summary:'Guardado', detail:'Capacidad actualizada', life:3000 });
          this.cargar(true);
        } else {
          this.$toast.add({ severity:'error', summary:'Error', detail: res.data?.error || 'Error al guardar capacidad', life:5000 });
        }
      } catch (e) {
        this.$toast.add({ severity:'error', summary:'Error', detail: 'Error de conexión', life:5000 });
      } finally {
        this.guardandoCapacidad = false;
      }
    },

    formatDateTime(val) {
      if (!val) return null;
      const dt = (val instanceof Date) ? val : new Date(val);
      if (Number.isNaN(dt.getTime())) return null;
      return dt.toLocaleString('es-MX', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    formatDateOnly(val) {
      if (!val) return null;
      const dt = (val instanceof Date) ? val : new Date(val);
      if (Number.isNaN(dt.getTime())) return null;
      return dt.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    },

    resolveTopUpdatedAt(top) {
      if (!top || typeof top !== 'object') return null;
      return top.updated_at || top.updatedAt || top.fecha_actualizacion || top.last_update || null;
    },

    topUpdateLabel(top) {
      const updatedAt = this.formatDateOnly(this.resolveTopUpdatedAt(top));
      const lastChangeAt = this.formatDateOnly(top?.last_change_at);
      const configUpdatedAt = this.formatDateOnly(top?.config_updated_at);

      return updatedAt || lastChangeAt || configUpdatedAt || (this.mes ? 'Periodo ' + this.mes : null) || 'Sin fecha';
    },

    topChangeHint(top) {
      const changes = Number(top?.changes || 0);
      if (!top?.actualizada && changes > 0 && changes < 5) {
        return `(${changes} de 5 cambios)`;
      }
      return '';
    },

    topRowClass(top) {
      if (top?.actualizada) return 'kpi-top-row-ok';
      return Number(top?.changes || 0) > 0 ? 'kpi-top-row-parcial' : 'kpi-top-row-pendiente';
    },

    topStatusIconClass(top) {
      if (top?.actualizada) return 'pi pi-check kpi-top-check-ok';
      return Number(top?.changes || 0) > 0 ? 'pi pi-clock kpi-top-check-warn' : 'pi pi-minus-circle kpi-top-check-no';
    },

    async cargar(isRefresh) {
      // Prevenir llamadas concurrentes: si ya hay una carga en progreso,
      // marcamos pendiente para re-ejecutar al final (evita perder cambios de filtro)
      if (this.cargandoEnProgreso) {
        this.cargarPendiente = true;
        return;
      }
      this.cargandoEnProgreso = true;
      this.cargarPendiente = false;

      try {

      if (isRefresh) {
        // Refresco: mantener datos visibles, aplicar indicador sutil
        this.refreshing = true;
        this.prevSnapshot = this._snapshotKpi();
      } else {
        // Carga inicial o cambio de mes: limpiar estado
        this.loading = true;
        this.locucionPersonasData = null;
        this.errorPersonas = null;
        this.musicalizacionData = null;
        this.musicalizacionUpdatedAt = null;
        this.duplicadosErrores = null;
        this.duplicadosErroresError = null;
      }
      this.error = null;
      this.desgloseExpandido = false;
      this.musExpandido = false;
      this.mostrarTodosCanalesMus = true;
      this.musFiltroTexto = '';

      // Duración mínima perceptible en refresco (evita flash <100ms en caché)
      const minDelay = isRefresh
        ? new Promise(r => setTimeout(r, 480))
        : Promise.resolve();

      const opId = this.asesorSeleccionado ? Number(this.asesorSeleccionado) : null;

      // 1. Datos principales: Global + Producción
      try {
        const [res] = await Promise.all([
          axiosInstance.post('/api/kpi_ops_mes', {
            token: localStorage.getItem('token'),
            month: this.mes,
            with_extended: false,
            include_unscheduled: this.includeUnscheduled,
            operator_id: opId,
          }),
          minDelay,
        ]);
        if (res.data.success || res.data.ok) {
          if (isRefresh) {
            const changed = this._detectChanges(res.data);
            this.refreshStatus = changed ? 'changed' : 'same';
            clearTimeout(this.refreshStatusTimer);
            this.refreshStatusTimer = setTimeout(() => { this.refreshStatus = null; }, 3000);
          }
          this.data = res.data;
          // Reiniciar asesor si el seleccionado ya no existe en los datos
          if (this.asesorSeleccionado && this.data?.canales) {
            const existe = this.data.canales.some(c => Number(c.operator_id) === Number(this.asesorSeleccionado));
            if (!existe) {
              this.asesorSeleccionado = null;
              gf.clear('globalAsesorId');
              gf.clear('globalAsesorName');
            }
          }
          this.lastUpdated = new Date();
        } else {
          this.error = res.data.message || res.data.msg || 'Error al cargar KPI.';
        }
      } catch {
        this.error = 'Error de conexión al cargar KPI.';
      } finally {
        this.loading = false;
        this.refreshing = false;
      }

      // 2+3+4. Musicalización, Personas y Duplicados: paralelas, siempre (incluido refresco)
      await Promise.all([
        this.cargarMusicalizacion(),
        this.cargarPersonas(),
        this.cargarDuplicadosErrores(),
      ]);

      } finally {
        this.cargandoEnProgreso = false;
        // Si hubo un cambio de filtro durante la carga, re-ejecutar
        if (this.cargarPendiente) {
          this.cargarPendiente = false;
          await this.cargar(false);
        }
      }
    },

    actualizar() {
      return this.cargar(true);
    },

    async invalidarCache() {
      this.invalidando = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_invalidar_cache', {
          token: localStorage.getItem('token'),
          month: this.mes,
        });
        if (res.data.success || res.data.ok) {
          await this.cargar(false);
        } else {
          alert(res.data.message || res.data.msg || 'Error al invalidar caché.');
        }
      } catch {
        alert('Error de conexión al invalidar caché.');
      } finally {
        this.invalidando = false;
      }
    },

    async invalidarCacheOperador() {
      if (!this.asesorSeleccionado) return;
      this.invalidandoOp = true;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_invalidar_cache_operador', {
          token: localStorage.getItem('token'),
          month: this.mes,
          operator_id: Number(this.asesorSeleccionado),
        });
        if (res.data.success || res.data.ok) {
          await this.cargar(false);
        } else {
          alert(res.data.message || res.data.msg || 'Error al invalidar caché del operador.');
        }
      } catch {
        alert('Error de conexión al invalidar caché del operador.');
      } finally {
        this.invalidandoOp = false;
      }
    },


    _snapshotKpi() {
      if (!this.data) return null;
      const g = this.data.global || {};
      const c = this.data.conectados || {};
      return {
        eficiencia_spots: g.eficiencia_spots,
        eficiencia_ia: g.eficiencia_ia,
        llamadas: g.llamadas,
        minutas: g.minutas,
        conectados_eficiencia: c.eficiencia ?? null,
      };
    },

    _detectChanges(newData) {
      if (!this.prevSnapshot) return null;
      const g = newData.global || {};
      const c = newData.conectados || {};
      return (
        this.prevSnapshot.eficiencia_spots !== g.eficiencia_spots ||
        this.prevSnapshot.eficiencia_ia    !== g.eficiencia_ia    ||
        this.prevSnapshot.llamadas         !== g.llamadas         ||
        this.prevSnapshot.minutas          !== g.minutas ||
        this.prevSnapshot.conectados_eficiencia !== (c.eficiencia ?? null)
      );
    },

    formatPct(val) {
      if (val === null || val === undefined) return '—';
      const pct = Number((val * 100).toFixed(2));
      return `${pct}%`;
    },

    claseEficiencia(val) {
      if (val === null || val === undefined) return 'kpi-eff-neutral';
      if (val >= 0.8) return 'kpi-eff-green';
      if (val >= 0.5) return 'kpi-eff-yellow';
      return 'kpi-eff-red';
    },

    heroClass(val, options = {}) {
      if (val === null || val === undefined) return '';

      const fixed = options.fixed || { green: 0.8, yellow: 0.5 };
      if (!options.currentMonthProgressive || !this.isMesEnCurso) {
        if (val >= fixed.green) return 'kpi-mus-hero-green';
        if (val >= fixed.yellow) return 'kpi-mus-hero-yellow';
        return 'kpi-mus-hero-red';
      }

      const expected = this.avanceMes;
      const greenThreshold = Math.min(1, expected);
      const yellowThreshold = Math.max(0, expected * 0.85);

      if (val >= greenThreshold) return 'kpi-mus-hero-green';
      if (val >= yellowThreshold) return 'kpi-mus-hero-yellow';
      return 'kpi-mus-hero-neutral';
    },

    heroProgressHint(val, options = {}) {
      if (val === null || val === undefined) return 'Sin dato';
      const cls = this.heroClass(val, { ...options, currentMonthProgressive: true });
      if (cls === 'kpi-mus-hero-green') return 'Adelantado';
      if (cls === 'kpi-mus-hero-yellow') return 'En línea';
      if (cls === 'kpi-mus-hero-neutral') return 'Rezago';
      return 'Rezago';
    },

    async cargarMusicalizacion() {
      this.loadingMus = true;
      this.errorMus = null;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_musicalizacion', {
          token: localStorage.getItem('token'),
          month: this.mes,
          operator_id: this.asesorSeleccionado ? Number(this.asesorSeleccionado) : null,
        });
        if (res.data.success || res.data.ok) {
          this.musicalizacionData = res.data;
          this.musicalizacionUpdatedAt = new Date();
        } else {
          this.errorMus = res.data.message || res.data.msg || 'Error al cargar musicalización.';
        }
      } catch {
        this.errorMus = 'Error de conexión al cargar musicalización.';
      } finally {
        this.loadingMus = false;
      }
    },

    async cargarDuplicadosErrores() {
      this.duplicadosErroresLoading = true;
      this.duplicadosErroresError = null;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_duplicados_errores', {
          token: localStorage.getItem('token'),
        });
        const d = res.data || {};
        if (d.success) {
          this.duplicadosErrores = {
            repetidas:  Number(d.repetidas) || 0,
            notags:     Number(d.notags) || 0,
            duplicadas: Array.isArray(d.lista_duplicadas) ? d.lista_duplicadas : [],
            sinTag:     Array.isArray(d.lista_sin_tag)    ? d.lista_sin_tag    : [],
          };
        } else {
          this.duplicadosErroresError = d.message || 'Error al cargar duplicados.';
        }
      } catch {
        this.duplicadosErroresError = 'Error de conexión al cargar duplicados.';
      } finally {
        this.duplicadosErroresLoading = false;
      }
    },

    abrirDuplicadosErrores(tab) {
      this.dupErrTab = tab || 'duplicadas';
      this.dupErrSearch = '';
      this.showDuplicadosErroresModal = true;
    },

    async cargarPersonas() {
      this.loadingPersonas = true;
      this.errorPersonas = null;
      try {
        const res = await axiosInstance.post('/api/kpi_ops_locucion_personas', {
          token: localStorage.getItem('token'),
          month: this.mes,
          operator_id: this.asesorSeleccionado ? Number(this.asesorSeleccionado) : null,
        });
        if (res.data.success || res.data.ok) {
          this.locucionPersonasData = res.data;
        } else {
          this.errorPersonas = res.data.message || res.data.msg || 'Error al cargar desglose.';
        }
      } catch {
        this.errorPersonas = 'Error de conexión al cargar desglose por locutor.';
      } finally {
        this.loadingPersonas = false;
      }
    },

    getLogoUrl(row) {
      if (!row?.mobileimage) return null;
      return 'https://vybroo.net/images' + row.mobileimage;
    },

    logoBackgroundStyle(row) {
      if (!row?.color) return { backgroundColor: '#a1a1aa' };
      const hex = String(row.color).replace(/^#/, '').toLowerCase();
      if (/^[0-9a-f]{3}$/.test(hex) || /^[0-9a-f]{6}$/.test(hex)) {
        return { backgroundColor: '#' + hex };
      }
      return { backgroundColor: '#a1a1aa' };
    },

    toggleSeccion(key) {
      this.collapsed[key] = !this.collapsed[key];
    },

    quitarFiltroAsesor() {
      if (!this.asesorSeleccionado) return;
      this.$confirm.require({
        message: 'Se mostrarán los datos de todos los asesores.',
        header: '¿Quitar filtro de asesor?',
        icon: 'pi pi-filter-slash',
        acceptLabel: 'Quitar filtro',
        rejectLabel: 'Cancelar',
        accept: () => {
          gf.clearBatch(['globalAsesorId', 'globalAsesorName']);
        },
      });
    },

    // ── Scroll-to-top ──

    resolveScrollTarget() {
      // Handle fragment components: this.$el may be null/undefined
      // when component has multiple root nodes (fragment)
      let current = this.$el && this.$el.nodeType === 1 
        ? this.$el 
        : (this.$el?.parentElement || document.querySelector('.media-page') || document.querySelector('.kpi-mus-hero'));
      while (current && current !== document.body) {
        if (current.nodeType !== 1) { current = current.parentElement; continue; }
        const style = window.getComputedStyle(current);
        const hasScrollableOverflow = /(auto|scroll)/.test(style.overflowY || '');
        if (hasScrollableOverflow && current.scrollHeight > current.clientHeight) {
          return current;
        }
        current = current.parentElement;
      }
      return window;
    },

    bindBackToTopScroll() {
      const target = this.backToTopScrollTarget || window;
      target.addEventListener('scroll', this.handleBackToTopVisibility, { passive: true });
    },

    unbindBackToTopScroll() {
      const target = this.backToTopScrollTarget || window;
      target.removeEventListener('scroll', this.handleBackToTopVisibility);
    },

    scrollToSection(sectionId) {
      const el = document.getElementById(sectionId);
      if (!el) return;

      // Expandir sección si está contraída antes de hacer scroll
      const key = sectionId.replace(/^section-/, '');
      if (this.collapsed[key]) {
        this.collapsed[key] = false;
      }

      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },

    handleBackToTopVisibility() {
      const target = this.backToTopScrollTarget || window;
      const top = target === window
        ? (window.scrollY || window.pageYOffset || 0)
        : target.scrollTop;
      this.showBackToTop = top > 200;
    },

    scrollToTop() {
      const target = this.backToTopScrollTarget || window;
      if (target === window) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      target.scrollTo({ top: 0, behavior: 'smooth' });
    },

  },
};
</script>

<style>
@import "@/assets/media-module-base.css";

/* Hero diferenciado para KPI Operaciones */
.page-ind-kpi {
  --media-hero-bg: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);
  --media-hero-border: rgba(147, 197, 253, 0.5);
  --media-hero-bg-dark: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(24, 24, 27, 0.98) 100%);
  --media-hero-border-dark: rgba(59, 130, 246, 0.2);
}

/* KPI Conectados - Live indicator */
.kpi-live-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  margin-left: 6px;
  animation: kpi-live-pulse 2s ease-in-out infinite;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

@keyframes kpi-live-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4); }
  50% { opacity: 0.7; box-shadow: 0 0 0 6px rgba(16, 185, 129, 0); }
}

.kpi-mus-hero-dimmed {
  opacity: 0.5;
}

/* Toolbar */
.page-ind-kpi .ind-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.page-ind-kpi .ind-toolbar-field {
  width: 220px;
  flex-shrink: 0;
}

.page-ind-kpi .ind-filter-input {
  width: 100%;
  height: 42px;
  border-radius: 10px;
}

.page-ind-kpi .ind-toolbar-right {
  display: flex;
  align-items: flex-end;
  padding-bottom: 2px;
}

/* Month input */
.page-ind-kpi .ind-month-input {
  height: 42px;
  width: 100%;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.55);
  background: rgba(255, 255, 255, 0.96);
  padding: 0 10px;
  font-size: 0.9rem;
  color: inherit;
  outline: none;
}

.dark .page-ind-kpi .ind-month-input {
  border-color: rgba(113, 113, 122, 0.48);
  background: rgba(24, 24, 27, 0.75);
  color: #e4e4e7;
  color-scheme: dark;
}

/* Error */
.kpi-error-box {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid rgba(239, 68, 68, 0.4);
  background: rgba(254, 226, 226, 0.5);
  color: #b91c1c;
  font-size: 0.9rem;
}

.dark .kpi-error-box {
  background: rgba(69, 10, 10, 0.4);
  color: #fca5a5;
  border-color: rgba(239, 68, 68, 0.3);
}

/* Sección */
.kpi-section {
  position: relative;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 12px;
  padding: 16px 18px;
  transition: border-color 0.25s ease, border-left-width 0.25s ease, background 0.25s ease;
}

/* ── Shimmer overlay en secciones durante recarga ── */
.kpi-section--loading::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 12px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.55) 50%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: kpi-loading-shimmer 1.8s ease-in-out infinite;
  z-index: 2;
  pointer-events: none;
}

.dark .kpi-section--loading::before {
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.08) 50%,
    transparent 100%
  );
  background-size: 200% 100%;
}

@keyframes kpi-loading-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Loading dot animado en títulos ── */
.kpi-loading-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6366f1;
  animation: kpi-loading-dot-pulse 1.4s ease-in-out infinite;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

.dark .kpi-loading-dot {
  background: #818cf8;
}

/* ── Icono de sección con estilo ── */
.kpi-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  font-size: 0.82rem;
  flex-shrink: 0;
}

/* Variante live: pulso suave para indicar tiempo real */
.kpi-section-icon--live {
  animation: kpi-icon-live-pulse 3s ease-in-out infinite;
}

@keyframes kpi-icon-live-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(0.92); }
}

@keyframes kpi-loading-dot-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.35; transform: scale(0.6); }
}

.dark .kpi-section {
  background: rgba(24, 24, 27, 0.5);
  border-color: rgba(82, 82, 91, 0.4);
}

.kpi-section-pending {
  opacity: 0.65;
}

/* ── Cuerpo de sección (overflow:visible para no recortar tooltips) ── */
.kpi-section-body {
  overflow: visible;
}

/* ── Sección colapsada: reducir padding inferior ── */
.kpi-section-collapsed {
  padding-top: 10px;
  padding-bottom: 10px;
}
#app .kpi-section-collapsed .kpi-section-title {
  margin-bottom: 0;
}
.kpi-section-collapsed .kpi-section-header {
  margin-bottom: 0;
}

/* ── Skeleton page (carga en frío) ── */
.kpi-skel-page {
  animation: kpi-skel-fade-in 0.4s ease-out;
}

@keyframes kpi-skel-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.kpi-skel-loading-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: #94a3b8;
  letter-spacing: 0.02em;
}

.dark .kpi-skel-loading-label {
  color: #52525b;
}

/* Fade-in suave del contenido real al terminar skeletons */
.kpi-skel-page + div > .kpi-section,
.kpi-page-content {
  animation: kpi-content-fade-in 0.35s ease-out;
}

@keyframes kpi-content-fade-in {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}

.kpi-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 8px;
}

.kpi-section-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.kpi-table-search {
  width: 240px;
  height: 34px;
  border-radius: 8px;
}

.kpi-type-filters {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.kpi-inline-controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: nowrap;
}

.kpi-inline-controls-search {
  flex: 0 0 420px;
  min-width: 260px;
  max-width: 460px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.kpi-inline-controls-search-input {
  position: relative;
  flex: 1 1 auto;
}

.kpi-inline-controls-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 auto;
  min-width: 0;
}

.kpi-search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.76rem;
  color: #94a3b8;
  pointer-events: none;
  z-index: 1;
}

.kpi-table-search-with-icon {
  width: 100%;
}

.kpi-table-search-with-icon.p-inputtext {
  padding-left: 2rem;
}

.kpi-table-search-with-icon.p-inputtext::placeholder {
  color: #94a3b8;
}

.kpi-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #475569;
  background: rgba(255, 255, 255, 0.94);
  cursor: pointer;
  user-select: none;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.kpi-type-chip input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.kpi-type-chip::before {
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.45);
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.kpi-type-chip:hover {
  border-color: rgba(59, 130, 246, 0.45);
  background: rgba(239, 246, 255, 0.9);
  color: #1e3a8a;
}

.kpi-type-chip--todos:hover {
  border-color: rgba(59, 130, 246, 0.45);
  background: rgba(239, 246, 255, 0.92);
  color: #1e3a8a;
}

.kpi-type-chip--activos:hover {
  border-color: rgba(34, 197, 94, 0.45);
  background: rgba(236, 253, 245, 0.94);
  color: #166534;
}

.kpi-type-chip--demos:hover {
  border-color: rgba(107, 114, 128, 0.45);
  background: rgba(243, 244, 246, 0.96);
  color: #374151;
}

.kpi-type-chip--intercambio:hover {
  border-color: rgba(234, 179, 8, 0.5);
  background: rgba(254, 249, 195, 0.96);
  color: #92400e;
}

.kpi-type-chip--cortesia:hover {
  border-color: rgba(168, 85, 247, 0.5);
  background: rgba(243, 232, 255, 0.96);
  color: #6b21a8;
}

.kpi-type-chip.is-active {
  border-color: rgba(59, 130, 246, 0.6);
  background: rgba(219, 234, 254, 0.9);
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(147, 197, 253, 0.4);
}

.kpi-type-chip--todos.is-active {
  border-color: rgba(59, 130, 246, 0.6);
  background: rgba(219, 234, 254, 0.9);
  color: #1d4ed8;
  box-shadow: inset 0 0 0 1px rgba(147, 197, 253, 0.4);
}

.kpi-type-chip--activos.is-active {
  border-color: rgba(34, 197, 94, 0.6);
  background: rgba(220, 252, 231, 0.95);
  color: #15803d;
  box-shadow: inset 0 0 0 1px rgba(134, 239, 172, 0.45);
}

.kpi-type-chip--demos.is-active {
  border-color: rgba(107, 114, 128, 0.6);
  background: rgba(243, 244, 246, 0.95);
  color: #4b5563;
  box-shadow: inset 0 0 0 1px rgba(209, 213, 219, 0.55);
}

.kpi-type-chip--intercambio.is-active {
  border-color: rgba(234, 179, 8, 0.65);
  background: rgba(254, 249, 195, 0.95);
  color: #a16207;
  box-shadow: inset 0 0 0 1px rgba(253, 224, 71, 0.45);
}

.kpi-type-chip--cortesia.is-active {
  border-color: rgba(168, 85, 247, 0.62);
  background: rgba(243, 232, 255, 0.95);
  color: #7e22ce;
  box-shadow: inset 0 0 0 1px rgba(216, 180, 254, 0.45);
}

.kpi-type-chip.is-active::before {
  background: #3b82f6;
  transform: scale(1.1);
}

.kpi-type-chip--activos.is-active::before { background: #22c55e; }
.kpi-type-chip--demos.is-active::before { background: #6b7280; }
.kpi-type-chip--intercambio.is-active::before { background: #eab308; }
.kpi-type-chip--cortesia.is-active::before { background: #a855f7; }

.dark .kpi-type-chip {
  border-color: rgba(113, 113, 122, 0.48);
  background: rgba(24, 24, 27, 0.75);
  color: #d4d4d8;
}

.dark .kpi-type-chip::before {
  background: rgba(113, 113, 122, 0.75);
}

.dark .kpi-type-chip:hover {
  border-color: rgba(96, 165, 250, 0.55);
  background: rgba(30, 41, 59, 0.85);
  color: #bfdbfe;
}

.dark .kpi-type-chip--todos:hover {
  border-color: rgba(96, 165, 250, 0.55);
  background: rgba(30, 41, 59, 0.9);
  color: #bfdbfe;
}

.dark .kpi-type-chip--activos:hover {
  border-color: rgba(74, 222, 128, 0.58);
  background: rgba(20, 83, 45, 0.36);
  color: #dcfce7;
}

.dark .kpi-type-chip--demos:hover {
  border-color: rgba(156, 163, 175, 0.58);
  background: rgba(63, 63, 70, 0.36);
  color: #e4e4e7;
}

.dark .kpi-type-chip--intercambio:hover {
  border-color: rgba(250, 204, 21, 0.6);
  background: rgba(113, 63, 18, 0.4);
  color: #fef3c7;
}

.dark .kpi-type-chip--cortesia:hover {
  border-color: rgba(192, 132, 252, 0.6);
  background: rgba(88, 28, 135, 0.38);
  color: #f3e8ff;
}

.dark .kpi-type-chip:nth-of-type(1):hover {
  border-color: rgba(96, 165, 250, 0.55);
  background: rgba(30, 41, 59, 0.88);
  color: #bfdbfe;
}

.dark .kpi-type-chip:nth-of-type(2):hover {
  border-color: rgba(74, 222, 128, 0.55);
  background: rgba(20, 83, 45, 0.32);
  color: #dcfce7;
}

.dark .kpi-type-chip:nth-of-type(3):hover {
  border-color: rgba(156, 163, 175, 0.55);
  background: rgba(63, 63, 70, 0.34);
  color: #e4e4e7;
}

.dark .kpi-type-chip:nth-of-type(4):hover {
  border-color: rgba(250, 204, 21, 0.58);
  background: rgba(113, 63, 18, 0.36);
  color: #fef3c7;
}

.dark .kpi-type-chip:nth-of-type(5):hover {
  border-color: rgba(192, 132, 252, 0.58);
  background: rgba(88, 28, 135, 0.34);
  color: #f3e8ff;
}

.dark .kpi-type-chip.is-active {
  border-color: rgba(96, 165, 250, 0.75);
  background: rgba(30, 58, 138, 0.3);
  color: #dbeafe;
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.35);
}

.dark .kpi-type-chip--activos.is-active {
  border-color: rgba(74, 222, 128, 0.75);
  background: rgba(20, 83, 45, 0.28);
  color: #dcfce7;
  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.35);
}

.dark .kpi-type-chip--demos.is-active {
  border-color: rgba(156, 163, 175, 0.72);
  background: rgba(63, 63, 70, 0.3);
  color: #e4e4e7;
  box-shadow: inset 0 0 0 1px rgba(113, 113, 122, 0.34);
}

.dark .kpi-type-chip--intercambio.is-active {
  border-color: rgba(250, 204, 21, 0.75);
  background: rgba(113, 63, 18, 0.32);
  color: #fef3c7;
  box-shadow: inset 0 0 0 1px rgba(234, 179, 8, 0.38);
}

.dark .kpi-type-chip--cortesia.is-active {
  border-color: rgba(192, 132, 252, 0.75);
  background: rgba(88, 28, 135, 0.3);
  color: #f3e8ff;
  box-shadow: inset 0 0 0 1px rgba(168, 85, 247, 0.35);
}

.dark .kpi-type-chip.is-active::before {
  background: #60a5fa;
}

.dark .kpi-type-chip--activos.is-active::before { background: #4ade80; }
.dark .kpi-type-chip--demos.is-active::before { background: #9ca3af; }
.dark .kpi-type-chip--intercambio.is-active::before { background: #facc15; }
.dark .kpi-type-chip--cortesia.is-active::before { background: #c084fc; }



.kpi-metaspots-filter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.74rem;
  font-weight: 600;
  color: #475569;
  background: rgba(255, 255, 255, 0.94);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease;
}

.kpi-metaspots-filter input {
  margin: 0;
}

.kpi-metaspots-filter.is-active {
  border-color: rgba(14, 165, 233, 0.55);
  background: rgba(224, 242, 254, 0.95);
  color: #0c4a6e;
}

.dark .kpi-metaspots-filter {
  border-color: rgba(113, 113, 122, 0.48);
  background: rgba(24, 24, 27, 0.75);
  color: #d4d4d8;
}

.dark .kpi-metaspots-filter.is-active {
  border-color: rgba(56, 189, 248, 0.65);
  background: rgba(12, 74, 110, 0.35);
  color: #e0f2fe;
}

.kpi-inline-count {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3px 0 10px;
  line-height: 1;
  opacity: 0.72;
  font-size: 0.74rem;
  color: #94a3b8;
}

.dark .kpi-inline-count {
  color: #71717a;
}

@media (max-width: 768px) {
  .kpi-section-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .kpi-inline-controls {
    align-items: stretch;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .kpi-inline-controls-search {
    width: 100%;
    max-width: none;
    min-width: 0;
    flex: 1 1 auto;
    flex-wrap: wrap;
  }

  .kpi-inline-controls-filters {
    width: 100%;
    justify-content: flex-start;
  }

  .kpi-table-search {
    width: 100%;
  }

  .kpi-type-filters {
    width: 100%;
  }
}

.kpi-section-title {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1e293b;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.dark .kpi-section-title {
  color: #d4d4d8;
}

/* Override margin when title is inside header */
.kpi-section-header .kpi-section-title {
  margin-bottom: 0;
}

/* Cards globales */
.kpi-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 220px));
  justify-content: start;
  gap: 12px;
}

.kpi-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 10px;
  padding: 10px 12px;
  min-height: 94px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: rgba(248, 250, 252, 0.9);
}

.dark .kpi-card {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}

.kpi-card-lg {
  grid-column: span 2;
  min-height: 102px;
}

.kpi-card-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #475569;
}

.dark .kpi-card-label {
  color: #a1a1aa;
}

.kpi-card-value {
  font-size: clamp(1.05rem, 1.5vw, 1.35rem);
  font-weight: 800;
  line-height: 1.1;
  overflow-wrap: anywhere;
  color: #0f172a;
}

.kpi-card-lg .kpi-card-value {
  font-size: clamp(1.2rem, 1.9vw, 1.55rem);
}

.dark .kpi-card-value {
  color: #f4f4f5;
}

.kpi-card-sub {
  font-size: 0.78rem;
  color: #64748b;
}

.kpi-card-sub-muted {
  font-size: 0.74rem;
  color: #94a3b8;
}

.kpi-card-sub-progressive {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 0.72rem;
}

.kpi-out-meta-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  width: fit-content;
  max-width: 100%;
  margin: 12px auto 0;
  justify-content: center;
  padding: 8px 10px;
  border: 1px dashed rgba(251, 146, 60, 0.35);
  border-radius: 10px;
  background: rgba(255, 251, 235, 0.72);
}

.kpi-out-meta-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9a3412;
}

.kpi-out-meta-label .pi {
  font-size: 0.7rem;
}

.kpi-out-meta-items {
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
}

.kpi-out-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(251, 146, 60, 0.3);
  background: rgba(255, 237, 213, 0.7);
  border-radius: 999px;
  padding: 3px 9px;
}

.kpi-out-meta-chip-name {
  font-size: 0.72rem;
  color: #9a3412;
}

.kpi-out-meta-chip-value {
  font-size: 0.78rem;
  font-weight: 700;
  color: #7c2d12;
}

.kpi-out-meta-total {
  font-size: 0.76rem;
  color: #b45309;
}

.dark .kpi-card-sub {
  color: #71717a;
}

.dark .kpi-card-sub-muted {
  color: #52525b;
}

.dark .kpi-card-sub-progressive {
  color: #71717a;
}

.dark .kpi-out-meta-row {
  border-color: rgba(251, 146, 60, 0.25);
  background: rgba(67, 20, 7, 0.34);
}

.dark .kpi-out-meta-label {
  color: #fdba74;
}

.dark .kpi-out-meta-chip {
  border-color: rgba(251, 146, 60, 0.28);
  background: rgba(67, 20, 7, 0.56);
}

.dark .kpi-out-meta-chip-name {
  color: #fdba74;
}

.dark .kpi-out-meta-chip-value {
  color: #fed7aa;
}

.dark .kpi-out-meta-total {
  color: #fdba74;
}

/* Eficiencia colores en tarjetas */
.kpi-card.kpi-eff-green  { border-color: rgba(52, 211, 153, 0.5);  background: rgba(236, 253, 245, 0.9); }
.kpi-card.kpi-eff-yellow { border-color: rgba(251, 191, 36, 0.5);  background: rgba(255, 251, 235, 0.9); }
.kpi-card.kpi-eff-red    { border-color: rgba(239, 68, 68, 0.4);   background: rgba(254, 242, 242, 0.9); }
.kpi-card.kpi-eff-neutral { border-color: rgba(148, 163, 184, 0.3); }

.dark .kpi-card.kpi-eff-green  { border-color: rgba(52, 211, 153, 0.35); background: rgba(6, 30, 20, 0.5); }
.dark .kpi-card.kpi-eff-yellow { border-color: rgba(251, 191, 36, 0.35); background: rgba(40, 30, 5, 0.5); }
.dark .kpi-card.kpi-eff-red    { border-color: rgba(239, 68, 68, 0.3);   background: rgba(40, 8, 8, 0.5); }

.kpi-card.kpi-eff-green  .kpi-card-value { color: #065f46; }
.kpi-card.kpi-eff-yellow .kpi-card-value { color: #92400e; }
.kpi-card.kpi-eff-red    .kpi-card-value { color: #991b1b; }

.dark .kpi-card.kpi-eff-green  .kpi-card-value { color: #6ee7b7; }
.dark .kpi-card.kpi-eff-yellow .kpi-card-value { color: #fcd34d; }
.dark .kpi-card.kpi-eff-red    .kpi-card-value { color: #fca5a5; }

/* Badge de eficiencia en tabla */
.kpi-pct-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  width: fit-content;
  text-align: center;
  white-space: nowrap;
  border-radius: 6px;
  padding: 2px 7px;
  font-size: 0.8rem;
  font-weight: 600;
}

.kpi-pct-badge.kpi-eff-green  { background: rgba(209, 250, 229, 0.8); color: #065f46; }
.kpi-pct-badge.kpi-eff-yellow { background: rgba(254, 243, 199, 0.8); color: #92400e; }
.kpi-pct-badge.kpi-eff-red    { background: rgba(254, 226, 226, 0.8); color: #991b1b; }
.kpi-pct-badge.kpi-eff-neutral { background: rgba(244, 244, 245, 0.7); color: #71717a; }

.dark .kpi-pct-badge.kpi-eff-green  { background: rgba(6, 30, 20, 0.7);  color: #6ee7b7; }
.dark .kpi-pct-badge.kpi-eff-yellow { background: rgba(40, 30, 5, 0.7);  color: #fcd34d; }
.dark .kpi-pct-badge.kpi-eff-red    { background: rgba(40, 8, 8, 0.7);   color: #fca5a5; }
.dark .kpi-pct-badge.kpi-eff-neutral { background: rgba(39, 39, 42, 0.6); color: #a1a1aa; }

/* Densidad compacta en tabla principal de canales */
.kpi-spots-table .p-datatable-thead > tr > th {
  padding: 0.42rem 0.5rem;
  font-size: 0.76rem;
}

.kpi-spots-table .p-datatable-tbody > tr > td {
  padding: 0.36rem 0.5rem;
}

.kpi-spots-table .p-datatable-tbody > tr > td .text-xs {
  line-height: 1.1;
}

/* Detalle musicalizacion alineado con la tabla principal */
.kpi-expand-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
}

.kpi-expand-actions-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.kpi-expand-actions-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.kpi-mus-detail-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.kpi-mus-search {
  width: min(260px, 100%);
}

.kpi-mus-detail-link {
  font-size: 0.875rem;
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.kpi-mus-detail-link:hover {
  color: #1e40af;
}

.dark .kpi-mus-detail-link {
  color: #60a5fa;
}

.dark .kpi-mus-detail-link:hover {
  color: #93c5fd;
}

.kpi-mus-canales-table .p-datatable-tbody > tr > td {
  vertical-align: middle;
}

/* Toggle excluidos */
.kpi-toggle-label {
  display: flex;
  align-items: center;
  font-size: 0.82rem;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
}

.dark .kpi-toggle-label {
  color: #a1a1aa;
}

/* Badge próximamente */
.kpi-badge-soon {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: rgba(148, 163, 184, 0.2);
  color: #64748b;
  border-radius: 4px;
  padding: 2px 6px;
}

.dark .kpi-badge-soon {
  background: rgba(82, 82, 91, 0.3);
  color: #a1a1aa;
}

/* Empty */
.kpi-empty-msg {
  font-size: 0.88rem;
  color: #94a3b8;
  padding: 16px 0 4px;
}

.dark .kpi-empty-msg {
  color: #52525b;
}

@media (max-width: 640px) {
  .kpi-cards-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .kpi-card-lg {
    grid-column: span 1;
    min-height: 94px;
  }
}

/* ── Musicalización: Hero KPI ── */
.kpi-mus-hero {
  border-radius: 8px;
  padding: 10px 14px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #fff;
}
.dark .kpi-mus-hero {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}
.kpi-mus-hero-green  { border-color: rgba(52, 211, 153, 0.6)  !important; background: #f0fdf4 !important; }
.kpi-mus-hero-yellow { border-color: rgba(251, 191, 36, 0.6)  !important; background: #fffbeb !important; }
.kpi-mus-hero-red    { border-color: rgba(239, 68, 68, 0.5)   !important; background: #fef2f2 !important; }
.kpi-mus-hero-neutral { border-color: rgba(148, 163, 184, 0.5) !important; background: #fff !important; }
.dark .kpi-mus-hero-green  { border-color: rgba(52, 211, 153, 0.35) !important; background: rgba(6, 30, 20, 0.5)   !important; }
.dark .kpi-mus-hero-yellow { border-color: rgba(251, 191, 36, 0.35) !important; background: rgba(40, 30, 5, 0.5)   !important; }
.dark .kpi-mus-hero-red    { border-color: rgba(239, 68, 68, 0.3)   !important; background: rgba(40, 8, 8, 0.5)    !important; }
.dark .kpi-mus-hero-neutral { border-color: rgba(113, 113, 122, 0.45) !important; background: rgba(39, 39, 42, 0.62) !important; }

.kpi-mus-hero-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.kpi-mus-hero-left {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.kpi-mus-hero-pct {
  font-size: 1.6rem;
  font-weight: 900;
  line-height: 1.1;
  color: #0f172a;
}
.dark .kpi-mus-hero-pct { color: #f4f4f5; }
.kpi-mus-hero-green  .kpi-mus-hero-pct { color: #065f46; }
.kpi-mus-hero-yellow .kpi-mus-hero-pct { color: #92400e; }
.kpi-mus-hero-red    .kpi-mus-hero-pct { color: #991b1b; }
.kpi-mus-hero-neutral .kpi-mus-hero-pct { color: #334155; }
.dark .kpi-mus-hero-green  .kpi-mus-hero-pct { color: #6ee7b7; }
.dark .kpi-mus-hero-yellow .kpi-mus-hero-pct { color: #fcd34d; }
.dark .kpi-mus-hero-red    .kpi-mus-hero-pct { color: #fca5a5; }
.dark .kpi-mus-hero-neutral .kpi-mus-hero-pct { color: #cbd5e1; }

.kpi-mus-bar-wrap {
  height: 6px;
  border-radius: 99px;
  background: rgba(148, 163, 184, 0.2);
  overflow: hidden;
  margin-bottom: 6px;
}
.dark .kpi-mus-bar-wrap { background: rgba(82, 82, 91, 0.3); }
.kpi-mus-bar-fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.5s ease;
  background: #94a3b8;
}
.kpi-mus-hero-green  .kpi-mus-bar-fill { background: #34d399; }
.kpi-mus-hero-yellow .kpi-mus-bar-fill { background: #fbbf24; }
.kpi-mus-hero-red    .kpi-mus-bar-fill { background: #f87171; }
.kpi-mus-hero-neutral .kpi-mus-bar-fill { background: #94a3b8; }

/* ── Strip secundario ── */
.kpi-mus-strip {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #fff;
  overflow: hidden;
}
.dark .kpi-mus-strip {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}
.kpi-mus-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: 11px 14px;
}
.kpi-mus-stat-divider {
  width: 1px;
  background: rgba(148, 163, 184, 0.45);
  align-self: stretch;
}
.dark .kpi-mus-stat-divider { background: rgba(82, 82, 91, 0.45); }
.kpi-mus-stat-bar {
  height: 4px;
  border-radius: 2px;
  background: rgba(148, 163, 184, 0.15);
  margin-top: 3px;
  overflow: hidden;
}
.dark .kpi-mus-stat-bar {
  background: rgba(82, 82, 91, 0.25);
}
.kpi-mus-stat-bar-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.4s ease;
  min-width: 0;
}
.kpi-bar-green { background: #10b981; }
.kpi-bar-yellow { background: #f59e0b; }
.kpi-bar-red { background: #ef4444; }
.dark .kpi-bar-green { background: #34d399; }
.dark .kpi-bar-yellow { background: #fbbf24; }
.dark .kpi-bar-red { background: #f87171; }
.kpi-mus-stat-val {
  font-size: clamp(1rem, 1.4vw, 1.2rem);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
}
.dark .kpi-mus-stat-val { color: #f4f4f5; }
.kpi-mus-stat-sep {
  margin: 0 1px;
  font-weight: 300;
  opacity: 0.4;
}
.kpi-mus-val-green  { color: #065f46 !important; }
.kpi-mus-val-yellow { color: #92400e !important; }
.kpi-mus-val-red    { color: #991b1b !important; }
.dark .kpi-mus-val-green  { color: #6ee7b7 !important; }
.dark .kpi-mus-val-yellow { color: #fcd34d !important; }
.dark .kpi-mus-val-red    { color: #fca5a5 !important; }
.kpi-mus-stat-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #475569;
}
.dark .kpi-mus-stat-label { color: #a1a1aa; }
.kpi-mus-stat-sub {
  font-size: 0.72rem;
  color: #64748b;
}
.kpi-mus-val-neutral { color: #334155 !important; }
.dark .kpi-mus-val-neutral { color: #d4d4d8 !important; }
.kpi-capacidad-edit-btn {
  display: inline-flex; align-items: center; gap: 3px;
  margin-top: 4px; font-size: 0.7rem; font-weight: 500;
  color: #3b82f6; background: none; border: none; cursor: pointer;
  padding: 0; text-decoration: underline; text-underline-offset: 2px;
  opacity: 0.7; transition: opacity 0.15s;
}
.kpi-capacidad-edit-btn:hover { opacity: 1; }
.dark .kpi-mus-stat-sub { color: #52525b; }

/* ── Mes en curso ── */
.kpi-mes-en-curso-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0284c7;
  background: rgba(224, 242, 254, 0.7);
  border: 1px solid rgba(125, 211, 252, 0.5);
  border-radius: 8px;
  padding: 7px 16px;
  text-align: center;
}
.dark .kpi-mes-en-curso-banner {
  color: #38bdf8;
  background: rgba(12, 74, 110, 0.3);
  border-color: rgba(56, 189, 248, 0.2);
}
/* ── Filter chip interactivo en section titles ── */
.kpi-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 2px 8px 2px 6px;
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 999px;
  background: rgba(238, 242, 255, 0.55);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #6366f1;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  top: -0.5px;
  transition: border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease;
  user-select: none;
  -webkit-appearance: none;
  outline: none;
  line-height: 1.3;
}

.kpi-filter-chip:hover {
  border-color: rgba(99, 102, 241, 0.5);
  background: rgba(238, 242, 255, 0.8);
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
}

.kpi-filter-chip:active {
  background: rgba(238, 242, 255, 0.9);
}

.kpi-filter-chip .pi-filter {
  font-size: 0.62rem;
  opacity: 0.75;
}

.kpi-filter-chip-name {
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kpi-filter-chip-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0;
  overflow: hidden;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1;
  color: #818cf8;
  opacity: 0;
  transition: width 0.18s ease, opacity 0.18s ease, margin 0.18s ease;
  flex-shrink: 0;
}

.kpi-filter-chip:hover .kpi-filter-chip-close {
  width: 14px;
  opacity: 0.8;
  margin-left: 2px;
}

.kpi-filter-chip-close:hover {
  opacity: 1 !important;
  color: #ef4444;
}

.dark .kpi-filter-chip {
  border-color: rgba(129, 140, 248, 0.25);
  background: rgba(30, 41, 59, 0.5);
  color: #a5b4fc;
}

.dark .kpi-filter-chip:hover {
  border-color: rgba(129, 140, 248, 0.45);
  background: rgba(30, 41, 59, 0.7);
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.12);
}

.dark .kpi-filter-chip-close {
  color: #a5b4fc;
}

.dark .kpi-filter-chip-close:hover {
  color: #f87171;
}

/* ── Section filtered state (asesor activo) ── */
.kpi-section--filtered {
  background: rgba(238, 242, 255, 0.45);
  border-left: 3px solid rgba(99, 102, 241, 0.55);
  border-color: rgba(99, 102, 241, 0.2);
  box-shadow:
    0 0 0 1px rgba(99, 102, 241, 0.08);
}

.dark .kpi-section--filtered {
  background: rgba(30, 41, 59, 0.55);
  border-left: 3px solid rgba(129, 140, 248, 0.4);
  border-color: rgba(129, 140, 248, 0.15);
  box-shadow:
    0 0 0 1px rgba(129, 140, 248, 0.1);
}

/* ── Filter context inline en heroes (legacy / transitional) ── */
.kpi-filter-context {
  font-size: 0.68rem;
  color: #818cf8;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.dark .kpi-filter-context {
  color: #a5b4fc;
  opacity: 0.8;
}

.kpi-mus-live-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0284c7;
  background: rgba(224, 242, 254, 0.7);
  border: 1px solid rgba(125, 211, 252, 0.5);
  border-radius: 6px;
  padding: 3px 9px;
}
.dark .kpi-mus-live-badge {
  color: #38bdf8;
  background: rgba(12, 74, 110, 0.35);
  border-color: rgba(56, 189, 248, 0.25);
}
.kpi-mus-live-grid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Dual hero layout (Producción) ── */
.kpi-dual-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
@media (max-width: 640px) {
  .kpi-dual-hero {
    grid-template-columns: 1fr;
  }
}

/* ── Persona pills (Productores) ── */
.kpi-persona-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.kpi-persona-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(248, 250, 252, 0.9);
}
.dark .kpi-persona-pill {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}
.kpi-persona-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
}
.dark .kpi-persona-name { color: #d4d4d8; }
.kpi-persona-count {
  font-size: 0.88rem;
  font-weight: 800;
  color: #0f172a;
}
.dark .kpi-persona-count { color: #f4f4f5; }
.kpi-persona-pct {
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 500;
}
.kpi-mus-live-stat {
  flex: 1;
  min-width: 130px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: rgba(248, 250, 252, 0.9);
}
.dark .kpi-mus-live-stat {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}
.kpi-mus-live-add { border-color: rgba(52, 211, 153, 0.4) !important; }
.kpi-mus-live-del { border-color: rgba(239, 68, 68, 0.35) !important; }

/* ── Video subsección ── */
.kpi-video-subsection {
  padding-top: 4px;
}
.kpi-video-subsection-head {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(236, 72, 153, 0.15);
}
.dark .kpi-video-subsection-head {
  border-bottom-color: rgba(236, 72, 153, 0.1);
}
.kpi-video-subsection-title {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #be185d;
}

.kpi-integrity-subsection-title {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #f59e0b;
}
.dark .kpi-video-subsection-title {
  color: #f472b6;
}
.kpi-mus-stat--pending {
  opacity: 0.55;
}
.kpi-mus-stat--pending .kpi-mus-stat-val {
  color: #a1a1aa;
  font-size: 0.85rem;
}
.dark .kpi-mus-stat--pending .kpi-mus-stat-val {
  color: #52525b;
}

/* ── Video hero ── */
.kpi-video-hero {
  border-color: rgba(236, 72, 153, 0.4) !important;
  background: #fdf2f8 !important;
}
.dark .kpi-video-hero {
  border-color: rgba(236, 72, 153, 0.2) !important;
  background: rgba(76, 5, 42, 0.4) !important;
}
.kpi-video-hero.kpi-stat-clickable:hover {
  background: #fce7f3 !important;
}
.dark .kpi-video-hero.kpi-stat-clickable:hover {
  background: rgba(76, 5, 42, 0.55) !important;
}
.kpi-video-hero .kpi-mus-hero-pct {
  color: #be185d;
}
.dark .kpi-video-hero .kpi-mus-hero-pct {
  color: #f472b6;
}
.dark .kpi-mus-live-add { border-color: rgba(52, 211, 153, 0.25) !important; }
.dark .kpi-mus-live-del { border-color: rgba(239, 68, 68, 0.25) !important; }
/* ── TOPs visibles ── */
.kpi-tops-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.kpi-tops-head-left {
  display: flex;
  justify-content: center;
  width: 100%;
}

.kpi-tops-title {
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #94a3b8;
  text-align: center;
  margin: 0;
}

.dark .kpi-tops-title { color: #71717a; }

.kpi-tops-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.kpi-top-row {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(248, 250, 252, 0.9);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.kpi-top-row:hover {
  border-color: rgba(59, 130, 246, 0.35);
  background: rgba(239, 246, 255, 0.9);
}

.dark .kpi-top-row {
  background: rgba(39, 39, 42, 0.6);
  border-color: rgba(82, 82, 91, 0.45);
}

.dark .kpi-top-row:hover {
  border-color: rgba(96, 165, 250, 0.4);
  background: rgba(30, 41, 59, 0.75);
}

.kpi-top-row-ok {
  border-color: rgba(52, 211, 153, 0.35);
  background: rgba(236, 253, 245, 0.75);
}

.kpi-top-row-pendiente {
  border-color: rgba(148, 163, 184, 0.35);
  background: rgba(248, 250, 252, 0.9);
}

.kpi-top-row-parcial {
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(255, 251, 235, 0.85);
}

.dark .kpi-top-row-ok {
  border-color: rgba(52, 211, 153, 0.3);
  background: rgba(6, 30, 20, 0.45);
}

.dark .kpi-top-row-parcial {
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(66, 32, 6, 0.4);
}

.kpi-top-check-ok { color: #16a34a; flex-shrink: 0; }
.kpi-top-check-warn { color: #d97706; flex-shrink: 0; }
.kpi-top-check-no { color: #dc2626; flex-shrink: 0; }

.kpi-top-content {
  min-width: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.kpi-top-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-top-meta {
  font-size: 0.72rem;
  color: #94a3b8;
  line-height: 1.2;
  font-weight: 500;
}

.kpi-top-hint {
  margin-left: 4px;
  color: #b45309;
  font-weight: 600;
}

.dark .kpi-top-name { color: #d4d4d8; }
.dark .kpi-top-meta { color: #71717a; }
.dark .kpi-top-hint { color: #fbbf24; }

.kpi-top-divider {
  border-top: 1px dashed #e5e7eb;
  margin: 2px 0;
}

.dark .kpi-top-divider {
  border-top-color: rgba(82, 82, 91, 0.65);
}
/* ── Fórmulas editadas con mini-bar (reservado para uso futuro) ── */
.kpi-mus-live-num {
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1;
  color: #0f172a;
}
.dark .kpi-mus-live-num { color: #f4f4f5; }
.kpi-mus-live-add .kpi-mus-live-num { color: #065f46; }
.kpi-mus-live-del .kpi-mus-live-num { color: #991b1b; }
.dark .kpi-mus-live-add .kpi-mus-live-num { color: #6ee7b7; }
.dark .kpi-mus-live-del .kpi-mus-live-num { color: #fca5a5; }
.kpi-mus-live-of {
  font-size: 0.85rem;
  font-weight: 500;
  color: #94a3b8;
}
.kpi-mus-live-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}
.dark .kpi-mus-live-label { color: #a1a1aa; }
.kpi-mus-pending {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(241, 245, 249, 0.6);
  border: 1px dashed rgba(148, 163, 184, 0.4);
}
.dark .kpi-mus-pending {
  background: rgba(24, 24, 27, 0.4);
  border-color: rgba(82, 82, 91, 0.4);
}
.kpi-mus-pending-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94a3b8;
}
.kpi-mus-pending-item {
  font-size: 0.8rem;
  color: #94a3b8;
}
.kpi-mus-pending-sep {
  color: rgba(148, 163, 184, 0.5);
  font-size: 0.75rem;
}
@media (max-width: 640px) {
  .kpi-mus-strip { flex-direction: column; }
  .kpi-mus-stat-divider { width: 100%; height: 1px; }
  .kpi-mus-live-grid { flex-direction: column; }
  .kpi-mus-clocks-row { flex-direction: column; }
}

/* ── Animaciones de entrada ── */
@keyframes kpiSlideUp {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes kpiStatPop {
  from { opacity: 0; transform: scale(0.93); }
  to   { opacity: 1; transform: scale(1); }
}

/* Secciones: slide-up escalonado */
.kpi-section { animation: kpiSlideUp 0.38s ease both; }
.kpi-section:nth-child(1) { animation-delay: 0.04s; }
.kpi-section:nth-child(2) { animation-delay: 0.12s; }
.kpi-section:nth-child(3) { animation-delay: 0.22s; }
.kpi-section:nth-child(4) { animation-delay: 0.32s; }

/* Heroes: slide-up individual */
.kpi-mus-hero { animation: kpiSlideUp 0.38s ease both; }
.kpi-dual-hero .kpi-mus-hero:nth-child(1) { animation-delay: 0.08s; }
.kpi-dual-hero .kpi-mus-hero:nth-child(2) { animation-delay: 0.18s; }

/* Strip: stats en cascada */
.kpi-mus-strip .kpi-mus-stat { animation: kpiStatPop 0.30s ease both; }
.kpi-mus-strip .kpi-mus-stat:nth-child(1) { animation-delay: 0.06s; }
.kpi-mus-strip .kpi-mus-stat:nth-child(3) { animation-delay: 0.11s; }
.kpi-mus-strip .kpi-mus-stat:nth-child(5) { animation-delay: 0.16s; }
.kpi-mus-strip .kpi-mus-stat:nth-child(7) { animation-delay: 0.21s; }
.kpi-mus-strip .kpi-mus-stat:nth-child(9) { animation-delay: 0.26s; }

/* Persona pills: slide-up con stagger corto */
.kpi-persona-pill { animation: kpiSlideUp 0.30s ease both; }
.kpi-persona-pills .kpi-persona-pill:nth-child(1) { animation-delay: 0.06s; }
.kpi-persona-pills .kpi-persona-pill:nth-child(2) { animation-delay: 0.11s; }
.kpi-persona-pills .kpi-persona-pill:nth-child(3) { animation-delay: 0.16s; }
.kpi-persona-pills .kpi-persona-pill:nth-child(n+4) { animation-delay: 0.21s; }

/* Musicalización: fade del contenido loading → datos */
.kpi-fade-enter-active,
.kpi-fade-leave-active { transition: opacity 0.32s ease, transform 0.32s ease; }
.kpi-fade-enter,
.kpi-fade-leave-to { opacity: 0; transform: translateY(6px); }

/* Respetar preferencias del usuario */
@media (prefers-reduced-motion: reduce) {
  .kpi-section,
  .kpi-mus-hero,
  .kpi-mus-strip .kpi-mus-stat,
  .kpi-persona-pill { animation: none !important; }
  .kpi-fade-enter-active,
  .kpi-fade-leave-active { transition: none !important; }
  .kpi-refresh-bar::after { animation: none !important; }
}

/* ── Barra de progreso de refresco ── */
.kpi-refresh-bar {
  height: 3px;
  border-radius: 99px;
  overflow: hidden;
  background: transparent;
  transition: opacity 0.2s ease;
  opacity: 0;
}
.kpi-refresh-bar.kpi-refresh-bar-active {
  opacity: 1;
  background: rgba(148, 163, 184, 0.15);
}
.kpi-refresh-bar.kpi-refresh-bar-active::after {
  content: '';
  display: block;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, #3b82f6 35%, #93c5fd 60%, transparent 100%);
  animation: kpiBarSweep 1.1s ease-in-out infinite;
}
@keyframes kpiBarSweep {
  from { transform: translateX(-100%); }
  to   { transform: translateX(280%); }
}

/* ── Secciones durante refresco ── */
.kpi-sections-refreshing {
  opacity: 0.62;
  transition: opacity 0.25s ease;
  pointer-events: none;
}

/* ── Badge de estado de refresco ── */
.kpi-refresh-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  border-radius: 5px;
  padding: 1px 7px;
  white-space: nowrap;
}
.kpi-refresh-badge-new {
  background: rgba(209, 250, 229, 0.85);
  color: #065f46;
  border: 1px solid rgba(52, 211, 153, 0.35);
}
.dark .kpi-refresh-badge-new {
  background: rgba(6, 30, 20, 0.6);
  color: #6ee7b7;
  border-color: rgba(52, 211, 153, 0.25);
}
.kpi-refresh-badge-same {
  background: rgba(241, 245, 249, 0.85);
  color: #64748b;
  border: 1px solid rgba(148, 163, 184, 0.3);
}
.dark .kpi-refresh-badge-same {
  background: rgba(39, 39, 42, 0.5);
  color: #a1a1aa;
  border-color: rgba(82, 82, 91, 0.4);
}

/* ── Timestamp ── */
.kpi-last-updated {
  font-size: 0.68rem;
  color: #94a3b8;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}
.dark .kpi-last-updated { color: #52525b; }

/* ═══════════════════════════════════════
   COLLAPSIBLE SECTIONS
   ═══════════════════════════════════════ */

/* ── Quick-nav bar ── */
.kpi-quick-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.85rem 1.1rem;
  margin-bottom: 1.25rem;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  position: sticky;
  top: 0.6rem;
  z-index: 20;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.03);
}
.dark .kpi-quick-nav {
  background: rgba(24, 24, 27, 0.55);
  border-color: rgba(63, 63, 70, 0.45);
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.kpi-quick-nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.015em;
  color: #475569;
  background: white;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  white-space: nowrap;
  outline: none;
  user-select: none;
  -webkit-user-select: none;
  line-height: 1.1;
}

.kpi-quick-nav-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #0f172a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px) scale(1.02);
}

.kpi-quick-nav-btn:active {
  transform: translateY(0) scale(0.97);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dark .kpi-quick-nav-btn {
  color: #a1a1aa;
  background: rgba(39, 39, 42, 0.35);
  border-color: rgba(63, 63, 70, 0.35);
}

.dark .kpi-quick-nav-btn:hover {
  background: rgba(39, 39, 42, 0.65);
  border-color: rgba(113, 113, 122, 0.35);
  color: #f4f4f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px) scale(1.02);
}

.kpi-quick-nav-btn i {
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.kpi-quick-nav-btn:hover i {
  transform: scale(1.15);
}

.kpi-quick-nav-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.015em;
}

.kpi-quick-nav-btn[data-section="conectados"] {
  background: rgba(16,185,129,0.08);
  border-color: rgba(16,185,129,0.15);
}
.kpi-quick-nav-btn[data-section="conectados"]:hover {
  background: rgba(16,185,129,0.15);
  border-color: rgba(16,185,129,0.25);
}

.kpi-quick-nav-btn[data-section="global"] {
  background: rgba(59,130,246,0.08);
  border-color: rgba(59,130,246,0.15);
}
.kpi-quick-nav-btn[data-section="global"]:hover {
  background: rgba(59,130,246,0.15);
  border-color: rgba(59,130,246,0.25);
}

.kpi-quick-nav-btn[data-section="produccion"] {
  background: rgba(139,92,246,0.08);
  border-color: rgba(139,92,246,0.15);
}
.kpi-quick-nav-btn[data-section="produccion"]:hover {
  background: rgba(139,92,246,0.15);
  border-color: rgba(139,92,246,0.25);
}

.kpi-quick-nav-btn[data-section="musicalizacion"] {
  background: rgba(20,184,166,0.08);
  border-color: rgba(20,184,166,0.15);
}
.kpi-quick-nav-btn[data-section="musicalizacion"]:hover {
  background: rgba(20,184,166,0.15);
  border-color: rgba(20,184,166,0.25);
}

.kpi-quick-nav-btn[data-section="canales"] {
  background: rgba(245,158,11,0.08);
  border-color: rgba(245,158,11,0.15);
}
.kpi-quick-nav-btn[data-section="canales"]:hover {
  background: rgba(245,158,11,0.15);
  border-color: rgba(245,158,11,0.25);
}


.kpi-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
}

/* Scroll offset for sticky nav */
.kpi-section {
  scroll-margin-top: 4rem;
}
.kpi-section-title:hover {
  opacity: 0.8;
}
.kpi-section-title:active {
  opacity: 0.6;
}

/* ── Collapse toggle button ── */
.kpi-collapse-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  margin-left: auto;
  padding: 0;
  font-size: 0.72rem;
}
.kpi-section-title:hover .kpi-collapse-toggle {
  background: rgba(148, 163, 184, 0.1);
  color: #64748b;
}
.dark .kpi-collapse-toggle { color: #52525b; }
.dark .kpi-section-title:hover .kpi-collapse-toggle {
  background: rgba(82, 82, 91, 0.2);
  color: #a1a1aa;
}

/* Chevron rotation */
.kpi-chevron-collapsed {
  transform: rotate(-180deg);
}
.pi-chevron-up {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}


/* Transition: kpi-collapse */
.kpi-collapse-enter-active,
.kpi-collapse-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 5000px;
  opacity: 1;
}
.kpi-collapse-enter,
.kpi-collapse-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-8px);
}

/* ═══════════════════════════════════════
   FAB — SCROLL TO TOP
   ═══════════════════════════════════════ */
.kpi-top-fab {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: white;
  color: #475569;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.04);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.kpi-top-fab:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 16px rgba(0,0,0,0.14);
  color: #1e293b;
}
.kpi-top-fab:active {
  transform: translateY(0) scale(0.95);
}
.dark .kpi-top-fab {
  background: #27272a;
  color: #a1a1aa;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3), 0 0 0 1px rgba(63,63,70,0.6);
}
.dark .kpi-top-fab:hover {
  background: #3f3f46;
  color: #e4e4e7;
}

/* Transition: kpi-top-fab */
.kpi-top-fab-enter-active,
.kpi-top-fab-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.kpi-top-fab-enter,
.kpi-top-fab-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.85);
}

/* ═══════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════ */
@media (max-width: 640px) {
  .kpi-quick-nav {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
    top: 0.25rem;
    margin-bottom: 0.75rem;
    border-radius: 8px;
  }
  .kpi-quick-nav-btn {
    font-size: 0.63rem;
    padding: 0.3rem 0.5rem;
  }
  .kpi-top-fab {
    bottom: 1rem;
    right: 1rem;
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }
}



/* Conectados Modal styles */
.conectados-detalle-modal :deep(.p-dialog-header) {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--surface-border, #e2e8f0);
}
.conectados-detalle-modal :deep(.p-dialog-content) {
  padding: 0 1.5rem 1.5rem;
}
.conectados-breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--surface-border, #e2e8f0);
  margin-bottom: 1rem;
}
.conectados-breadcrumb-item {
  cursor: pointer;
  color: var(--text-color-secondary, #64748b);
  transition: color 0.15s;
  display: flex;
  align-items: center;
}
.conectados-breadcrumb-item:hover { color: var(--primary-color, #3b82f6); }
.conectados-breadcrumb-item.active { color: var(--text-color, #1e293b); font-weight: 600; cursor: default; }
.conectados-breadcrumb-sep { color: var(--text-color-secondary, #94a3b8); font-size: 0.75rem; }
.conectados-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--text-color-secondary, #64748b);
}
.conectados-total-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: var(--surface-ground, #f8fafc);
  border-radius: 8px;
  margin-bottom: 1rem;
}
.dark .conectados-total-bar { background: rgba(255,255,255,0.05); }
.conectados-total-label { font-size: 0.85rem; color: var(--text-color-secondary, #64748b); }
.conectados-total-value { font-size: 1.25rem; font-weight: 700; color: var(--primary-color, #3b82f6); }
.conectados-empty, .conectados-error { display: flex; align-items: center; justify-content: center; padding: 2rem; color: var(--text-color-secondary, #94a3b8); font-size: 0.9rem; }
.conectados-error { color: #ef4444; }
.conectados-branch-list { display: flex; flex-direction: column; gap: 0.35rem; }
.conectados-branch-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.85rem;
  background: var(--surface-card, #fff);
  border: 1px solid var(--surface-border, #e2e8f0);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  gap: 0.75rem;
}
.dark .conectados-branch-item { background: rgba(255,255,255,0.03); border-color: rgba(255,255,255,0.08); }
.conectados-branch-item:hover { border-color: var(--primary-color, #3b82f6); background: rgba(59,130,246,0.04); }
.dark .conectados-branch-item:hover { background: rgba(59,130,246,0.08); }
.conectados-branch-info { flex: 1; min-width: 0; }
.conectados-branch-name { display: block; font-weight: 600; font-size: 0.9rem; color: var(--text-color, #1e293b); }
.conectados-branch-stream { font-size: 0.75rem; color: var(--text-color-secondary, #94a3b8); }
.conectados-branch-counts { text-align: right; min-width: 100px; }
.conectados-branch-count { display: block; font-size: 1.15rem; font-weight: 700; color: var(--primary-color, #3b82f6); }
.conectados-branch-bar { height: 4px; background: var(--primary-color, #3b82f6); border-radius: 2px; opacity: 0.3; margin-top: 3px; margin-left: auto; }
.conectados-branch-arrow { color: var(--text-color-secondary, #94a3b8); font-size: 0.8rem; }
.conectados-device-list { display: flex; flex-direction: column; gap: 0.35rem; }
.conectados-device-item {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.85rem;
  border: 1px solid var(--surface-border, #e2e8f0);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  gap: 0.75rem;
}
.dark .conectados-device-item { border-color: rgba(255,255,255,0.08); }
.conectados-device-item:hover { border-color: var(--primary-color, #3b82f6); background: rgba(59,130,246,0.04); }
.dark .conectados-device-item:hover { background: rgba(59,130,246,0.08); }
.conectados-device-icon {
  width: 32px; height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(59,130,246,0.1);
  color: var(--primary-color, #3b82f6);
  font-size: 0.9rem;
  flex-shrink: 0;
}
.conectados-device-info { flex: 1; min-width: 0; }
.conectados-device-id { display: block; font-size: 0.8rem; font-weight: 600; color: var(--text-color, #1e293b); font-family: monospace; }
.conectados-device-meta { font-size: 0.75rem; color: var(--text-color-secondary, #94a3b8); margin-top: 1px; }
.conectados-device-badges { display: flex; gap: 0.35rem; flex-shrink: 0; }
.conectados-badge-legacy { font-size: 0.65rem; padding: 1px 5px; border-radius: 4px; background: rgba(251,191,36,0.15); color: #d97706; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px; }
.conectados-badge-cat { font-size: 0.65rem; padding: 1px 5px; border-radius: 4px; background: rgba(59,130,246,0.1); color: var(--primary-color, #3b82f6); font-weight: 500; }
.conectados-device-arrow { color: var(--text-color-secondary, #94a3b8); font-size: 0.75rem; flex-shrink: 0; }
.conectados-tag-warn { color: #d97706; font-style: italic; }
.conectados-device-full-id { font-family: monospace; font-size: 0.8rem; }
.conectados-timeline { display: flex; flex-direction: column; gap: 0; padding-left: 0.5rem; }
.conectados-timeline-item { display: flex; gap: 0.75rem; }
.conectados-timeline-line { display: flex; flex-direction: column; align-items: center; width: 16px; flex-shrink: 0; }
.conectados-timeline-dot { width: 12px; height: 12px; border-radius: 50%; border: 2px solid var(--primary-color, #3b82f6); background: var(--surface-card, #fff); flex-shrink: 0; margin-top: 4px; }
.dark .conectados-timeline-dot { background: var(--surface-ground, #1e293b); }
.conectados-timeline-dot.active { background: #22c55e; border-color: #22c55e; box-shadow: 0 0 0 3px rgba(34,197,94,0.2); }
.conectados-timeline-dot.inactive { border-color: var(--text-color-secondary, #94a3b8); }
.conectados-timeline-connector { width: 2px; flex: 1; min-height: 24px; background: var(--surface-border, #e2e8f0); }
.dark .conectados-timeline-connector { background: rgba(255,255,255,0.1); }
.conectados-timeline-content { flex: 1; padding: 0.25rem 0 1rem; min-width: 0; }
.conectados-timeline-header { display: flex; justify-content: space-between; align-items: center; }
.conectados-timeline-time { font-size: 0.85rem; font-weight: 600; color: var(--text-color, #1e293b); }
.conectados-timeline-duration { font-size: 0.75rem; color: var(--primary-color, #3b82f6); font-weight: 600; background: rgba(59,130,246,0.08); padding: 1px 6px; border-radius: 4px; }
.conectados-timeline-meta { font-size: 0.75rem; color: var(--text-color-secondary, #94a3b8); margin-top: 2px; display: flex; flex-wrap: wrap; gap: 0.5rem; }

/* ── Temporada Detalle Modal ── */
.tdm-trigger {
  cursor: pointer;
  transition: background 0.15s ease;
  border-radius: 6px;
}
.tdm-trigger:hover {
  background: rgba(59,130,246,0.06);
}
.dark .tdm-trigger:hover {
  background: rgba(59,130,246,0.1);
}
.temporada-detalle-modal .p-dialog-content {
  padding: 0.75rem 1rem 0.5rem;
}
.tdm-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.tdm-search {
  position: relative;
  flex: 1;
}
.tdm-search-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: var(--text-color-secondary, #94a3b8);
  pointer-events: none;
}
.tdm-search-input {
  width: 100%;
  padding: 6px 8px 6px 28px;
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 6px;
  font-size: 0.8rem;
  background: var(--surface-ground, #fff);
  color: var(--text-color, #1e293b);
  outline: none;
}
.dark .tdm-search-input {
  background: rgba(39,39,42,0.6);
  border-color: rgba(113,113,122,0.4);
  color: #e4e4e7;
}
.tdm-search-input:focus {
  border-color: var(--primary-color, #3b82f6);
}
.tdm-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 6px;
  background: var(--surface-ground, #fff);
  color: var(--text-color-secondary, #64748b);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}
.dark .tdm-export-btn {
  background: rgba(39,39,42,0.6);
  border-color: rgba(113,113,122,0.4);
  color: #a1a1aa;
}
.tdm-export-btn:hover:not(:disabled) {
  border-color: var(--primary-color, #3b82f6);
  color: var(--primary-color, #3b82f6);
}
.tdm-export-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.tdm-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem;
  color: var(--text-color-secondary, #94a3b8);
  font-size: 0.85rem;
}
.tdm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2rem;
  color: var(--text-color-secondary, #94a3b8);
  font-size: 0.85rem;
  text-align: center;
}
.tdm-empty i {
  font-size: 1.5rem;
  opacity: 0.5;
}
.tdm-table-wrap {
  overflow-x: auto;
}
.tdm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}
.tdm-table th {
  text-align: left;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--text-color-secondary, #64748b);
  border-bottom: 1px solid var(--surface-border, #e2e8f0);
}
.dark .tdm-table th {
  color: #a1a1aa;
  border-color: rgba(82,82,91,0.4);
}
.tdm-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--surface-border, #f1f5f9);
  color: var(--text-color, #1e293b);
  vertical-align: middle;
}
.dark .tdm-table td {
  border-color: rgba(82,82,91,0.2);
  color: #e4e4e7;
}
.tdm-table tbody tr:hover {
  background: rgba(59,130,246,0.04);
}
.dark .tdm-table tbody tr:hover {
  background: rgba(59,130,246,0.08);
}
.tdm-col-req {
  width: 1%;
  white-space: nowrap;
}
.tdm-col-expand {
  width: 26px;
  text-align: center;
  padding: 0 4px !important;
}
.tdm-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-color-secondary, #94a3b8);
  cursor: pointer;
  transition: transform 0.2s ease, color 0.15s;
  user-select: none;
  line-height: 1;
}
.tdm-chevron:hover {
  color: var(--primary-color, #3b82f6);
}
.tdm-chevron.expanded {
  transform: rotate(90deg);
  color: var(--primary-color, #3b82f6);
}
.tdm-expanded-row td {
  padding: 0 !important;
  border-bottom: none;
}
.tdm-expanded-content {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 10px 56px;
  font-size: 0.75rem;
  color: var(--text-color-secondary, #64748b);
  animation: tdm-expand-in 0.2s ease;
}
.tdm-expanded-content i {
  font-size: 0.7rem;
  opacity: 0.5;
}
.tdm-sched-clients {
  font-weight: 600;
  color: var(--text-color, #1e293b);
}
.dark .tdm-sched-clients {
  color: #e4e4e7;
}
@keyframes tdm-expand-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}
.tdm-col-status {
  width: 35%;
}
.tdm-col-date {
  width: 1%;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.tdm-req-id {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--primary-color, #3b82f6);
  font-family: monospace;
}
.tdm-id-click {
  cursor: pointer;
  position: relative;
  transition: opacity 0.15s;
}
.tdm-id-click:hover {
  opacity: 0.7;
}
.tdm-copied-feedback {
  position: absolute;
  top: -1px;
  left: calc(100% + 6px);
  font-size: 0.65rem;
  font-weight: 600;
  color: #059669;
  background: rgba(5,150,105,0.1);
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
  animation: tdm-fade-in 0.15s ease;
  pointer-events: none;
}
.dark .tdm-copied-feedback {
  color: #6ee7b7;
  background: rgba(5,150,105,0.15);
}
@keyframes tdm-fade-in {
  from { opacity: 0; transform: translateY(2px); }
  to   { opacity: 1; transform: translateY(0); }
}
.tdm-spot-name {
  font-weight: 600;
}
.tdm-spot-id {
  font-size: 0.7rem;
  color: var(--text-color-secondary, #94a3b8);
  margin-left: 4px;
  font-family: monospace;
}
.tdm-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.tdm-badge--green {
  background: rgba(52,211,153,0.12);
  color: #065f46;
}
.dark .tdm-badge--green {
  background: rgba(52,211,153,0.15);
  color: #6ee7b7;
}
.tdm-badge--amber {
  background: rgba(251,191,36,0.12);
  color: #92400e;
}
.dark .tdm-badge--amber {
  background: rgba(251,191,36,0.15);
  color: #fcd34d;
}
.tdm-badge--neutral {
  background: rgba(99,102,241,0.1);
  color: #4338ca;
}
.dark .tdm-badge--neutral {
  background: rgba(99,102,241,0.18);
  color: #a5b4fc;
}
.tdm-contact-cell {
  display: flex;
  align-items: center;
}
.tdm-contact-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 5px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}
.tdm-contact--completo {
  background: rgba(52,211,153,0.1);
  color: #065f46;
}
.dark .tdm-contact--completo {
  background: rgba(52,211,153,0.15);
  color: #6ee7b7;
}
.tdm-contact--parcial {
  background: rgba(251,191,36,0.1);
  color: #92400e;
}
.dark .tdm-contact--parcial {
  background: rgba(251,191,36,0.15);
  color: #fbbf24;
}
.tdm-contact--vacio {
  background: rgba(239,68,68,0.06);
  color: #991b1b;
}
.dark .tdm-contact--vacio {
  background: rgba(239,68,68,0.1);
  color: #fca5a5;
}

/* ── TOP 50 Detalle ── */
.top-detalle-modal .p-dialog-content {
  padding-top: 0.25rem;
}

.tops-detalle-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.dark .tops-detalle-tabs {
  border-bottom-color: #3f3f46;
}

.tops-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.6rem 1.2rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}

.dark .tops-tab {
  color: #a1a1aa;
}

.tops-tab:hover {
  color: #334155;
}

.dark .tops-tab:hover {
  color: #e4e4e7;
}

.tops-tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.dark .tops-tab.active {
  color: #60a5fa;
  border-bottom-color: #60a5fa;
}

.tops-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 10px;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
}

.tops-tab-badge.added {
  background: #dcfce7;
  color: #166534;
}

.dark .tops-tab-badge.added {
  background: rgba(22, 101, 52, 0.35);
  color: #6ee7b7;
}

.tops-tab-badge.removed {
  background: #fce4ec;
  color: #b71c1c;
}

.dark .tops-tab-badge.removed {
  background: rgba(183, 28, 28, 0.35);
  color: #fca5a5;
}

.tops-tab-badge.tag {
  background: #e0f2fe;
  color: #0369a1;
}

.dark .tops-tab-badge.tag {
  background: rgba(3, 105, 161, 0.35);
  color: #7dd3fc;
}

.tops-tab-badge.warn {
  background: #fef3c7;
  color: #b45309;
}

.dark .tops-tab-badge.warn {
  background: rgba(180, 83, 9, 0.35);
  color: #fcd34d;
}

.tops-detalle-tags {
  max-width: 460px;
}

.tdm-tags-col {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tdm-tag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  min-width: 0;
  max-width: 200px;
}

.tdm-chip {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1.4;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tdm-chip-old {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.dark .tdm-chip-old {
  background: rgba(185,28,28,0.15);
  color: #fca5a5;
  border-color: rgba(185,28,28,0.3);
}

.tdm-chip-new {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.dark .tdm-chip-new {
  background: rgba(22,101,52,0.15);
  color: #6ee7b7;
  border-color: rgba(22,101,52,0.3);
}

.tdm-chip-none {
  color: #94a3b8;
  font-size: 0.75rem;
}

.tdm-tag-arrow {
  flex-shrink: 0;
  color: #64748b;
  font-weight: 700;
  font-size: 0.85rem;
}

.tdm-tipo-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.4;
}

.tdm-tipo-badge.tipo-entrada {
  background: #dcfce7;
  color: #166534;
}

.dark .tdm-tipo-badge.tipo-entrada {
  background: rgba(22, 101, 52, 0.3);
  color: #6ee7b7;
}

.tdm-tipo-badge.tipo-salida {
  background: #fce4ec;
  color: #b71c1c;
}

.dark .tdm-tipo-badge.tipo-salida {
  background: rgba(183, 28, 28, 0.3);
  color: #fca5a5;
}

.tdm-col-date {
  white-space: nowrap;
  width: 90px;
}

.tops-detalle-table th:first-child,
.tops-detalle-table td:first-child {
  padding-left: 0.5rem;
}

.tops-detalle-song {
  font-weight: 600;
  color: #1e293b;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark .tops-detalle-song {
  color: #e4e4e7;
}

.tops-detalle-artist {
  color: #475569;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark .tops-detalle-artist {
  color: #a1a1aa;
}

/* Canal row click */
.kpi-canal-row-click {
  cursor: pointer;
  transition: color 0.15s;
}
.kpi-canal-row-click:hover {
  color: #2563eb !important;
}
.dark .kpi-canal-row-click:hover {
  color: #60a5fa !important;
}

/* Stat clickable */
.kpi-stat-clickable {
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s ease;
}
.kpi-stat-clickable::after {
  content: '›';
  position: absolute;
  right: 8px;
  top: 50%;
  font-size: 1.3em;
  font-weight: 400;
  line-height: 1;
  opacity: 0.55;
  transform: translateY(-50%);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.kpi-stat-clickable:hover::after {
  opacity: 0.85;
  transform: translateY(-50%) translateX(3px);
}
.kpi-stat-clickable:hover {
  background: rgba(59,130,246,0.07);
}
.dark .kpi-stat-clickable:hover {
  background: rgba(59,130,246,0.12);
}

/* Hero clickable — centrado vertical, hover efecto */
.kpi-mus-hero.kpi-stat-clickable::after {
  right: 14px;
  font-size: 1.5em;
}
.kpi-mus-hero.kpi-stat-clickable:hover {
  background: rgba(59,130,246,0.06);
}
.dark .kpi-mus-hero.kpi-stat-clickable:hover {
  background: rgba(59,130,246,0.1);
}
.kpi-mus-hero.kpi-stat-clickable:hover::after {
  transform: translateY(-50%) translateX(3px);
}

/* Playlist name click */
.cdm-pl-name {
  cursor: pointer;
  transition: color 0.15s;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cdm-pl-name:hover {
  color: #2563eb !important;
}
.dark .cdm-pl-name:hover {
  color: #60a5fa !important;
}

/* Playlist group headers (Video / Musica) */
.cdm-pl-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 6px;
  margin-top: 4px;
}
.cdm-pl-group-icon {
  font-size: 0.85rem;
}
.cdm-pl-group-icon--video { color: #7c3aed; }
.dark .cdm-pl-group-icon--video { color: #a78bfa; }
.cdm-pl-group-icon--audio { color: #2563eb; }
.dark .cdm-pl-group-icon--audio { color: #93c5fd; }
.cdm-pl-group-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
}
.dark .cdm-pl-group-title { color: #a1a1aa; }
.cdm-pl-group-count {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 999px;
  background: rgba(100, 116, 139, 0.15);
  color: #64748b;
}
.dark .cdm-pl-group-count {
  background: rgba(148, 163, 184, 0.15);
  color: #94a3b8;
}

/* Playlist detalle loading */
.pdm-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 0;
  color: #94a3b8;
  font-size: 0.9rem;
}

/* Canal / playlists detalle modals */
.canal-detalle-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cdm-summary {
  display: flex;
  align-items: center;
  gap: 0;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 0;
}
.dark .cdm-summary {
  background: #0f172a;
  border-color: #1e293b;
}
.cdm-summary-stat {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cdm-summary-stat-val {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
}
.dark .cdm-summary-stat-val {
  color: #f1f5f9;
}
.cdm-summary-stat-label {
  font-size: 0.7rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.cdm-summary-divider {
  width: 1px;
  height: 32px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.dark .cdm-summary-divider {
  background: #334155;
}
.cdm-search {
  position: relative;
}
.cdm-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  color: #94a3b8;
}
.cdm-search-input {
  width: 100%;
  padding: 7px 10px 7px 30px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.8rem;
  outline: none;
  background: #fff;
  color: #1e293b;
  box-sizing: border-box;
}
.dark .cdm-search-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.cdm-search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59,130,246,0.15);
}
.cdm-filters {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.cdm-filter-group {
  display: flex;
  align-items: center;
  gap: 4px;
}
.cdm-filter-label {
  font-size: 0.75rem;
  color: #94a3b8;
  font-weight: 600;
  margin-right: 4px;
}
.cdm-filter-chip {
  padding: 3px 10px;
  border-radius: 12px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.12s;
}
.dark .cdm-filter-chip {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.cdm-filter-chip:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}
.cdm-filter-chip.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}
.dark .cdm-filter-chip.active {
  background: #3b82f6;
  color: #fff;
}
.cdm-filter-chip-ok.active {
  background: #16a34a;
  border-color: #16a34a;
}
.cdm-filter-chip-warn.active {
  background: #f59e0b;
  border-color: #f59e0b;
}
.cdm-filter-chip-no.active {
  background: #dc2626;
  border-color: #dc2626;
}

/* Estilo del chip "Sin llamada" / "Sin minuta" en el modal de contactos */
.contact-chip.chip-pendiente {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  border: 1px solid rgba(239, 68, 68, 0.3);
  font-weight: 500;
}
.dark .contact-chip.chip-pendiente {
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
  border-color: rgba(239, 68, 68, 0.35);
}

/* Row hover en el modal de contactos para indicar que es expandible */
.contactos-row {
  cursor: pointer;
  transition: background-color 0.12s ease;
}
.contactos-row:hover > td {
  background: rgba(99, 102, 241, 0.04);
}
.dark .contactos-row:hover > td {
  background: rgba(99, 102, 241, 0.08);
}
.cdm-table-wrap {
  overflow-x: auto;
}
.cdm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}
.cdm-table th {
  text-align: left;
  padding: 8px 12px;
  font-weight: 600;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dark .cdm-table th {
  color: #94a3b8;
  border-bottom-color: #334155;
}
.cdm-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #475569;
}
.dark .cdm-table td {
  border-bottom-color: #1e293b;
  color: #cbd5e1;
}
.cdm-col-center {
  text-align: center;
}
.cdm-table tbody tr:hover {
  background: #f8fafc;
}
.dark .cdm-table tbody tr:hover {
  background: #0f172a;
}
.cdm-col-date {
  font-size: 0.75rem;
  color: #94a3b8;
  white-space: nowrap;
}
.cdm-estado-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 600;
}
.cdm-estado-ok {
  background: #dcfce7;
  color: #166534;
}
.dark .cdm-estado-ok {
  background: rgba(22,101,52,0.2);
  color: #6ee7b7;
}
.cdm-estado-no {
  background: #fef2f2;
  color: #b91c1c;
}
.dark .cdm-estado-no {
  background: rgba(185,28,28,0.2);
  color: #fca5a5;
}
.cdm-estado-ghost {
  background: rgba(148,163,184,0.15);
  color: #64748b;
}
.dark .cdm-estado-ghost {
  background: rgba(148,163,184,0.18);
  color: #94a3b8;
}
.cdm-tipo-video {
  background: rgba(139,92,246,0.15);
  color: #7c3aed;
}
.dark .cdm-tipo-video {
  background: rgba(139,92,246,0.25);
  color: #a78bfa;
}
.cdm-tipo-audio {
  background: rgba(59,130,246,0.12);
  color: #2563eb;
}
.dark .cdm-tipo-audio {
  background: rgba(59,130,246,0.2);
  color: #93c5fd;
}
.cdm-cambios-val {
  font-weight: 700;
  font-size: 0.9rem;
}
.cdm-cambios-ok {
  color: #16a34a;
}
.dark .cdm-cambios-ok {
  color: #6ee7b7;
}
.cdm-cambios-pocos {
  color: #94a3b8;
}
.cdm-empty {
  text-align: center;
  color: #94a3b8;
  font-style: italic;
  padding: 24px 12px !important;
}

/* Video canales accordion */
.video-canales-accordion {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.video-canal-card {
  border: 1px solid rgba(148,163,184,0.2);
  border-radius: 8px;
  overflow: hidden;
  background: #fafbfc;
  transition: border-color 0.15s, background 0.15s;
}
.dark .video-canal-card { background: rgba(39,39,42,0.4); border-color: rgba(82,82,91,0.3); }
.video-canal-card--open {
  border-color: rgba(236,72,153,0.25);
  background: #fdf2f8;
}
.dark .video-canal-card--open { border-color: rgba(236,72,153,0.2); background: rgba(76,5,42,0.2); }
.video-canal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
  transition: background 0.1s;
}
.video-canal-header:hover { background: rgba(148,163,184,0.06); }
.dark .video-canal-header:hover { background: rgba(255,255,255,0.03); }
.video-canal-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.video-canal-name {
  font-weight: 700;
  font-size: 0.85rem;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .video-canal-name { color: #d4d4d8; }
.video-canal-count {
  font-size: 0.7rem;
  font-weight: 600;
  color: #be185d;
  background: rgba(236,72,153,0.08);
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}
.video-canal-count--ok {
  color: #065f46;
  background: rgba(16,185,129,0.12);
}
.dark .video-canal-count { color: #f472b6; background: rgba(236,72,153,0.12); }
.dark .video-canal-count--ok { color: #6ee7b7; background: rgba(16,185,129,0.18); }
.video-canal-chevron {
  font-size: 0.75rem;
  color: #94a3b8;
  flex-shrink: 0;
  transition: transform 0.15s;
}
.dark .video-canal-chevron { color: #71717a; }
.video-canal-body {
  padding: 0 14px 10px;
  animation: vcExpand 0.2s ease;
}
@keyframes vcExpand {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}
.video-pl-table {
  border: none;
  margin: 0;
  width: 100%;
  table-layout: fixed;
}
.video-pl-table .cdm-pl-name {
  max-width: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video-pl-table th {
  font-size: 0.65rem;
  padding: 5px 6px;
  background: transparent;
  border-bottom: 1px solid rgba(148,163,184,0.1);
}
.dark .video-pl-table th { border-color: rgba(82,82,91,0.2); }
.video-pl-table td {
  font-size: 0.78rem;
  padding: 5px 6px;
}
.contactos-row { cursor: pointer; transition: background 0.1s; }
.contactos-row:hover { background: rgba(59,130,246,0.03); }
.dark .contactos-row:hover { background: rgba(59,130,246,0.05); }
.contactos-row--expanded { background: rgba(59,130,246,0.04) !important; }
.dark .contactos-row--expanded { background: rgba(59,130,246,0.06) !important; }
.contactos-row--expanded .contactos-canal-cell { border-bottom-color: transparent; }
.contactos-expanded-row { background: rgba(248,250,252,0.7); }
.dark .contactos-expanded-row { background: rgba(39,39,42,0.3); }
.contactos-sub-table { margin: 0; border-top: 1px solid rgba(148,163,184,0.15); }
.contactos-sub-table th { font-size: 0.68rem; padding: 6px 10px; background: transparent; }
.contactos-sub-table td { font-size: 0.78rem; padding: 5px 10px; }
.contactos-table td { vertical-align: middle; }
.contactos-canal-cell { padding-top: 10px; padding-bottom: 10px; }
.contact-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 500;
  white-space: nowrap;
}
.chip-llamada { background: rgba(59,130,246,0.1); color: #2563eb; border: 1px solid rgba(59,130,246,0.25); }
.dark .chip-llamada { background: rgba(59,130,246,0.15); color: #93c5fd; border-color: rgba(59,130,246,0.3); }
.chip-minuta { background: rgba(16,185,129,0.1); color: #059669; border: 1px solid rgba(16,185,129,0.25); }
.dark .chip-minuta { background: rgba(16,185,129,0.15); color: #6ee7b7; border-color: rgba(16,185,129,0.3); }
.chip-icon { font-size: 0.75rem; }
.chip-count { font-size: 0.7rem; opacity: 0.7; margin-left: 2px; }
.kpi-desglose-link { color: #3b82f6; cursor: pointer; font-weight: 500; }
.kpi-desglose-link:hover { text-decoration: underline; color: #2563eb; }

/* ── Duplicados y Errores ── */
.kpi-dup-errores-strip {
  border-top: 1px solid rgba(148,163,184,0.2);
  padding-top: 14px;
}
.dark .kpi-dup-errores-strip { border-top-color: rgba(82,82,91,0.35); }
.kpi-dup-errores-header { display: flex; align-items: center; gap: 6px; margin-bottom: 10px; flex-wrap: wrap; }
.kpi-dup-errores-loading { display: flex; align-items: center; gap: 6px; font-size: 0.75rem; color: #94a3b8; padding: 8px 0; }
.kpi-dup-errores-error { font-size: 0.75rem; color: #dc2626; padding: 8px 12px; background: rgba(239,68,68,0.08); border-radius: 6px; }


.dup-errores-badge {
  display: inline-block; padding: 2px 10px; border-radius: 10px; font-size: 0.72rem; font-weight: 600;
}
.dup-errores-badge--amber { background: #fef3c7; color: #b45309; }
.dark .dup-errores-badge--amber { background: rgba(180, 83, 9, 0.35); color: #fcd34d; }
.dup-errores-badge--red { background: #fef2f2; color: #b91c1c; }
.dark .dup-errores-badge--red { background: rgba(185, 28, 28, 0.2); color: #fca5a5; }
</style>
